(function () {
    'use strict';

    angular
        .module('awizApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            //'ngTouch',
            'infinite-scroll',
            'angular-loading-bar',
            'selectionModel',
            'toaster',
            'ae-datetimepicker',
            'moment-picker',
            'xeditable',
            'amo.multiselect',
            'daterangepicker',
            'angular.filter',
            'ngSanitize',
            'checklist-model',
            'ui.calendar',
            'angularMoment',
            'angularPromiseButtons',
            'nya.bootstrap.select',
            'ngLetterAvatar',
            'angularDurationFormat',
            'angular-timezone-select'
        ])
        .config(function (angularPromiseButtonsProvider, cfpLoadingBarProvider, $uibModalProvider) {
            cfpLoadingBarProvider.latencyThreshold = 500;
            angularPromiseButtonsProvider.extendConfig({
                spinnerTpl: ''
            });
            $uibModalProvider.options.animation = false;
        })
        .run(function (stateHandler, translationHandler, editableOptions, editableThemes) {
            stateHandler.initialize();
            translationHandler.initialize();
            editableThemes.bs3.buttonsClass = 'btn-sm';
            editableOptions.theme = 'bs3';
        })
        .run(function($trace, ENV) {
            if(ENV === "dev"){
                $trace.enable('TRANSITION');
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('mySlotsWidget', function ($rootScope, $http, EntryReservation) {
            return {
                restrict: 'AE',
                scope: {},
                templateUrl: "app/entities/entry-reservation/widget-slots/slots.html",
                link: function (scope) {
                    EntryReservation.mySlots().$promise.then(function (result) {
                        scope.slots = result;
                    });
                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('FastEntry', function ($resource) {
            return $resource('api/fast-entry/:id', {id: '@id'}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'toggleDone': {method: 'POST', url: 'api/fast-entry/:id/toggle-done'},
                'changeOrder': {method: 'POST', url: 'api/fast-entry/:id/change-order'}
            });
        })
        .directive('todoEscape', function () {
            var ESCAPE_KEY = 27;

            return function (scope, elem, attrs) {
                elem.bind('keydown', function (event) {
                    if (event.keyCode === ESCAPE_KEY) {
                        scope.$apply(attrs.todoEscape);
                    }
                });

                scope.$on('$destroy', function () {
                    elem.unbind('keydown');
                });
            };
        })
        .directive('todoFocus', function todoFocus($timeout) {
            return function (scope, elem, attrs) {
                scope.$watch(attrs.todoFocus, function (newVal) {
                    if (newVal) {
                        $timeout(function () {
                            elem[0].focus();
                        }, 0, false);
                    }
                });
            };
        })
        .directive('fastEntriesWidget', function ($rootScope, $state, $interval, $http, FastEntry) {
            return {
                restrict: 'AE',
                replace: true,
                scope: {},
                templateUrl: "app/entities/entry-reservation/widget-fast-entries/entries.html",
                link: function (scope, $element, $attrs) {

                    scope.page = 0;
                    scope.pageSize = 5;
                    scope.selectedDate = moment();

                    scope.reloadData = reloadData;
                    scope.next = function () {
                        scope.selectedDate.add(1, "d");
                        reloadData();
                    };
                    scope.previous = function () {
                        scope.selectedDate.subtract(1, "d");
                        reloadData();
                    };
                    scope.show = function (id) {
                        EntryReservationService.show(id);
                    };
                    scope.edit = function (item) {
                        scope.editedEntry = item;
                        scope.originalEntry = angular.extend({}, item);
                    };
                    scope.saveEdited = function (item, event) {
                        if (event === 'blur' && scope.saveEvent === 'submit') {
                            scope.saveEvent = null;
                            return;
                        }

                        scope.saveEvent = event;

                        if (scope.reverted) {
                            scope.reverted = null;
                            return;
                        }

                        FastEntry.update({id: item.id, content: item.content, date: scope.selectedDate.local().toDate()}).$promise.then(function () {
                            delete scope.originalEntry;
                            delete scope.editedEntry;
                            reloadData();
                        });
                    };
                    scope.toggleDone = function (item) {
                        FastEntry.toggleDone({id: item.id, done: item.done}).$promise.then(reloadData);
                    };
                    scope.moveUp = function (item) {
                        FastEntry.changeOrder({id: item.id, action: 'UP'}).$promise.then(reloadData);
                    };
                    scope.moveDown = function (item) {
                        FastEntry.changeOrder({id: item.id, action: 'DOWN'}).$promise.then(reloadData);
                    };
                    scope.delete = function (item) {
                        FastEntry.delete({id: item.id}).$promise.then(reloadData);
                    };
                    scope.revertEntry = function (item) {
                        scope.items[scope.items.indexOf(item)] = scope.originalEntry;
                        scope.originalEntry = null;
                        scope.editedEntry = null;
                        scope.reverted = true;
                    };

                    scope.addFastEntry = function () {
                        FastEntry.save({content: scope.newEntryContent, date: scope.selectedDate.local().toDate()}).$promise.then(function () {
                            delete scope.newEntryContent;
                            reloadData();
                        });
                    };

                    function reloadData() {
                        FastEntry.query({page: scope.page, size: scope.pageSize, date: scope.selectedDate.local().toDate()}, onSuccess, onError);

                        function onSuccess(response, headers) {
                            scope.items = response;
                            scope.itemsCount = Number(headers('X-Total-Count'));
                        }

                        function onError() {
                            scope.items = [];
                            scope.itemsCount = 0;
                        }
                    }

                    reloadData();

                    scope.$on('entry:updated', function () {
                        reloadData();
                    });

                    scope.changeFilter = function (filter) {
                        scope.selectedFilter = filter;
                        if (filter === 'all') {
                            scope.doneFilter = {}
                        } else if (filter === 'done') {
                            scope.doneFilter = {done: true}
                        } else if (filter === 'undone') {
                            scope.doneFilter = {done: false}
                        } else {
                            scope.doneFilter = {done: false}
                        }
                    };
                    scope.changeFilter('undone');

                    var intervalPromise;
                    function initAutoRefresh() {
                        $interval.cancel(intervalPromise);
                        reloadData();
                        intervalPromise = $interval(initAutoRefresh, 30000);
                    }

                    initAutoRefresh();
                    scope.$on('$destroy', function () {
                        $interval.cancel(intervalPromise);
                    });
                }
            };
        })
    ;

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('commentsWidget', function ($rootScope, $interval, EntryReservation, EntryReservationService) {
                return {
                    restrict: 'AE',
                    replace: true,
                    scope: {},
                    templateUrl: "app/entities/entry-reservation/widget-comments/comments.html",
                    link: function (scope) {
                        scope.page = 0;
                        scope.pageSize = 5;

                        scope.reloadData = reloadData;
                        scope.nextPage = function () {
                            scope.page += 1;
                            reloadData();
                        };
                        scope.previousPage = function () {
                            if (scope.page !== 0) {
                                scope.page -= 1;
                            }
                            reloadData();
                        };
                        scope.show = function (id) {
                            EntryReservationService.show(id);
                        };
                        scope.isLastPage = function () {
                            return (scope.page + 1) * scope.pageSize >= scope.itemsCount;
                        };

                        reloadData();
                        function reloadData() {
                            EntryReservation.lastComments({page: scope.page, size: scope.pageSize}, onSuccess, onError);

                            function onSuccess(response, headers) {
                                scope.items = response;
                                scope.itemsCount = Number(headers('X-Total-Count'));
                            }

                            function onError() {
                                scope.items = [];
                                scope.itemsCount = 0;
                            }
                        }

                        scope.$on('entry:updated', function () {
                            reloadData();
                        });

                        var intervalPromise;
                        function initAutoRefresh() {
                            $interval.cancel(intervalPromise);
                            reloadData();
                            intervalPromise = $interval(initAutoRefresh, 30000);
                        }

                        initAutoRefresh();
                        scope.$on('$destroy', function () {
                            $interval.cancel(intervalPromise);
                        });
                    }
                };
            });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationTvController', function($scope, $state, Principal, EntryReservation) {
            var vm = this;
            vm.$state = $state;
            vm.isAuthenticated = null;

            var bodyElement = angular.element(document.querySelector('body'));
            bodyElement.addClass('tv-mode');

            $scope.$on('$destroy', function () {
                bodyElement.removeClass('tv-mode');
            });

            $scope.$watch(function () {
                return Principal.isAuthenticated();
            }, function () {
                vm.isAuthenticated = Principal.isAuthenticated;
                loadData();
            });

            vm.hasSlots = Principal.hasSlots;

            function loadData() {
                EntryReservation.mySlots().$promise.then(function (result) {
                    vm.slots = result;
                    vm.colsPerSlot = vm.slots.length > 0 ? 12 / vm.slots.length : 12;
                });
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('tv', {
                url: '/tv',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    content: {
                        templateUrl: 'app/entities/entry-reservation/tv-mode/tv-mode.html',
                        controller: 'EntryReservationTvController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    authorize: function (Auth) {
                        return Auth.authorize();
                    },
                    translatePartialLoader: function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settings');
                        $translatePartialLoader.addPart('slot-management');
                        $translatePartialLoader.addPart('user-management');
                        $translate.refresh();
                    }
                }
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationStatusChangeController', function ($timeout, $rootScope, $scope, $uibModalInstance, EntryReservation, params) {
            var vm = this;

            vm.item = {
                id: params.entryId
            };

            vm.options = params;

            vm.setNewStatus = function (status) {
                vm.item.status = status;
            };

            vm.operationStatus = {
                CONFIRM: {
                    statuses: [ 'CONFIRMED' ]
                },
                UNCONFIRM: {
                    statuses: [ 'UNCONFIRMED' ]
                },
                FINISH: {
                    statuses: [ 'PROCESSED', 'PROCESSED_DELAYED', 'UNPROCESSED_DID_NOT_ARRIVE' ]
                },
                CANCEL: {
                    statuses: [ 'CANCELLED' ]
                }
            };

            vm.getStatuses = function () {
                var statuses = vm.operationStatus[params.operation].statuses;
                if(statuses.length === 1){
                    vm.setNewStatus(statuses[0]);
                }
                return statuses;
            };

            vm.isCommentRequired = function () {
                return vm.options.commentRequired || vm.item.status === 'UNPROCESSED_DID_NOT_ARRIVE';
            };


            EntryReservation.get({id: params.entryId}).$promise.then(function (data) {
                vm.entry = data;

            });
            vm.onTimeChangeCheckbox = function(){
                if(vm.item.timeChange){
                    vm.item.startTime = vm.entry.startTime;
                }
                else {
                    delete vm.item.timeChange;
                    delete vm.item.startTime;
                }
            };

            vm.calculateEndTime = function () {
                if (!vm.entry.parcelType || !vm.entry.parcelQuantity) {
                    delete vm.calculatedEndTime;
                    return;
                }

                var processingTime = vm.entry.parcelType.processingTimeInMin * vm.entry.parcelQuantity;
                vm.calculatedEndTime = moment(vm.item.startTime).add(processingTime, 'm');
            };

            vm.canChangeTime = function(){
                return vm.entry && vm.entry.status === 'UNCONFIRMED' && vm.item && vm.item.status === 'CONFIRMED';
            };

            vm.save = function () {
                return EntryReservation.changeStatus(vm.item).$promise.then(function () {
                    $rootScope.$broadcast('entry:updated');
                    $uibModalInstance.close();
                });
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('mySlot', function ($rootScope, $translate, $compile, $state, $interval, $http, EntryReservation, uiCalendarConfig, EntryReservationService, Principal, EntryReservationUtils, $cookies) {
            return {
                restrict: 'AE',
                require: '?slot',
                scope: {
                    slot: '=',
                    stickToCurrentDay: '=',
                    requestParams: '=',
                    defaultView: '@'
                },
                replace: true,
                templateUrl: "app/entities/entry-reservation/slot/slot.html",
                link: function (scope) {
                    Principal.isCompanyWorker(scope.slot.customer.id)
                        .then(function (result) {
                            scope.isSlotOwner = result;
                            scope.calendarOptions.calendar.selectOverlap = result;
                        });

                    var slotTimezone = scope.slot.timezone;
                    var clientTimezone = moment.tz.guess();
                    scope.isDifferentTimezone = function () {
                        return scope.slot.timezone !== clientTimezone;
                    };

                    scope.calendarId = 'slotCalendar-' + scope.slot.id;

                    scope.viewToSet = scope.defaultView || $cookies.get('view.' + scope.calendarId) || 'agendaDay';

                    scope.calendarOptions = {
                        calendar: {
                            allDaySlot: false,
                            allDayText: '',
                            header: {
                                left: 'agendaDay,listDay',
                                center: 'title',
                                right: 'today,prev,next'
                            },
                            views: {
                                listDay: {
                                    startParam: 'startDate',
                                    endParam: 'endDate'
                                }
                            },
                            defaultView: scope.viewToSet,
                            height: 'auto',
                            locale: $translate.use(),
                            timezone: slotTimezone,
                            timeFormat: 'H:mm',
                            nowIndicator: true,
                            now: now,
                            slotDuration: '00:15:00',
                            slotLabelInterval: '00:30:00',
                            slotLabelFormat: "H:mm",
                            selectable: true,
                            eventSources: [
                                {
                                    events: fetchEntries
                                },
                                {
                                    events: fetchReservedTime
                                },
                                {
                                    events: fetchDaysOff
                                }
                            ],
                            eventClick: eventClick,
                            selectAllow: selectAllow,
                            selectOverlap: false,
                            select: select,
                            editable: false,
                            eventDurationEditable: false,
                            eventRender: EntryReservationUtils.calendarEventRender,
                            viewRender: function (view) {
                                if (!scope.defaultView){
                                    $cookies.put('view.' + scope.calendarId, view.name);
                                }
                            }
                        }
                    };

                    function now() {
                        return moment().tz(slotTimezone);
                    }

                    function fetchEntries(start, end, timezone, callback) {
                        var params = scope.requestParams || {};
                        var startZoned = moment.tz(start.format(), timezone);
                        var endZoned = moment.tz(end.format(), timezone);
                        EntryReservationUtils.fetchSlotEntries(scope.slot.id, startZoned, endZoned, timezone, params, callback);
                    }

                    function fetchReservedTime(start, end, timezone, callback) {
                        var startZoned = moment.tz(start.format(), timezone);
                        var endZoned = moment.tz(end.format(), timezone);
                        EntryReservationUtils.fetchSlotReservedTime(scope.slot.id, startZoned, endZoned, timezone, callback);
                    }

                    function fetchDaysOff(start, end, timezone, callback) {
                        EntryReservationUtils.fetchDayOffs(start, end, scope.slot.id, false, function (events) {
                            callback(events);
                            scope.$evalAsync(function () {
                                setAllDaySlotVisible(events.length > 0);
                            });
                        });
                    }

                    function setAllDaySlotVisible(visible) {
                        var calendarObject = uiCalendarConfig.calendars[scope.calendarId];
                        if (calendarObject && calendarObject.fullCalendar('option', 'allDaySlot') !== visible) {
                            calendarObject.fullCalendar('option', 'allDaySlot', visible);
                        }
                    }

                    function selectAllow(selectInfo) {
                        return EntryReservationUtils.calendarSelectAllow(selectInfo, scope.isSlotOwner);
                    }

                    function select(startTime, end) {
                        var startTimeZoned = moment.tz(startTime.format(), slotTimezone);
                        EntryReservationService.add({slotId: scope.slot.id, startTime: startTimeZoned});
                    }

                    function eventClick(event) {
                        if (event.id){
                            EntryReservationService.show(event.id);
                        }
                    }

                    function refetchCalendarEvents() {
                        var calendarObject = uiCalendarConfig.calendars[scope.calendarId];
                        if (calendarObject) {
                            calendarObject.fullCalendar('refetchEvents');

                            if (scope.stickToCurrentDay === true){
                                calendarObject.fullCalendar('gotoDate', moment());
                            }
                        }
                    }

                    scope.$on('entry:updated', function () {
                        refetchCalendarEvents();
                    });

                    var intervalPromise;

                    function initAutoRefresh() {
                        $interval.cancel(intervalPromise);
                        refetchCalendarEvents();
                        intervalPromise = $interval(initAutoRefresh, 30000);
                    }

                    initAutoRefresh();
                    scope.$on('$destroy', function () {
                        $interval.cancel(intervalPromise);
                    });

                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('entryOptionButton', function ($rootScope, $state, $http, EntryReservation, EntryReservationService) {
            return {
                restrict: 'AE',
                require: '?entry',
                scope: {
                    entry: '='
                },
                replace: true,
                templateUrl: "app/entities/entry-reservation/option-button/option-button.html",
                link: function (scope) {

                    scope.confirm = function () {
                        EntryReservationService.statusChange(scope.entry.id, 'CONFIRM');
                    };

                    scope.backToUnconfirmed = function () {
                        EntryReservationService.statusChange(scope.entry.id, 'UNCONFIRM', true);
                    };

                    scope.finish = function () {
                        EntryReservationService.statusChange(scope.entry.id, 'FINISH');
                    };

                    scope.backToConfirmed = function () {
                        EntryReservationService.statusChange(scope.entry.id, 'CONFIRM', true);
                    };

                    scope.cancel = function () {
                        EntryReservationService.statusChange(scope.entry.id, 'CANCEL', true);
                    };

                    scope.edit = function () {
                        EntryReservationService.edit(scope.entry.id);
                    };

                    scope.timeChange = function () {
                        EntryReservationService.timeChange(scope.entry.id);
                    };
                    scope.carrierChange = function () {
                        EntryReservationService.carrierChange(scope.entry.id);
                    };

                    scope.toggleWorkStandBy = function (workStandBy) {
                        EntryReservationService.toggleWorkStandBy(scope.entry.id, workStandBy);
                    };

                    scope.isUnconfirmed = function () {
                        return scope.entry && scope.entry.status === 'UNCONFIRMED';
                    };

                    scope.isConfirmed = function () {
                        return scope.entry && scope.entry.status === 'CONFIRMED';
                    };

                    scope.isFinished = function () {
                        var finishedStatuses = ['PROCESSED', 'PROCESSED_DELAYED', 'UNPROCESSED_DID_NOT_ARRIVE', 'CANCELLED'];
                        return scope.entry && finishedStatuses.includes(scope.entry.status);
                    };

                    scope.isReadyForWork = function () {
                        return scope.entry && scope.entry.workStandBy;
                    };

                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationCalendarController', function ($scope, $translate, $interval, EntryReservation, uiCalendarConfig, EntryReservationService, EntryReservationUtils, Principal) {
            var vm = this;
            vm.tableFilters = {};
            vm.hasSlots = Principal.hasSlots;
            vm.timezone = moment.tz.guess();

            EntryReservation.statuses().$promise.then(function (data) {
                vm.reservationStatuses = data;
            });

            vm.calendarId = 'reservationsCalendar';
            vm.calendarOptions = {
                calendar: {
                    allDaySlot: false,
                    allDayText: '',
                    header: {
                        left: 'agendaWeek,month',
                        center: 'title',
                        right: 'today,prev,next'
                    },
                    defaultView: 'month',
                    height: 'auto',
                    aspectRatio: 2.2,
                    locale: $translate.use(),
                    timezone: vm.timezone,
                    timeFormat: 'H:mm',
                    nowIndicator: true,
                    now: now,
                    slotDuration: '00:30:00',
                    slotLabelInterval: '00:60:00',
                    slotLabelFormat: "H:mm",
                    selectable: false,
                    eventSources: [
                        {
                            events: fetchEntries
                        },
                        {
                            events: fetchDaysOff
                        }
                    ],
                    eventClick: eventClick,
                    selectOverlap: false,
                    editable: false,
                    eventDurationEditable: false,
                    eventRender: EntryReservationUtils.calendarEventRender
                }
            };

            function now() {
                return moment().tz(vm.timezone);
            }

            function fetchEntries(start, end, timezone, callback) {
                EntryReservationUtils.downloadTransformEntries(vm.tableFilters, start, end, timezone, callback);
            }

            function fetchDaysOff(start, end, timezone, callback) {
                EntryReservationUtils.fetchDayOffs(start, end, vm.tableFilters.slot, true, function (events) {
                    callback(events);
                    $scope.$evalAsync(function () {
                        setAllDaySlotVisible(events.length > 0);
                    });
                });
            }

            function setAllDaySlotVisible(visible) {
                var calendarObject = uiCalendarConfig.calendars[vm.calendarId];
                if (calendarObject && calendarObject.fullCalendar('option', 'allDaySlot') !== visible) {
                    calendarObject.fullCalendar('option', 'allDaySlot', visible);
                }
            }

            function eventClick(event) {
                if (event.id){
                    EntryReservationService.show(event.id);
                }
            }

            function refetchCalendarEvents() {
                var calendarObject = uiCalendarConfig.calendars[vm.calendarId];
                if (calendarObject) {
                    calendarObject.fullCalendar('refetchEvents');
                }
            }

            $scope.$on('entry:updated', function () {
                refetchCalendarEvents();
            });

            var intervalPromise;
            function initAutoRefresh() {
                $interval.cancel(intervalPromise);
                refetchCalendarEvents();
                intervalPromise = $interval(initAutoRefresh, 30000);
            }

            initAutoRefresh();
            $scope.$on('$destroy', function () {
                $interval.cancel(intervalPromise);
            });

            vm.search = function(){
                refetchCalendarEvents();
            };
        });

})();
;
(function () {
    "use strict";

    angular.module('awizApp')
        .directive('entryComments', function ($rootScope, EntryReservation) {
            return {
                restrict: 'E',
                scope: {
                    entryId: '='
                },
                templateUrl: 'app/entities/entry-reservation/entry-comments/entry-comments.html',
                link: function (scope) {

                    loadComments(scope.entryId);
                    resetNewComment();

                    scope.postComment = function () {
                        return EntryReservation.postComment({id: scope.entryId}, scope.newComment).$promise.then(function () {
                            $rootScope.$broadcast('entry:updated');
                            resetNewComment();
                        });
                    };

                    scope.$on('entry:updated', function () {
                        loadComments(scope.entryId);
                    });

                    function resetNewComment() {
                        scope.newComment = {
                            text: ''
                        };
                    }
                    function loadComments(id) {
                        EntryReservation.comments({id: id}).$promise.then(function (comments) {
                            scope.comments = comments;
                        });
                    }
                }
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectShipper', function (Forwarder) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '='
                },
                templateUrl: 'app/entities/forwarder/select-shipper/select-shipper.html',
                link: function(scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Forwarder.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.shippers = items;
                        })
                        .catch(function (reason) {
                            scope.shippers = [];
                        });

                    scope.setValue = function(value){
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectCustomer', function (Customer) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '='
                },
                templateUrl: 'app/admin/customer-management/select-customer/select-customer.html',
                link: function(scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Customer.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.list = items;
                        })
                        .catch(function (reason) {
                            scope.list = [];
                        });

                    scope.setValue = function(value){
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('requestReset', {
                parent: 'account',
                url: '/reset/request',
                data: {
                    authorities: [],
                    pageTitle: 'reset.request.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/request/reset.request.html',
                        controller: 'RequestResetController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('RequestResetController', function (Auth) {
            var vm = this;

            vm.error = null;
            vm.errorEmailNotExists = null;
            vm.resetAccount = {};
            vm.success = null;

            vm.requestReset = function () {
                vm.error = null;
                vm.errorEmailNotExists = null;

                Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('finishReset', {
                parent: 'account',
                url: '/reset/finish?key&lang',
                data: {
                    authorities: [],
                    pageTitle: 'reset.finish.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/finish/reset.finish.html',
                        controller: 'ResetFinishController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('ResetFinishController', function ($stateParams, Auth, $translate) {
            var vm = this;
            Auth.logout();

            if(angular.isDefined($stateParams.lang)){
                $translate.use($stateParams.lang);
            }

            vm.keyMissing = angular.isUndefined($stateParams.key);
            vm.confirmPassword = null;
            vm.doNotMatch = null;
            vm.error = null;
            vm.finishReset = finishReset;
            vm.resetAccount = {};
            vm.success = null;

            function finishReset() {
                vm.doNotMatch = null;
                vm.error = null;
                vm.success = null;
                if (vm.resetAccount.password !== vm.confirmPassword) {
                    vm.doNotMatch = 'ERROR';
                } else {
                    Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                        vm.success = 'OK';
                    }).catch(function () {
                        vm.success = null;
                        vm.error = 'ERROR';
                    });
                }
            }
        });


})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('SidebarController', function ($state, ENV) {
            var vm = this;
            vm.isNavbarCollapsed = true;
            vm.inProduction = ENV === 'prod';
            vm.$state = $state;

            vm.toggleNavbar = function () {
                vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
            };
            vm.collapseNavbar = function () {
                vm.isNavbarCollapsed = true;
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('activeLink', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var clazz = attrs.activeLink;
                    var path = attrs.href;
                    path = path.substring(1); //hack because path does bot return including hashbang
                    scope.location = location;
                    scope.$watch('location.path()', function(newPath) {
                        if (path === newPath) {
                            element.addClass(clazz);
                        } else {
                            element.removeClass(clazz);
                        }
                    });
                }
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('NavbarController', function ($state, Auth, Principal, ENV, AlertService) {
            var vm = this;

            vm.isNavbarCollapsed = true;
            vm.isAuthenticated = Principal.isAuthenticated;
            vm.hasSlots = Principal.hasSlots;
            vm.inProduction = ENV === 'prod';
            vm.toggleNavbar = toggleNavbar;
            vm.collapseNavbar = collapseNavbar;
            vm.$state = $state;

            vm.logout = function () {
                collapseNavbar();
                Auth.logout();
                $state.go('login');
            };
            vm.exitUser = function () {
                collapseNavbar();
                Auth.exitUser().then(function (result) {
                    AlertService.success("user.events.privileges-restored");
                    $state.go('home');
                });
            };

            function toggleNavbar () {
                vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
            }

            function collapseNavbar () {
                vm.isNavbarCollapsed = true;
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider
                .state('error', {
                    parent: 'app',
                    url: '/error',
                    data: {
                        authorities: [],
                        pageTitle: 'error.title'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/layouts/error/error.html'
                        }
                    }
                })
                .state('accessdenied', {
                    parent: 'app',
                    url: '/accessdenied',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/layouts/error/accessdenied.html'
                        }
                    }
                });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .service('UserService', function ($translate, $uibModal, ConfirmDialogService, CompanyUser) {
            this.add = function () {
                return $uibModal.open({
                    templateUrl: 'app/user/user-dialog.html',
                    controller: 'UserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        user: function () {
                            return {
                                id: null,
                                activated: true,
                                roles : [ 'ROLE_USER' ],
                                sendEmailConfirmation: true,
                                language: $translate.use()
                            };
                        }
                    }
                }).result;
            };
            this.edit = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/user/user-dialog.html',
                    controller: 'UserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        user: function () {
                            return CompanyUser.get({id : id}).$promise.then(function (data) {
                                return {
                                    id: data.id,
                                    roles: data.roles,
                                    email: data.email,
                                    firstName: data.firstName,
                                    lastName: data.lastName,
                                    activated: data.activated,
                                    language: data.language
                                };
                            });
                        }
                    }
                }).result;
            };
            this.delete = function (id, item) {
                return ConfirmDialogService.open({
                    messageTranslated: {
                        key: "entity.delete.question",
                        params: {param: item.email}
                    },
                    confirmPromise: function () {
                        return CompanyUser.delete({id: id}).$promise;
                    }
                });
            };
        })
        .factory('User', function ($resource) {
            return $resource('api/admin/users/:login:id', {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                'save': {method: 'POST'},
                'update': {method: 'PUT'},
                'delete': {method: 'DELETE'}
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('Authority', function ($resource) {
            return $resource('api/authorities', {}, {
                'query': {method: 'GET', isArray: true}
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Sessions', function ($resource) {
            return $resource('api/account/sessions/:series', {}, {
                'getAll': { method: 'GET', isArray: true}
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('Register', function ($resource) {
            return $resource('api/register', {}, {});
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Principal', Principal);

    function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            hasSlots: hasSlots,
            isCompanyWorker: isCompanyWorker
        };
        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasSlots () {
            if (!_authenticated || !_identity || !_identity.slots) {
                return false;
            }
            return _identity.slots > 0;
        }

        function isCompanyWorker (companyId) {
            if (!_authenticated || !_identity || !_identity.customer) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.customer.id === companyId;
            }, function(){
                return false;
            });

        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }
            if(!authorities || authorities.length === 0){
                return true;
            }
            return false;
        }

        function hasAuthority (authority) {

            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }
            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('principalEmail', function (Principal) {
            return {
                restrict: 'AE',
                template: "<span class='bold'>{{currentAccount.email}}</span>",
                link: function (scope) {

                    scope.$watch(function () {
                        return Principal.isAuthenticated();
                    }, function () {

                        Principal.identity().then(function (account) {
                            if (account)
                                scope.currentAccount = angular.copy(account);
                            else {
                                scope.currentAccount = {
                                    email: "..."
                                };
                            }
                        });
                    });

                }
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Password', function ($resource) {
            return $resource('api/account/change_password', {}, {});
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('PasswordResetInit', function ($resource) {
            return $resource('api/account/reset_password/init', {}, {});
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('PasswordResetFinish', function ($resource) {
            return $resource('api/account/reset_password/finish', {}, {});
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('hasAuthority', function (Principal) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var authority = attrs.hasAuthority.replace(/\s+/g, '');

                    var setVisible = function () {
                            element.removeClass('hidden');
                        },
                        setHidden = function () {
                            element.addClass('hidden');
                        },
                        defineVisibility = function (reset) {

                            if (reset) {
                                setVisible();
                            }

                            Principal.hasAuthority(authority)
                                .then(function (result) {
                                    if (result) {
                                        setVisible();
                                    } else {
                                        setHidden();
                                    }
                                });
                        };

                    if (authority.length > 0) {
                        defineVisibility(true);

                        scope.$watch(function () {
                            return Principal.isAuthenticated();
                        }, function () {
                            defineVisibility(true);
                        });
                    }
                }
            };
        });


})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('hasAnyAuthority', function (Principal) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

                    var setVisible = function () {
                            element.removeClass('hidden');
                        },
                        setHidden = function () {
                            element.addClass('hidden');
                        },
                        defineVisibility = function (reset) {
                            var result;
                            if (reset) {
                                setVisible();
                            }

                            result = Principal.hasAnyAuthority(authorities);
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        };

                    if (authorities.length > 0) {
                        defineVisibility(true);

                        scope.$watch(function() {
                            return Principal.isAuthenticated();
                        }, function() {
                            defineVisibility(true);
                        });
                    }
                }
            };
        });


})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('AuthServerProvider', AuthServerProvider);

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Auth', Auth);

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, $http) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            login: login,
            logout: logout,
            loginAs: loginAs,
            exitUser: exitUser,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            return Principal.identity(force).then(authThen);

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout(true);
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function loginAs(username){
            var deferred = $q.defer();
            var data = 'username=' + encodeURIComponent(username);
            $http.post('/api/switch_user', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function() {
                Principal.authenticate(null);
                Principal.identity(true).then(function(account) {
                    deferred.resolve(account);
                });
            });
            return deferred.promise;
        }

        function exitUser(){
            var deferred = $q.defer();
            $http.post('/api/exit_user', {}, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                Principal.authenticate(null);
                Principal.identity(true).then(function(account) {
                    deferred.resolve(account);
                });
            });
            return deferred.promise;
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Activate', function ($resource) {
            return $resource('api/activate', {}, {
                'get': {method: 'GET', params: {}, isArray: false}
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('Account', function ($resource) {
            return $resource('api/account', {}, {
                'get': { method: 'GET', params: {}, isArray: false }
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider
                .state('warehouse', {
                    parent: 'entity',
                    url: '/warehouse?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': 'warehouses'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'name,asc',
                            squash: true
                        },
                        search: {
                            value: null
                        }
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (Warehouse, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            Warehouse.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                })
                .state('warehouseCreate', {
                    parent: 'warehouse',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: function ($transition$, ModalUtil, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/warehouse/dialog.html',
                            controller: 'WarehouseDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                item: function () {
                                    return {
                                        id: null,
                                        active: true,
                                        timezone: moment.tz.guess()
                                    };
                                }
                            }
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params("from"));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params("from"));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('warehouse.edit', {
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    params: {
                        id: {
                            value: null
                        }
                    },
                    onEnter: function ($stateParams, ModalUtil, $uibModal, Warehouse, $transition$) {
                        $uibModal.open({
                            templateUrl: 'app/entities/warehouse/dialog.html',
                            controller: 'WarehouseDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                item: function () {
                                    return Warehouse.get({id: $stateParams.id}).$promise;
                                }
                            }
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params("from"));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params("from"));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                });
        })
        .component('warehouses', {
            bindings: {
                filters: '=',
                page: '='
            },
            templateUrl: 'app/entities/warehouse/warehouses.html',
            controller: function ($state, $transitions, WarehouseService) {
                this.delete = function (item) {
                    return WarehouseService.deleteWarehouse(item).then(function () {
                        $state.reload();
                    });
                };
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
            }
        })
    ;
}());
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('Warehouse', function ($resource) {
            return $resource('api/warehouse/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'autocomplete': {method: 'GET', url: 'api/warehouse-autocomplete', isArray: true}
            });
        })
        .factory('WarehouseService', function (Warehouse, ConfirmDialogService) {
            return {
                deleteWarehouse: deleteWarehouse
            };

            function deleteWarehouse(item) {
                return ConfirmDialogService.open({
                    messageTranslated: {
                        key: "warehouse.labels.delete",
                        params: {param: item.name}
                    },
                    confirmPromise: function () {
                        return Warehouse.delete({id: item.id}).$promise;
                    }
                });
            }
        })
    ;

}());
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectWarehouse', function (Warehouse) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '=',
                    onSelect: '&'
                },
                templateUrl: 'app/entities/warehouse/select-warehouse.html',
                link: function (scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Warehouse.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.items = items;
                        })
                        .catch(function (reason) {
                            scope.items = [];
                        });

                    scope.setValue = function (value) {
                        // if (typeof scope.onSelect === 'function') {
                        //     scope.onSelect(value);
                        // }
                        // console.log(c);
                        scope.onSelect({$id: value.id, $model: value});
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('WarehouseDialogController', function ($timeout, $scope, $uibModalInstance, Warehouse, item) {
            var vm = this;
            vm.item = item;

            vm.save = function () {
                var tmp = angular.copy(vm.item);

                function onSaveSuccess(result) {
                    $scope.$emit('slot:updated', result);
                    $uibModalInstance.close(result);
                }

                if (null === tmp.id) {
                    return Warehouse.save(tmp, onSaveSuccess);
                } else {
                    return Warehouse.update(tmp, onSaveSuccess);
                }
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });

}());
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('slots', {
            bindings: {
                filters: '=',
                page: '='
            },
            templateUrl: 'app/entities/slot/slots.html',
            controller: function ($state, Slot, ConfirmDialogService) {
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                this.delete = function (item) {
                    return ConfirmDialogService
                        .open({
                            messageTranslated: {
                                key: "slot.label.delete",
                                params: {param: item.name}
                            },
                            confirmPromise: function () {
                                return Slot.delete({id: item.id}).$promise;
                            }
                        })
                        .then(function () {
                            $state.reload();
                        });
                };
            }
        })
        .component('slotSchedules', {
            bindings: {
                filters: '=',
                page: '=',
                slot: '<'
            },
            templateUrl: 'app/entities/slot/schedules.html',
            controller: function ($state, SlotSchedule, ConfirmDialogService) {
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                this.delete = function (item) {
                    return ConfirmDialogService
                        .open({
                            messageTranslated: {
                                key: "entity.delete.question",
                                params: {param: item.startTime}
                            },
                            confirmPromise: function () {
                                return SlotSchedule.delete({id: item.id}).$promise;
                            }
                        })
                        .then(function () {
                            $state.reload();
                        });
                };
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('slot', {
                    parent: 'entity',
                    url: '/slot?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': 'slots'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'name,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (Slot, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            Slot.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                })
                .state('slot.create', {
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: function (ModalUtil, $uibModal, $transition$) {
                        $uibModal.open({
                            templateUrl: 'app/entities/slot/dialog.html',
                            controller: 'SlotDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                item: function () {
                                    return {
                                        id: null,
                                        active: true,
                                        timezone: moment.tz.guess()
                                    };
                                }
                            }
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('slot.edit', {
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    params: {
                        id: null
                    },
                    onEnter: function ($stateParams, ModalUtil, $transition$, $uibModal, Slot) {
                        $uibModal.open({
                            templateUrl: 'app/entities/slot/dialog.html',
                            controller: 'SlotDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                item: function () {
                                    return Slot.get({id: $stateParams.id}).$promise;
                                }
                            }
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('slotSchedule', {
                    parent: 'entity',
                    url: '/slot/{slotId}/schedule?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    views: {
                        'content@': 'slotSchedules'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'info.startTime,desc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (SlotSchedule, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            queryParams.id = $stateParams.slotId;
                            SlotSchedule.schedule(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        },
                        slot: function (Slot, $stateParams) {
                            return Slot.get({id: $stateParams.slotId}).$promise;
                        }
                    }
                })
                .state('slotSchedule.create', {
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    params: {
                        slotId: null
                    },
                    onEnter: function ($stateParams, $transition$, ModalUtil, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/slot/schedule-dialog.html',
                            controller: 'SlotScheduleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                item: function () {
                                    return {
                                        id: null,
                                        slotId: $stateParams.slotId,
                                        periods: [
                                            {}
                                        ]
                                    };
                                }
                            }
                        }).result.then(function () {
                            ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                        }).catch(function () {
                            ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                        });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('slotSchedule.duplicate', {
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    params: {
                        duplicatedId: null
                    },
                    onEnter: function ($stateParams, $transition$, ModalUtil, $uibModal, SlotSchedule) {
                        $uibModal.open({
                            templateUrl: 'app/entities/slot/schedule-dialog.html',
                            controller: 'SlotScheduleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                item: function () {
                                    return SlotSchedule.get({id: $stateParams.duplicatedId}).$promise.then(function (result) {
                                        return {
                                            id: null,
                                            slotId: result.slotId,
                                            notes: result.notes,
                                            periods: result.periods
                                        };
                                    });
                                }
                            }
                        }).result.then(function () {
                            ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                        }).catch(function () {
                            ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                        });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('slotSchedule.edit', {
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    params: {
                        scheduleId: null
                    },
                    onEnter: function ($stateParams, $transition$, ModalUtil, $uibModal, SlotSchedule) {
                        $uibModal.open({
                            templateUrl: 'app/entities/slot/schedule-dialog.html',
                            controller: 'SlotScheduleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                item: function () {
                                    return SlotSchedule.get({id: $stateParams.scheduleId}).$promise;
                                }
                            }
                        }).result.then(function () {
                            ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                        }).catch(function () {
                            ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                        });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
            ;
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('Slot', function ($resource) {
            return $resource('api/slot/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'autocomplete': {method: 'GET', url: 'api/slot-autocomplete', isArray: true}
            });
        })
        .factory('SlotSchedule', function ($resource) {
            return $resource('api/slot-schedule/:id', {}, {
                'update': {method: 'PUT'},
                'schedule': {method: 'GET', url: 'api/slot/:id/schedule', isArray: true}
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectSlot', function (Slot) {
            return {
                require: '^ngModel',
                scope: {
                    type: "=",
                    modelValue: '=ngModel',
                    options: '='
                },
                templateUrl: 'app/entities/slot/select-slot.html',
                link: function (scope, $element, $attrs, ngModelCtrl) {

                    var defaultOptions = {
                        // activityFiltering: true
                    };

                    scope.requestOptions = angular.extend({}, defaultOptions, scope.options);
                    var queryPromise = Slot.autocomplete(scope.requestOptions).$promise;
                    queryPromise
                        .then(function (items) {
                            scope.items = items;
                        })
                        .catch(function (reason) {
                            scope.items = [];
                        });

                    scope.setValue = function (value) {
                        ngModelCtrl.$setViewValue(value);
                    };

                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('SlotScheduleDialogController', function ($scope, item, $uibModalInstance, SlotSchedule) {
            var vm = this;

            vm.dayNames = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            vm.item = item;

            vm.save = function () {
                if (vm.item.id !== null) {
                    SlotSchedule.update(vm.item).$promise.then(onSave);
                } else {
                    SlotSchedule.save(vm.item).$promise.then(onSave);
                }

                function onSave(result) {
                    $scope.$emit('slot:scheduleUpdated', result);
                    $uibModalInstance.close(result);
                }
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            vm.addPeriod = function () {
                vm.item.periods.push({});
            };

            vm.removePeriod = function (idx) {
                vm.item.periods.splice(idx, 1);
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('SlotDialogController', function ($scope, $uibModalInstance, Slot, item) {
            var vm = this;
            vm.item = item;

            function onSaveSuccess(result) {
                $scope.$emit('slot:updated', result);
                $uibModalInstance.close(result);
            }
            vm.save = function () {
                var tmp = angular.copy(vm.item);

                if (tmp.id !== null) {
                    return Slot.update(tmp, onSaveSuccess).$promise;
                } else {
                    return Slot.save(tmp, onSaveSuccess).$promise;
                }
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            vm.onWarehouseSelect = function (warehouse) {
                vm.item.warehouseId = warehouse.id;
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('parcelTypes', {
            bindings: {
                filters: '=',
                page: '='
            },
            templateUrl: 'app/entities/parcel-type/list.html',
            controller: function ($state, ParcelTypeService) {
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                this.create = function () {
                    ParcelTypeService.add().then(reloadData);
                };

                this.edit = function (item) {
                    ParcelTypeService.edit(item).then(reloadData);
                };

                this.delete = function (item) {
                    ParcelTypeService.delete(item).then(reloadData);
                };

                function reloadData() {
                    $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('parcelType', {
                    parent: 'entity',
                    url: '/parcel-type?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': 'parcelTypes'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'name,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (ParcelType, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            ParcelType.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }
                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('ParcelType', function ($resource) {
            return $resource('api/parcel-type/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'forSlot': {method: 'GET', isArray: true, url: 'api/parcel-type/for-slot'}
            });
        })
        .service('ParcelTypeService', function ($uibModal, ParcelType, ConfirmDialogService) {

            this.add = function (params) {
                return $uibModal.open({
                    templateUrl: 'app/entities/parcel-type/dialog.html',
                    controller: 'ParcelTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        item: function () {
                            return params;
                        }
                    }
                }).result;
            };

            this.edit = function (item) {
                return $uibModal.open({
                    templateUrl: 'app/entities/parcel-type/dialog.html',
                    controller: 'ParcelTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        item: function () {
                            return item;
                        }
                    }
                }).result;
            };

            this.delete = function (item) {
                return ConfirmDialogService.open({
                    messageTranslated: {
                        key: "parcelType.label.delete",
                        params: { param: item.name }
                    },
                    confirmPromise: function () {
                        return ParcelType.delete({id: item.id}).$promise;
                    }
                });
            };
        })
    ;

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('ParcelTypeDialogController', function ($scope, $stateParams, $uibModalInstance, ParcelType, item) {
            var vm = this;

            vm.item = {
                id: null
            };

            if (item) {
                vm.item = angular.copy(item);
            }

            vm.save = function () {
                if (vm.item.id !== null) {
                    ParcelType.update(vm.item).$promise.then(onSaveSuccess);
                } else {
                    ParcelType.save(vm.item).$promise.then(onSaveSuccess);
                }

                function onSaveSuccess(result) {
                    $scope.$emit('parcelType:updated', result);
                    $uibModalInstance.close(result);
                }
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });

})();
;
(function () {
    'use strict';
    angular
        .module('awizApp')
        .factory('SMS', function ($resource) {
            return $resource('api/sms/:id', {id: '@id'}, {
                'sendMessage': {method: 'POST'}
            });
        })
        .service('SmsService', function ($uibModal) {

            this.sendMessage = function (phone) {
                return $uibModal.open({
                    templateUrl: 'app/entities/sms/send-dialog.html',
                    controller: 'SmsSendDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        phone: function () {
                            return phone;
                        }
                    }
                }).result;
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('SmsSendDialogController', function ($uibModalInstance, phone, SMS) {
            var vm = this;

            vm.item = {
                phone: phone
            };

            vm.phonePattern = "^$|\\d{9}";

            vm.submit = function () {
                return SMS.sendMessage(vm.item).$promise.then(function () {
                    $uibModalInstance.close();
                });
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationTimeChangeController', function ($timeout, $rootScope, $uibModalInstance, EntryReservation, EntryReservationService, entryId) {
            var vm = this;

            EntryReservation.get({id: entryId}).$promise.then(function (data) {
                vm.entry = data;
                vm.item = {
                    id: data.id,
                    startTime: data.startTime
                };
                vm.calculatedEndTime = data.endTime;
            });

            vm.calculateEndTime = function () {
                vm.calculatedEndTime = EntryReservationService.calculateEndTime(vm.entry.parcelType.processingTimeInMin, vm.entry.parcelQuantity, vm.item.startTime);
            };

            vm.canSave = function(){
                return vm.entry && vm.entry.status === 'UNCONFIRMED';
            };

            vm.save = function () {
                return EntryReservation.timeChange(vm.item).$promise.then(function () {
                    $rootScope.$broadcast('entry:updated');
                    $uibModalInstance.close();
                });
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('reservations', {
            bindings: {
                filters: '=',
                page: '=',
                reservationStatuses: '<'
            },
            templateUrl: 'app/entities/entry-reservation/reservation-list/list.html',
            controller: function ($state, Principal, EntryReservationService, $scope) {
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                this.show = EntryReservationService.show;
                this.hasSlots = Principal.hasSlots;

                $scope.$on('entry:updated', function () {
                    $state.reload();
                });
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('entryreservation-list', {
                    parent: 'entity',
                    url: '/entry-reservation-list?{page:int}&{size:int}&sort&search&status&start&end&{shipper:int}&{slot:int}',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': "reservations"
                    },
                    params: {
                        page: {
                            value: 1,
                            squash: true
                        },
                        sort: {
                            value: 'id,desc',
                            squash: true
                        },
                        size: {
                            value: 50,
                            squash: true
                        },
                        search: null,
                        status: {
                            array: true
                        }
                    },
                    resolve: {
                        reservationStatuses: function (EntryReservation) {
                            return EntryReservation.statuses().$promise;
                        },
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (EntryReservation, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            EntryReservation.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                })
                .state('entryreservation-calendar', {
                    parent: 'entity',
                    url: '/entry-reservation-calendar?search&status&{shipper:int}&{slot:int}',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/entry-reservation/reservation-calendar/calendar.html',
                            controller: 'EntryReservationCalendarController',
                            controllerAs: 'vm'
                        }
                    },
                    params: {
                        search: null,
                        status: {
                            array: true
                        }
                    }
                })
                .state('home.entryreservation-link', {
                    url: 'reservation/{entryId}',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: function ($stateParams, $transition$, EntryReservationService, ModalUtil) {
                        EntryReservationService.show($stateParams.entryId)
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('entryreservation-show', {
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    params: {
                        id: null
                    },
                    onEnter: function ($stateParams, $transition$, EntryReservationService, ModalUtil) {
                        EntryReservationService.show($stateParams.id)
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })

            ;
        });

})();
;
(function () {
    'use strict';
    angular
        .module('awizApp')
        .factory('EntryReservation', function ($resource) {
            return $resource('api/entry-reservation/:id', {id: '@id'}, {
                'query': {method: 'GET', isArray: true},
                'myReservations': {method: 'GET', isArray: true, url: 'api/entry-reservation/my-reservations'},
                'update': {method: 'PUT'},
                'mySlots': {method: 'GET', url: 'api/entry-reservation/my-slots', isArray: true},
                'changeStatus': {method: 'POST', url: 'api/entry-reservation/:id/status-change'},
                'timeChange': {method: 'POST', url: 'api/entry-reservation/:id/time-change'},
                'carrierChange': {method: 'POST', url: 'api/entry-reservation/:id/carrier-change'},
                'toggleWorkStandBy': {method: 'POST', url: 'api/entry-reservation/:id/toggle-work-stand-by'},
                'comments': {method: 'GET', url: 'api/entry-reservation/:id/comments', isArray: true},
                'lastComments': {method: 'GET', url: 'api/entry-reservation/last-comments', isArray: true},
                'postComment': {method: 'POST', url: 'api/entry-reservation/:id/comments'},
                'statuses': {method: 'GET', isArray: true, url: 'api/entry-reservation-status'}
            });
        })
        .service('EntryReservationService', function ($rootScope, $uibModal, EntryReservation) {

            this.add = function (params) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/add.html',
                    controller: 'EntryReservationAddController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        params: params
                    }
                }).result;
            };
            this.edit = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/edit.html',
                    controller: 'EntryReservationEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entryId: id
                    }
                }).result;
            };
            this.show = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/reservation.html',
                    controller: 'EntryReservationDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entryId: function (){
                            return id;
                        }
                    }
                }).result;
            };
            this.statusChange = function (id, operation, commentRequired) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/status-change/status-change.html',
                    controller: 'EntryReservationStatusChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        params: function () {
                            return {
                                entryId: id,
                                operation: operation,
                                commentRequired: commentRequired
                            };
                        }
                    }
                }).result;
            };
            this.timeChange = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/time-change.html',
                    controller: 'EntryReservationTimeChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entryId: id
                    }
                }).result;
            };
            this.carrierChange = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/entities/entry-reservation/carrier-change.html',
                    controller: 'EntryReservationCarrierChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entryId: id
                    }
                }).result;
            };
            this.toggleWorkStandBy = function (entryId, workStandBy) {
                EntryReservation.toggleWorkStandBy({id: entryId, workStandBy: workStandBy}).$promise.then(function () {
                    $rootScope.$broadcast('entry:updated');
                });
            };
            this.calculateEndTime = function (parcelProcessingTimeInMin, parcelQuantity, startTime) {
                if (!parcelProcessingTimeInMin || !parcelQuantity) {
                    return;
                }

                var processingTime = parcelProcessingTimeInMin * parcelQuantity;
                return moment(startTime).add(processingTime, 'm');
            };
        })
        .service('EntryReservationUtils', function ($rootScope, $compile, $http, $translate) {
            var formatCalendarEvent = function (eventData, timezone) {
                return {
                    id: eventData.id,
                    start: moment(eventData.time.start).tz(timezone),
                    end: moment(eventData.time.end).tz(timezone),
                    className: ['calendar-reservation-status-' + eventData.status, 'calendar-work-stand-by-' + eventData.workStandBy],
                    overlap: eventData.status === 'CANCELLED',
                    workStandBy: eventData.workStandBy,
                    title: eventData.shipper.code,
                    actionType: eventData.actionType,
                    carrierName: eventData.freightInformation.carrierName,
                    driverPhone: eventData.freightInformation.driverPhone
                };
            };

            var formatCalendarReservedTime = function (eventData, timezone) {
                return {
                    start: moment(eventData.startTime).tz(timezone),
                    end: moment(eventData.endTime).tz(timezone),
                    className: "calendar-reserved-time",
                    rendering: 'background',
                    editable: false
                };
            };

            var formatCalendarDayOff = function (eventData, includeCustomer) {
                var title = eventData.notes || $translate.instant('dayOff.allDay');
                if (includeCustomer && eventData.customerCode) {
                    title = eventData.customerCode + ' — ' + title;
                }
                return {
                    start: eventData.date,
                    end: moment(eventData.date).add(1, 'day').format('YYYY-MM-DD'),
                    allDay: true,
                    className: 'calendar-day-off',
                    editable: false,
                    overlap: false,
                    dayOff: true,
                    title: title
                };
            };

            this.calendarEventRender = function (event, element, view) {
                if (event.id) {
                    if (event.workStandBy === true) {
                        element.find(".fc-list-item-title").append('<div class="pull-right"><i class="fas fa-fw fa-truck work-stand-by-true" title="{{ \'entry.events.work-stand-by.true\' | translate }}"></i></div>');
                    }

                    if (event.actionType === 'LOADING') {
                        element.find('.fc-title, .fc-list-item-title').prepend('<i class="fa fa-download fa-fw fa-smaller" translate-attr="{ title: \'entry.actionTypes.loading-forwarder\' }"></i>&nbsp;');
                    }
                    if (event.actionType === 'UNLOADING') {
                        element.find('.fc-title, .fc-list-item-title').prepend('<i class="fa fa-upload fa-fw fa-smaller" translate-attr="{ title: \'entry.actionTypes.unloading-forwarder\' }"></i>&nbsp;');
                    }
                    if (event.driverPhone) {
                        element.find('.fc-title, .fc-list-item-title').append('<div translate-attr="{ title: \'entry.vehicle.driverPhone\' }"><i class="fas fa-phone fa-fw fa-smaller"></i>&nbsp;' + event.driverPhone + '</div>');
                    }

                }
                var scope = $rootScope.$new();
                $compile(element)(scope);
            };

            this.downloadTransformEntries = function (tableFilters, start, end, timezone, callback) {
                tableFilters.start = start.toDate();
                tableFilters.end = end.toDate();
                $http({
                    url: '/api/entry-reservation',
                    params: tableFilters,
                    method: 'GET'
                }).then(function (reservationEntries) {
                    var events = [];
                    reservationEntries.data.forEach(function (eventData) {
                        events.push(formatCalendarEvent(eventData, timezone));
                    });
                    callback(events);
                });
            };

            this.fetchSlotEntries = function (slotId, start, end, timezone, params, callback) {
                params.start = start.toDate();
                params.end = end.toDate();
                $http({
                    url: '/api/entry-reservation/slot/' + slotId + '/entry',
                    params: params,
                    method: 'GET'
                }).then(function (reservationEntries) {
                    var events = [];
                    reservationEntries.data.forEach(function (eventData) {
                        events.push(formatCalendarEvent(eventData, timezone));
                    });
                    callback(events);
                });
            };

            this.fetchSlotReservedTime = function (slotId, start, end, timezone, callback) {
                $http({
                    url: '/api/entry-reservation/slot/' + slotId + '/reserved-time',
                    params: {
                        start: start.toDate(),
                        end: end.toDate()
                    },
                    method: 'GET'
                }).then(function (reservedTimeEntries) {
                    var events = [];
                    reservedTimeEntries.data.forEach(function (eventData) {
                        events.push(formatCalendarReservedTime(eventData, timezone));
                    });
                    callback(events);
                });
            };

            this.fetchDayOffs = function (start, end, slotId, includeCustomer, callback) {
                var params = {
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD')
                };
                if (slotId) {
                    params.slot = slotId;
                }
                $http({
                    url: '/api/day-off/calendar',
                    params: params,
                    method: 'GET'
                }).then(function (response) {
                    callback(response.data.map(function (eventData) {
                        return formatCalendarDayOff(eventData, includeCustomer);
                    }));
                });
            };

            this.calendarSelectAllow = function (selectInfo, isSlotOwner) {
                var is15min = selectInfo.start.add(15, "m").isSame(selectInfo.end);
                var isAfterNow = selectInfo.start.isAfter(moment());
                return is15min && (isAfterNow || isSlotOwner === true);
            };
        });


})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationDetailController', function ($timeout, $rootScope, $scope, entryId, $uibModalInstance, EntryReservation, SmsService) {
            var vm = this;
            vm.entryId = entryId;

            function loadEntry() {
                EntryReservation.get({id: vm.entryId}).$promise.then(function (data) {
                    vm.item = data;
                });
            }
            loadEntry();

            $scope.$on('entry:updated', function () {
                loadEntry();
            });

            vm.close = function() {
                $uibModalInstance.dismiss('cancel');
            };

            vm.sendSMS = function (phone) {
                SmsService.sendMessage(phone);
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationEditController', function ($timeout, $rootScope, $scope, $uibModalInstance, EntryReservation, ParcelType, entryId) {
            var vm = this;

            vm.actionTypes = ['LOADING', 'UNLOADING'];

            EntryReservation.get({id: entryId}).$promise
                .then(function (data) {
                    vm.item = data;
                    vm.calculatedEndTime = data.endTime;
                    vm.item.trailer = !!data.trailerRegistrationNumber;
                    loadParcelTypes(data.slot.id);
                });

            vm.save = function () {
                return EntryReservation.update(vm.item).$promise
                    .then(function (data) {
                        $rootScope.$broadcast('entry:updated');
                        $uibModalInstance.close(data);
                    });
            };

            function loadParcelTypes(slotId) {
                ParcelType.forSlot({slotId: slotId}).$promise.then(function (data) {
                    vm.parcelTypes = data;
                });
            }

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

            vm.calculateEndTime = function () {
                if (!vm.item.parcelType || !vm.item.parcelQuantity) {
                    delete vm.calculatedEndTime;
                    return;
                }

                var processingTime = vm.item.parcelType.processingTimeInMin * vm.item.parcelQuantity;
                vm.processingTime = processingTime;
                vm.calculatedEndTime = moment(vm.item.startTime).add(processingTime, 'm');
            };

            vm.onTrailerChange = function () {
                delete vm.item.trailerRegistrationNumber;
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationCarrierChangeController', function ($timeout, $rootScope, $uibModalInstance, EntryReservation, EntryReservationService, entryId) {
            var vm = this;

            EntryReservation.get({id: entryId}).$promise.then(function (data) {
                vm.entry = data;
                vm.item = {
                    id: data.id,
                    actionType: data.actionType,
                    carrierName: data.carrierName,
                    driverName: data.driverName,
                    driverPhone: data.driverPhone,
                    driverIdentityCard: data.driverIdentityCard,
                    vehicleRegistrationNumber: data.vehicleRegistrationNumber,
                    trailer: data.trailer,
                    trailerRegistrationNumber: data.trailerRegistrationNumber,
                    trackingNumber: data.trackingNumber,
                    orderNumber: data.orderNumber
                };
            });

            vm.onTrailerChange = function () {
                delete vm.item.trailerRegistrationNumber;
            };

            vm.canSave = function(){
                return vm.entry && (vm.entry.status === 'UNCONFIRMED' || vm.entry.status === 'CONFIRMED');
            };

            vm.save = function () {
                return EntryReservation.carrierChange(vm.item).$promise.then(function () {
                    $rootScope.$broadcast('entry:updated');
                    $uibModalInstance.close();
                });
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('EntryReservationAddController', function ($timeout, $rootScope, $scope, $stateParams, $uibModalInstance, EntryReservation, ParcelType, params, Forwarder, Slot, Principal) {
            var vm = this;

            Slot.get({id: params.slotId}).$promise.then(function (slot) {
                Principal.isCompanyWorker(slot.customer.id).then(function (isCompanyWorker) {
                    vm.isSlotOwner = isCompanyWorker;
                });
            });

            vm.actionTypes = ['LOADING', 'UNLOADING'];

            ParcelType.forSlot({slotId: params.slotId}).$promise.then(function (data) {
                vm.parcelTypes = data;
            });

            vm.item = angular.extend(params);
            vm.item.trailer = false;
            vm.item.actionType = 'LOADING';

            vm.save = function () {
                return EntryReservation.save(vm.item).$promise
                    .then(function (result) {
                        $rootScope.$broadcast('entry:updated');
                        $uibModalInstance.close(result);
                    });
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

            vm.calculateEndTime = function () {
                if (!vm.item.parcelType || !vm.item.parcelQuantity) {
                    delete vm.calculatedEndTime;
                    return;
                }

                var processingTime = vm.item.parcelType.processingTimeInMin * vm.item.parcelQuantity;
                vm.calculatedEndTime = moment(vm.item.startTime).add(processingTime, 'm');
                vm.processingTime = processingTime;
            };

            vm.onTrailerChange = function () {
                delete vm.item.trailerRegistrationNumber;
            };

            vm.setShipper = function () {
                vm.shipperSelectable = true;
                Forwarder.autocomplete().$promise.then(function (items) {
                    vm.shippers = items;
                });
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('forwarders', {
            bindings: {
                filters: '=',
                page: '='
            },
            templateUrl: 'app/entities/forwarder/list.html',
            controller: function ($state, ConfirmDialogService, Forwarder) {
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };

                this.delete = function (item) {
                    return ConfirmDialogService
                        .open({
                            messageTranslated: {
                                key: "entity.delete.question",
                                params: {param: item.code}
                            },
                            confirmPromise: function () {
                                return Forwarder.delete({id: item.id}).$promise;
                            }
                        })
                        .then(function () {
                            $state.reload();
                        });
                };
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('forwarder', {
                    parent: 'entity',
                    url: '/forwarder?page&size&sort&search',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': 'forwarders'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'id,desc',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (Forwarder, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            Forwarder.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                })
                .state('forwarder.invitations', {
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    onEnter: function ($transition$, $uibModal, ModalUtil) {
                        $uibModal.open({
                            templateUrl: 'app/entities/forwarder/invitations-dialog.html',
                            controller: 'ForwarderInvitationsDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md'
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('forwarder.invite', {
                    data: {
                        authorities: ['ROLE_OWNER']
                    },
                    onEnter: function ($transition$, $uibModal, ModalUtil) {
                        $uibModal.open({
                            templateUrl: 'app/entities/forwarder/invite-dialog.html',
                            controller: 'ForwarderInviteDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md'
                        }).result
                            .then(function () {
                                ModalUtil.defaultThen($transition$.from(), $transition$.params('from'));
                            })
                            .catch(function () {
                                ModalUtil.defaultCatch($transition$.from(), $transition$.params('from'));
                            });
                    },
                    onExit: function ($uibModalStack) {
                        $uibModalStack.dismissAll();
                    }
                })
                .state('forwarderInviteFinish', {
                    parent: 'entity',
                    url: '/forwarder/finish?key',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/forwarder/invite-finish.html',
                            controller: 'ForwarderInviteFinishController',
                            controllerAs: 'vm'
                        }
                    }
                })
            ;
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('ForwarderInviteFinishController', function ($translate, $stateParams, Auth, $state, Forwarder) {
            var vm = this;

            Forwarder.invitation({key: $stateParams.key}).$promise.then(function (data) {
                vm.item = data;
                vm.refreshLanguage();
            });
            vm.finishRegistration = function () {
                Forwarder.invitationFinish(vm.item).$promise.then(function () {
                    Auth.logout();
                    $state.go('home');
                });
            };

            vm.refreshLanguage = function () {
                $translate.use(vm.item.language);
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('ForwarderInviteDialogController', function ($translate, $scope, $uibModalInstance, Forwarder) {
            var vm = this;

            vm.invitation = {
                language: $translate.use()
            };

            vm.save = function () {
                return Forwarder.invitationRequest(vm.invitation, onSaveSuccess);

                function onSaveSuccess(result) {
                    $scope.$emit('forwarder:updated', result);
                    $uibModalInstance.close(result);
                }
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('ForwarderInvitationsDialogController', function ($uibModalInstance, Forwarder) {
            var vm = this;

            refreshInvitations();

            vm.sendAgain = function (invitation) {
                return Forwarder.invitationSendAgain({id: invitation.id}).$promise;
            };

            vm.delete = function (invitation) {
                return Forwarder.invitationDelete({id: invitation.id}).$promise.then(refreshInvitations);
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

            function refreshInvitations() {
                Forwarder.invitations().$promise.then(function (result) {
                    vm.invitations = result;
                });
            }
        });

})();
;
(function() {
    'use strict';
    angular
        .module('awizApp')
        .factory('Forwarder', function ($resource) {
            return $resource('api/forwarder/:id', {id: '@id'}, {
                'query': { method: 'GET', isArray: true },
                'update': { method:'PUT' },
                'invitation': { url: "api/forwarder/invitation" },
                'invitations': { url: "api/forwarder/invitations", isArray: true },
                'invitationDelete': { url: "api/forwarder/invitations/:id", method: 'DELETE' },
                'invitationSendAgain': { url: "api/forwarder/invitations/:id/send-again", method: 'POST' },
                'invitationRequest': { url: "api/forwarder/invitation-request", method: 'POST' },
                "invitationFinish" : { url: "api/forwarder/invitation-finish", method: 'POST' },
                'autocomplete': { url: 'api/forwarder-autocomplete', isArray: true }
            });
        });

})();
;
(function () {
    'use strict';
    angular
        .module('awizApp')
        .factory('OrganizationSettings', function ($resource) {
            return $resource('api/organization-settings/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'updatePrivacyPolicy': {
                    method: 'PUT',
                    transformRequest: function (data) {
                        var fd = new FormData();
                        angular.forEach(data, function(value, key) {
                            fd.append(key, value);
                        });
                        return fd;
                    },
                    url: "api/privacy-policy",
                    headers: {'Content-Type': undefined, enctype: 'multipart/form-data'}
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('uiSrefIf', function($compile) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.removeAttr('ui-sref-if');
                    $compile(elem)(scope);

                    scope.$watch(attrs.condition, function(bool) {
                        if (bool) {
                            elem.attr('ui-sref', attrs.value);
                        } else {
                            elem.removeAttr('ui-sref');
                            elem.removeAttr('href');
                        }

                        $compile(elem)(scope);
                    });
                }
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .filter('words', function () {
            return wordsFilter;

            function wordsFilter(input, words) {
                if (isNaN(words)) {
                    return input;
                }
                if (words <= 0) {
                    return '';
                }
                if (input) {
                    var inputWords = input.split(/\s+/);
                    if (inputWords.length > words) {
                        input = inputWords.slice(0, words).join(' ') + '...';
                    }
                }

                return input;
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .filter('characters', function () {
            return charactersFilter;

            function charactersFilter(input, chars, breakOnWord) {
                if (isNaN(chars)) {
                    return input;
                }
                if (chars <= 0) {
                    return '';
                }
                if (input && input.length > chars) {
                    input = input.substring(0, chars);

                    if (!breakOnWord) {
                        var lastspace = input.lastIndexOf(' ');
                        // Get last space
                        if (lastspace !== -1) {
                            input = input.substr(0, lastspace);
                        }
                    } else {
                        while (input.charAt(input.length-1) === ' ') {
                            input = input.substr(0, input.length - 1);
                        }
                    }
                    return input + '...';
                }
                return input;
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('tableNoData', {
            template: '<div class="table-no-data" ng-if="$ctrl.items && $ctrl.items.length == 0 && !$ctrl.isLoading"><span translate="global.no-records"></span></div>',
            bindings: {
                items: '<'
            },
            controller: function ($transitions) {

                this.isLoading = false;

                var onBefore = $transitions.onBefore({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = true;
                    }
                }.bind(this));

                var onFinish = $transitions.onFinish({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                var onError = $transitions.onError({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                this.$onDestroy = function () {
                    onBefore();
                    onFinish();
                    onError();
                };

            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('tableInvisibleOnLoading', function ($transitions) {
            return {
                restrict: 'A',
                link: function ($scope, $element) {
                    var onBefore = $transitions.onBefore({}, function () {
                        $element.hide();
                    });

                    var onFinish = $transitions.onFinish({}, function () {
                        $element.show();
                    });

                    var onError = $transitions.onError({}, function () {
                        $element.show();
                    });
                    $scope.$on('$destroy', function () {
                        onBefore();
                        onFinish();
                        onError();
                    });
                }
            };
        })
        .component('tableLoadingSpinner', {
            template: '<div class="table-loading-spinner" ng-if="$ctrl.isLoading"><i class="fas fa-spinner fa-spin fa-lg fa-2x"></i></div>',
            bindings: {
                items: '<'
            },
            controller: function ($transitions) {

                this.isLoading = false;

                var onBefore = $transitions.onBefore({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = true;
                    }
                }.bind(this));

                var onFinish = $transitions.onFinish({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                var onError = $transitions.onError({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                this.$onDestroy = function () {
                    onBefore();
                    onFinish();
                    onError();
                };
            }
        })

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('mobileFilters', function (MobileTableFilters) {
            return {
                scope: {},
                link: function (scope, $element) {
                    if(MobileTableFilters.isHidden()){
                        $element.addClass('hidden-xs');
                    }

                    MobileTableFilters.onToggle(function (toggled) {
                        if(toggled){
                            $element.removeClass('hidden-xs');
                        }
                        else{
                            $element.addClass('hidden-xs');
                        }
                    });
                }
            };
        })
        .component('tableFiltersSwitch', {
            controller: function(MobileTableFilters){
                this.toggleMobileFilters = function (){
                    MobileTableFilters.toggle();
                };
            },
            template: '<div class="form-group input-group-sm visible-xs filter-radio-button">\n' +
                '            <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.toggleMobileFilters()">\n' +
                '                <i class="fas fa-filter"></i>\n' +
                '            </button>\n' +
                '        </div>'
        })
        .provider('MobileTableFilters', function () {
            this.$get = function() {
                return {
                    show: false,
                    onToggleCallback: angular.noop,
                    init: function () {
                        this.show = false;
                        this.onToggleCallback(this.show);
                        return this;
                    },
                    toggle: function() {
                        this.show = !this.show;
                        this.onToggleCallback(this.show);
                    },
                    isHidden: function () {
                        return !this.show;
                    },
                    onToggle: function (callbackFn) {
                        if (callbackFn instanceof Function){
                            this.onToggleCallback = callbackFn;
                        }
                    }
                };
            };
        })
        .component('pagination', {
            bindings: {
                itemsCount: "<",
                size: "<",
                page: "<"
            },
            template: "<div class=\"text-center\">\n" +
                "    <div uib-pagination total-items=\"$ctrl.itemsCount\" items-per-page=\"$ctrl.size\" ng-model=\"$ctrl.page\" max-size=\"7\" class=\"pagination-sm\" ng-change=\"$ctrl.onPageChange()\" boundary-link-numbers=\"true\" ng-if=\"$ctrl.itemsCount && $ctrl.itemsCount > 0\"></div>\n" +
                "</div>",
            controller: function($state, $stateParams){
                this.onPageChange = function () {
                    $stateParams.page = this.page;
                    $state.transitionTo($state.current, $stateParams);
                };
            }
        })
        ;
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('tableTitle', {
            bindings: {
                titleKey: '@',
                tableCount: '<'
            },
            template: "<div>\n" +
                "    <table-filters-switch></table-filters-switch>" +
                "<div class=\"clearfix\">\n" +
                "        <h5>{{$ctrl.titleKey | translate}}&nbsp;(<invisible-on-loading>{{$ctrl.tableCount}}</invisible-on-loading>)</h5>\n" +
                "    </div>" +
                "</div>",
            controller: function () {
            }
        })
        .component('invisibleOnLoading', {
            controller: function ($transitions, $element) {
                this.isLoading = false;
                var onBefore = $transitions.onBefore({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = true;
                        // $element.hide();
                        $element.html('<span>...</span>');
                    }
                }.bind(this));

                var onFinish = $transitions.onFinish({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                        $element.show();
                    }
                }.bind(this));

                var onError = $transitions.onError({}, function (transition) {
                    if (transition.from() === transition.to()) {
                        this.isLoading = false;
                        $element.show();
                    }
                }.bind(this));

                this.$onDestroy = function () {
                    onBefore();
                    onFinish();
                    onError();
                };
            }
        })
        .component('stateLoadingSpinner', {
            template: "<div class=\"state-loading-spinner\" ng-if=\"$ctrl.isLoading\"><i class=\"fas fa-spinner fa-spin fa-lg fa-2x\"></i></div>",
            controller: function ($transitions) {

                this.isLoading = false;

                var onBefore = $transitions.onBefore({}, function (transition) {
                    if (transition.from() !== transition.to()) {
                        this.isLoading = true;
                    }
                }.bind(this));

                var onFinish = $transitions.onFinish({}, function (transition) {
                    if (transition.from() !== transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                var onError = $transitions.onError({}, function (transition) {
                    if (transition.from() !== transition.to()) {
                        this.isLoading = false;
                    }
                }.bind(this));

                this.$onDestroy = function () {
                    onBefore();
                    onFinish();
                    onError();
                };

            }
        });
}());
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('jhSort', function () {
            return {
                restrict: 'A',
                scope: {
                    predicate: '=jhSort',
                    ascending: '=',
                    callback: '&'
                },
                controllerAs: 'vm',
                bindToController: true,
                controller: function ($scope, $element) {
                    var vm = this;

                    vm.applyClass = applyClass;
                    vm.resetClasses = resetClasses;
                    vm.sort = sort;
                    vm.triggerApply = triggerApply;

                    $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
                    vm.triggerApply();

                    function applyClass (element) {
                        var thisIcon = element.find('span.glyphicon'),
                            sortIcon = 'glyphicon-sort',
                            sortAsc = 'glyphicon-sort-by-attributes',
                            sortDesc = 'glyphicon-sort-by-attributes-alt',
                            remove = sortIcon + ' ' + sortDesc,
                            add = sortAsc;
                        if (!vm.ascending) {
                            remove = sortIcon + ' ' + sortAsc;
                            add = sortDesc;
                        }
                        vm.resetClasses();
                        thisIcon.removeClass(remove);
                        thisIcon.addClass(add);
                    }

                    function resetClasses () {
                        var allThIcons = $element.find('span.glyphicon'),
                            sortIcon = 'glyphicon-sort',
                            sortAsc = 'glyphicon-sort-by-attributes',
                            sortDesc = 'glyphicon-sort-by-attributes-alt';
                        allThIcons.removeClass(sortAsc + ' ' + sortDesc);
                        allThIcons.addClass(sortIcon);
                    }

                    function sort (field) {
                        if (field !== vm.predicate) {
                            vm.ascending = true;
                        } else {
                            vm.ascending = !vm.ascending;
                        }
                        vm.predicate = field;
                        $scope.$apply();
                        vm.callback();
                    }

                    function triggerApply (values)  {
                        vm.resetClasses();
                        if (values && values[0] !== '_score') {
                            vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
                        }
                    }
                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('sortIcon', function () {
            return {
                restrict: 'AE',
                scope: {
                    column: '=',
                    predicate: '=',
                    ascending: '='
                },
                replace: true,
                template: '<span class="glyphicon " ng-class="{ \'glyphicon-sort\' : column !== predicate, \'glyphicon-sort-by-attributes\': predicate === column && ascending, \'glyphicon-sort-by-attributes-alt\': predicate === column && !ascending }"></span>'
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('jhSortBy', function () {
            return {
                restrict: 'A',
                scope: false,
                require: '^jhSort',
                link: linkFunc
            };

            function linkFunc(scope, element, attrs, parentCtrl) {
                element.append('<span class="glyphicon glyphicon-sort"></span>');
                element.bind('click', function () {
                    parentCtrl.sort(attrs.jhSortBy);
                });
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('selectDateRange', function (DateRangePickerConfig, $timeout) {
            return {
                scope: {
                    start: '=',
                    end: '=',
                    onChange: '&',
                    options: '='
                },
                template: '<div class="input-group input-group-sm">\n' +
                            '<span class="input-group-addon" translate-attr="{ title: selectOptions.placeholderKey }"><i class="fas fa-clock fa-fw"></i></span>' +
                            '<input date-range-picker options="daterangepicker_options" ' +
                                'class="form-control date-range-picker" type="text" translate-attr="{ placeholder: selectOptions.placeholderKey }"' +
                                'ng-change="onModelChange()" ng-model="period" />' +
                            '</div>',
                link: function (scope) {
                    scope.period = {};
                    if (scope.start) {
                        scope.period.startDate = scope.start;
                    }
                    if (scope.end) {
                        scope.period.endDate = scope.end;
                    }

                    scope.onModelChange = function () {
                        scope.start = scope.period.startDate ? moment(scope.period.startDate).toISOString() : null;
                        scope.end = scope.period.endDate ? moment(scope.period.endDate).toISOString() : null;
                        $timeout(function () {
                            scope.onChange();
                        });
                    };

                    var defaultOptions = {
                        placeholderKey: ''
                    };

                    scope.selectOptions = angular.extend({}, defaultOptions, scope.options);

                    var options = {
                        eventHandlers: {
                            'cancel.daterangepicker': function (ev, picker) {
                                scope.period = {};
                                scope.onModelChange();
                            },
                            'apply.daterangepicker': function (ev, picker) {
                                scope.onModelChange();
                            }
                        }
                    };
                    scope.daterangepicker_options = DateRangePickerConfig.get(options);
                }
            };
        })
        ;
})();
;
(function() {
    'use strict';
    angular
        .module('awizApp')
        .factory('ProductListHelper', function () {
            return {
                getSizeCollection: getSizeCollection,
                getColorCollection: getColorCollection,
                selectAll: selectAll,
                deselectAll: deselectAll,
                selectItem: selectItem
            };

            function getSizeCollection(products, allProducts) {
                if(!angular.isArray(products) || products.length === 0 || !angular.isArray(allProducts) || allProducts.length === 0)
                    return [];
                var shopModels = products
                    // .filter(function (p) {
                    //     return p.shopModel.length > 0;
                    // })
                    .map(function (p) {
                        return p.shopModel;
                    });

                return allProducts.filter(function (item) {
                    return shopModels.indexOf(item.shopModel) >= 0;
                });
            }
            function getColorCollection(products, allProducts) {
                if(!angular.isArray(products) || products.length === 0)
                    return [];
                var shopModels = products
                    // .filter(function (p) {
                    //     return p.collectionModel.length > 0;
                    // })
                    .map(function (p) {
                        return p.collectionModel;
                    });

                return allProducts.filter(function (item) {
                    return shopModels.indexOf(item.collectionModel) >= 0;
                });
            }

            function deselectAll(items){
                angular.forEach(items, function(item) {
                    item.selected = false;
                });
            }

            function selectItem(item, selectedItems) {
                if(!item.selected){
                    selectedItems.push(item);
                    item.selected = true;
                }
                else {
                    item.selected = false;
                    selectedItems.splice(selectedItems.indexOf(item), 1);
                }
            }

            function selectAll(items, selectedItems, checkbox){
                // var newValue = (50 !== selectedItems.length);
                var newValue = checkbox;
                angular.forEach(items, function(item) {
                    if(newValue){
                        if(!item.selected){
                            item.selected = newValue;
                            selectedItems.push(item);
                        }
                    }
                    else{
                        if(item.selected){
                            item.selected = newValue;
                            selectedItems.splice(selectedItems.indexOf(item), 1);
                        }
                    }
                });

            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component("periodTimezoneFormat", {
            template: '{{$ctrl.startTime | amTimezone: $ctrl.timezone | amDateFormat : $ctrl.format1 }} - {{$ctrl.endTime | amTimezone: $ctrl.timezone | amDateFormat : $ctrl.format2 }}' +
                '<span style="font-size: xx-small; font-weight: normal; color: black;" ng-if="$ctrl.isDifferentTimezone()">' +
                '{{$ctrl.endTime | amTimezone: $ctrl.timezone | amDateFormat : $ctrl.format3}}' +
                '</span>',
            bindings: {
                startTime: '<',
                endTime: '<',
                timezone: '<'
            },
            controller: function ($translate) {
                var ctrl = this;
                var timezone = moment.tz.guess();
                ctrl.isDifferentTimezone = function () {
                    return timezone !== ctrl.timezone;
                };

                ctrl.format1 = 'YYYY-MM-DD [ ' + $translate.instant('timezone.hour') + ' ] HH:mm';
                ctrl.format2 = "HH:mm";
                ctrl.format3 = " (Z)";
            }
        });

})();
;
(function(){
    'use strict';

    angular
        .module('awizApp')
        .factory('ParseLinks', function () {

            return {
                parse: parse
            };

            function parse (header) {
                if (header.length === 0) {
                    throw new Error('input must not be of zero length');
                }

                // Split parts by comma
                var parts = header.split(',');
                var links = {};
                // Parse each part into a named link
                angular.forEach(parts, function (p) {
                    var section = p.split(';');
                    if (section.length !== 2) {
                        throw new Error('section could not be split on ";"');
                    }
                    var url = section[0].replace(/<(.*)>/, '$1').trim();
                    var queryString = {};
                    url.replace(
                        new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                        function($0, $1, $2, $3) { queryString[$1] = $3; }
                    );
                    var page = queryString.page;
                    if( angular.isString(page) ) {
                        page = parseInt(page);
                    }
                    var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                    links[name] = page;
                });

                return links;
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('PaginationUtil', function () {
            return {
                parseAscending: parseAscending,
                parsePage: parsePage,
                parsePredicate: parsePredicate,
                parseIntOrNull: parseIntOrNull,
                parseCollection: parseCollection,
                parseDateTime: parseDateTime
            };

            function parseAscending (sort) {
                var sortArray = sort.split(',');
                if (sortArray.length > 1){
                    return sort.split(',').slice(-1)[0] === 'asc';
                } else {
                    // default to true if no sort defined
                    return true;
                }
            }

            // query params are strings, and need to be parsed
            function parsePage (page) {
                return parseInt(page);
            }

            // sort can be in the format `id,asc` or `id`
            function parsePredicate (sort) {
                var sortArray = sort.split(',');
                if (sortArray.length > 1){
                    sortArray.pop();
                }
                return sortArray.join(',');
            }

            function parseIntOrNull(value) {
                return value? Number(value) : null
            }

            function parseCollection(value) {
                if(!value)
                    return [];

                return angular.isArray(value)? value : [value];
            }

            function parseDateTime(value) {
                if(!value)
                    return null;
                return moment(value).toISOString()
            }

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('timeModelFormatter', function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {

                    ngModel.$formatters.push(function (value) {
                        if(value === null)
                            return;
                        return moment(value, "HH:mm:ss").toDate();
                    });

                    ngModel.$parsers.push(function (value) {
                        if (value === null)
                            return;

                        return moment(value).format('HH:mm:ss');
                    });
                }
            };
        })
        .directive('dateModelFormatter', function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {

                    ngModel.$formatters.push(function (value) {
                        if(value === null)
                            return;
                        return value;
                    });

                    ngModel.$parsers.push(function (value) {
                        if (value === null)
                            return;

                        return moment(value).format("YYYY-MM-DD");
                    });
                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .filter('join', function () {
            return function join(array, separator, prop) {
                if (!Array.isArray(array)) {
                    return array; // if not array return original - can also throw error
                }
                array = array.filter(function (e) {
                    return angular.isDefined(e);
                });

                return (!!prop ? array.map(function (item) {
                    return item[prop];
                }) : array).join(separator);
            };
        })
        .factory('ModalUtil', function ($state) {
            return {
                defaultThen: defaultThen,
                defaultCatch: defaultCatch
            };

            function defaultThen(transitionFrom, transitionParamsFrom) {
                if (transitionFrom.abstract) {
                    $state.go('^');
                } else {
                    $state.go(transitionFrom, transitionParamsFrom, {reload: true});
                }
            }

            function defaultCatch (transitionFrom, transitionParamsFrom) {
                if (transitionFrom.abstract) {
                    $state.go('^');
                } else {
                    $state.go(transitionFrom, transitionParamsFrom);
                }
            }

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('mapLinkToThick', {
            bindings: {
                address: '<',
                coordinates: '<'
            },
            template: '<a ng-if="$ctrl.label" href="https://www.google.com/maps/search/?api=1&query={{$ctrl.destination}}" target="_blank"\n' +
                '   title="{{ \'entry.label.show-on-map\' | translate }}">\n' +
                ' {{$ctrl.label}}' +
                '</a>',
            controller: function () {
                this.destination = null;
                this.label = null;
                this.$onInit = function () {
                    if(this.address){
                        this.label = this.address.street + ', ' + this.address.postcode + ' ' + this.address.city;
                        this.destination = this.address.street + ', ' + this.address.postcode + ' ' + this.address.city;
                    }
                    if(this.coordinates){
                        this.destination = this.coordinates.longitude + ',' + this.coordinates.latitude;
                    }
                };
            }
        })
        .component('mapLinkToDirections', {
            bindings: {
                address: '<',
                coordinates: '<'
            },
            template: '<a ng-if="$ctrl.destination" href="https://www.google.com/maps/dir/?api=1&destination={{$ctrl.destination}}" target="_blank"\n' +
                '   title="{{ \'entry.label.prepare-route\' | translate }}">\n' +
                ' <i class="fas fa-route fa-w-15"></i>' +
                '</a>',
            controller: function () {
                this.destination = null;
                this.$onInit = function () {
                    if(this.coordinates){
                        this.destination = this.coordinates.longitude + ',' + this.coordinates.latitude;
                    }
                    else if(this.address){
                        this.destination = this.address.street + ', ' + this.address.postcode + ' ' + this.address.city;
                    }
                };
            }
        })
    ;

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('jhiItemCount', {
            template: '<div class="info">' +
                '{{(($ctrl.page-1) * ($ctrl.pageSize || 50))==0 ? 1:(($ctrl.page-1) * ($ctrl.pageSize || 50))}} - ' +
                '{{($ctrl.page * ($ctrl.pageSize || 50)) < $ctrl.queryCount ? ($ctrl.page * ($ctrl.pageSize || 50)) : $ctrl.queryCount}} ' +
                'z {{$ctrl.queryCount}} rekordów' +
                '</div>',
            bindings: {
                page: '<',
                queryCount: '<total',
                pageSize: '<pagesize'
            }
        });
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('focusElement', function ($timeout) {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, element) {
                    $timeout(function () {
                        element.focus();
                    }, 100);
                }
            };
        });
}());

;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('fieldSearch', function () {
            return {
                template: '<div class="input-group input-group-sm">\n' +
                    '                <span class="input-group-addon" translate-attr="{ title: \'entity.action.search\' }"><i class="fas fa-search fa-fw"></i></span>\n' +
                    '                <input ng-model="modelValue" id="searchQuery" type="text" placeholder="{{ \'entity.action.search-placeholder\' | translate }}" ng-keyup="$event.keyCode == 13 && onEnter()" class="form-control">\n' +
                    '                <div class="input-group-btn">\n' +
                    '                    <button type="button" class="btn btn-default" ng-click="clear()" ng-disabled="!modelValue">\n' +
                    '                        <i class="far fa-trash-alt trash-clear"></i>\n' +
                    '                    </button>\n' +
                    '                    <button class="btn btn-default btn-success" type="button" ng-click="click()">\n' +
                    '                        <i class="fas fa-paper-plane"></i>\n' +
                    '                    </button>\n' +
                    '                </div>\n' +
                    '            </div>',
                scope: {
                },
                require: '^ngModel',
                link: function(scope, $element, $attrs, ngModelCtrl){

                    scope.clear = function () {
                        delete scope.modelValue;
                        scope.setValue();
                    };

                    scope.click = function () {
                        if(scope.buttonType !== 'submit')
                            scope.setValue();
                    };

                    scope.setValue = function(){
                        ngModelCtrl.$setViewValue(scope.modelValue);
                        ngModelCtrl.$validate();
                    };

                    ngModelCtrl.$render = function() {
                        scope.modelValue = ngModelCtrl.$viewValue;
                    };

                    scope.onEnter = function () {
                        scope.setValue();
                    };
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('DateUtils', function ($filter) {

            return {
                convertDateTimeFromServer: convertDateTimeFromServer,
                convertLocalDateFromServer: convertLocalDateFromServer,
                convertLocalDateToServer: convertLocalDateToServer,
                dateformat: dateformat
            };

            function convertDateTimeFromServer (date) {
                if (date) {
                    return new Date(date);
                } else {
                    return null;
                }
            }

            function convertLocalDateFromServer (date) {
                if (date) {
                    var dateString = date.split('-');
                    return new Date(dateString[0], dateString[1] - 1, dateString[2]);
                }
                return null;
            }

            function convertLocalDateToServer (date) {
                if (date) {
                    return $filter('date')(date, 'yyyy-MM-dd');
                } else {
                    return null;
                }
            }

            function dateformat () {
                return 'yyyy-MM-dd';
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('DataUtils', function ($window) {

            return {
                abbreviate: abbreviate,
                byteSize: byteSize,
                openFile: openFile,
                toBase64: toBase64
            };

            function abbreviate (text) {
                if (!angular.isString(text)) {
                    return '';
                }
                if (text.length < 30) {
                    return text;
                }
                return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
            }

            function byteSize (base64String) {
                if (!angular.isString(base64String)) {
                    return '';
                }

                function endsWith(suffix, str) {
                    return str.indexOf(suffix, str.length - suffix.length) !== -1;
                }

                function paddingSize(base64String) {
                    if (endsWith('==', base64String)) {
                        return 2;
                    }
                    if (endsWith('=', base64String)) {
                        return 1;
                    }
                    return 0;
                }

                function size(base64String) {
                    return base64String.length / 4 * 3 - paddingSize(base64String);
                }

                function formatAsBytes(size) {
                    return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
                }

                return formatAsBytes(size(base64String));
            }

            function openFile (type, data) {
                $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
            }

            function toBase64 (file, cb) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = function (e) {
                    var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                    cb(base64Data);
                };
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .filter('capitalize', function () {
            return capitalizeFilter;

            function capitalizeFilter (input) {
                if (input !== null) {
                    input = input.toLowerCase();
                }
                return input.substring(0, 1).toUpperCase() + input.substring(1);
            }
        });

})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('awizApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('avSort', function () {
            return {
                restrict: 'A',
                scope: {
                    sortBy: '=avSort',
                    predicate: '=',
                    ascending: '=',
                    callback: '&'
                },
                controllerAs: 'vm',
                bindToController: true,
                controller: function ($scope, $element) {
                    var vm = this;

                    $element.bind('click', function () {
                        sort(vm.sortBy);
                    });

                    vm.resetClasses = function () {
                        var allThIcons = $element.find('span.glyphicon'),
                            sortIcon = 'glyphicon-sort',
                            sortAsc = 'glyphicon-sort-by-attributes',
                            sortDesc = 'glyphicon-sort-by-attributes-alt';

                        allThIcons.removeClass(sortAsc + ' ' + sortDesc);
                        allThIcons.addClass(sortIcon);
                    };

                    vm.triggerApply = function (values)  {
                        vm.resetClasses();
                        if (values && values[0] !== '_score') {
                            vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
                        }
                    };

                    $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
                    vm.triggerApply();

                    function sort(column){
                        if(vm.predicate === column){
                            vm.ascending = !vm.ascending;
                        }
                        else{
                            vm.predicate = column;
                            vm.ascending = true;
                        }
                        vm.resetClasses();
                        $scope.$apply();
                    }

                }
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('daysOff', {
            bindings: {
                year: '<',
                items: '<'
            },
            templateUrl: 'app/entities/day-off/list.html',
            controller: function ($state, DayOff, DayOffDialogService, ConfirmDialogService, AlertService) {
                var ctrl = this;

                ctrl.$onInit = function () {
                    ctrl.selectedYear = parseInt(ctrl.year, 10);
                };

                ctrl.selectYear = function () {
                    var year = parseInt(ctrl.selectedYear, 10);
                    if (year >= 2020 && year <= 2100) {
                        $state.go('dayOff', {year: year});
                    }
                };

                ctrl.changeYear = function (offset) {
                    ctrl.selectedYear = parseInt(ctrl.selectedYear, 10) + offset;
                    ctrl.selectYear();
                };

                ctrl.importYear = function () {
                    var year = parseInt(ctrl.selectedYear, 10);
                    return ConfirmDialogService.open({
                        messageTranslated: {
                            key: 'dayOff.importQuestion',
                            params: {year: year}
                        },
                        confirmPromise: function () {
                            return DayOff.importYear({year: year}, {}).$promise.then(function (result) {
                                AlertService.success('dayOff.importSuccess', {
                                    year: result.year,
                                    importedCount: result.importedCount,
                                    skippedCount: result.skippedCount,
                                    availableCount: result.availableCount
                                });
                            });
                        }
                    }).then(reload);
                };

                ctrl.create = function () {
                    DayOffDialogService.open({id: null, date: moment().format('YYYY-MM-DD')}).then(reload);
                };

                ctrl.edit = function (item) {
                    DayOffDialogService.open(item).then(reload);
                };

                ctrl.delete = function (item) {
                    ConfirmDialogService.open({
                        messageTranslated: {
                            key: 'dayOff.deleteQuestion',
                            params: {param: item.date}
                        },
                        confirmPromise: function () {
                            return DayOff.delete({id: item.id}).$promise;
                        }
                    }).then(reload);
                };

                function reload() {
                    return $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('dayOff', {
                parent: 'entity',
                url: '/day-off?{year:int}',
                data: {
                    authorities: ['ROLE_OWNER']
                },
                views: {
                    'content@': 'daysOff'
                },
                params: {
                    year: {
                        value: moment().year(),
                        squash: true
                    }
                },
                resolve: {
                    year: function ($transition$) {
                        return selectedYear($transition$);
                    },
                    items: function (DayOff, $transition$) {
                        return DayOff.query({year: selectedYear($transition$)}).$promise;
                    }
                }
            });

            function selectedYear($transition$) {
                var year = parseInt($transition$.params().year, 10);
                return isNaN(year) ? moment().year() : year;
            }
        });
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('DayOff', function ($resource) {
            return $resource('api/day-off/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'importYear': {method: 'POST', url: 'api/day-off/import'}
            });
        })
        .service('DayOffDialogService', function ($uibModal) {
            this.open = function (item) {
                return $uibModal.open({
                    templateUrl: 'app/entities/day-off/dialog.html',
                    controller: 'DayOffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        item: function () {
                            return angular.copy(item || {id: null});
                        }
                    }
                }).result;
            };
        });
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('DayOffDialogController', function ($uibModalInstance, DayOff, item) {
            var vm = this;
            vm.item = item;

            vm.save = function () {
                var request = vm.item.id
                    ? DayOff.update({id: vm.item.id}, vm.item).$promise
                    : DayOff.save(vm.item).$promise;
                return request.then(function (result) {
                    $uibModalInstance.close(result);
                });
            };

            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', 'amMoment', 'tmhDynamicLocale', 'Principal'];

    function translationHandler($rootScope, $window, $state, $translate, amMoment, tmhDynamicLocale, Principal) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function(e, languageObj) {
                updateTitle();
                changeLocaleDependencies(languageObj.language);
            });

            $rootScope.$watch(function() {
                return Principal.isAuthenticated();
            }, function() {
                Principal.identity().then(function (account) {
                    if (account!== null) {
                        $translate.use(account.language);
                    }
                });
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        function changeLocaleDependencies(languageKey) {
            if(languageKey){
                amMoment.changeLocale(languageKey, {});
                tmhDynamicLocale.set(languageKey);
            }
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($translateProvider, tmhDynamicLocaleProvider) {
            // Initialize angular-translate
            $translateProvider.preferredLanguage('pl');
            $translateProvider.registerAvailableLanguageKeys([
                'en',
                'pl'
            ], {
                'en': 'en',
                'en_*': 'en',
                'en-*': 'en',
                'pl': 'pl',
                'pl_*': 'pl',
                'pl-*': 'pl'
            });
            $translateProvider.determinePreferredLanguage();
            $translateProvider.useStorage('translationStorageProvider');
            $translateProvider.useSanitizeValueStrategy('escaped');
            $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
            $translateProvider.useLoader('$translatePartialLoader', {
                urlTemplate: 'i18n/{lang}/{part}.json'
            });

            tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
            tmhDynamicLocaleProvider.useStorage('translationStorageProvider');
            tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('translationStorageProvider', function ($cookies, $log, LANGUAGES) {
            return {
                get: get,
                put: put
            };

            function get(name) {
                if (LANGUAGES.indexOf($cookies.get(name)) === -1) {
                    // $log.info('Resetting invalid cookie language "' + $cookies.get(name) + '" to prefered language "pl"');
                    // $cookies.put(name, 'pl');
                }
                return $cookies.get(name);
            }

            function put(name, value) {
                $cookies.put(name, value);
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function (nyaBsConfigProvider) {
            nyaBsConfigProvider.setLocalizedText("pl", {
                defaultNoneSelection: '-- wybierz --',
                noSearchResult: 'brak rekordów',
                numberItemSelected: 'Zaznaczono - %d ',
                selectAll: 'Zaznacz wszystko',
                deselectAll: 'Odznacz wszystko'
            });
            nyaBsConfigProvider.setLocalizedText("en", {
                defaultNoneSelection: '-- select --',
                noSearchResult: 'no records',
                numberItemSelected: 'Selected - %d ',
                selectAll: 'Select all',
                deselectAll: 'Deselect all'
            });
        })
        .config(function (amoMultiselectConfig) {
            amoMultiselectConfig.deselectAllText = "Odznacz wszystko";
            amoMultiselectConfig.filterText = "Szukaj...";
            amoMultiselectConfig.selectAllText = "Zaznacz wszystko";
            amoMultiselectConfig.selectText = "wybierz...";
            amoMultiselectConfig.selectedSuffixSingularText = " poz. ";
            amoMultiselectConfig.selectedSuffixText = " poz. ";
        })
        .factory('JhiLanguageService', function ($q, $http, $translate, LANGUAGES) {
            return {
                getAll: getAll,
                getCurrent: getCurrent
            };

            function getAll() {
                var deferred = $q.defer();
                deferred.resolve(LANGUAGES);
                return deferred.promise;
            }

            function getCurrent() {
                var deferred = $q.defer();
                var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

                deferred.resolve(language);

                return deferred.promise;
            }

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .filter('findLanguageFromKey', function () {
            return findLanguageFromKeyFilter;

            function findLanguageFromKeyFilter(lang) {
                return {
                    'ca': 'Català',
                    'cs': 'Český',
                    'da': 'Dansk',
                    'de': 'Deutsch',
                    'el': 'Ελληνικά',
                    'en': 'English',
                    'es': 'Español',
                    'fr': 'Français',
                    'gl': 'Galego',
                    'hu': 'Magyar',
                    'hi': 'हिंदी',
                    'it': 'Italiano',
                    'ja': '日本語',
                    'ko': '한국어',
                    'mr': 'मराठी',
                    'nl': 'Nederlands',
                    'pl': 'Polski',
                    'pt-br': 'Português (Brasil)',
                    'pt-pt': 'Português',
                    'ro': 'Română',
                    'ru': 'Русский',
                    'sk': 'Slovenský',
                    'sv': 'Svenska',
                    'ta': 'தமிழ்',
                    'tr': 'Türkçe',
                    'zh-cn': '中文（简体）',
                    'zh-tw': '繁體中文'
                }[lang];
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            "pl",
            "en"
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function (uibPaginationConfig, paginationConstants) {
            uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
            uibPaginationConfig.maxSize = 5;
            uibPaginationConfig.boundaryLinks = true;
            uibPaginationConfig.firstText = '«';
            uibPaginationConfig.previousText = '‹';
            uibPaginationConfig.nextText = '›';
            uibPaginationConfig.lastText = '»';
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function (uibPagerConfig, paginationConstants) {
            uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
            uibPagerConfig.previousText = '«';
            uibPagerConfig.nextText = '»';
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('showValidation', function () {
            return {
                restrict: 'A',
                require: 'form',
                link: linkFunc
            };

            function linkFunc (scope, element) {
                element.find('.form-group').each(function() {
                    var $formGroup = angular.element(this);
                    var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                    if ($inputs.length > 0) {
                        $inputs.each(function() {
                            var $input = angular.element(this);
                            scope.$watch(function() {
                                return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                            }, function(isInvalid) {
                                $formGroup.toggleClass('has-error', isInvalid);
                            });
                        });
                    }
                });
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('minbytes', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: linkFunc
            };

            function linkFunc (scope, element, attrs, ngModel) {
                if (!ngModel) {
                    return;
                }

                ngModel.$validators.minbytes = function (modelValue) {
                    return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
                };
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function numberOfBytes(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('maxbytes', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: linkFunc
            };

            function linkFunc (scope, element, attrs, ngModel) {
                if (!ngModel) {
                    return;
                }

                ngModel.$validators.maxbytes = function (modelValue) {
                    return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
                };
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function numberOfBytes(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('DateRangePickerConfig', function ($translate) {
            var def = {
                ranges: {},
                locale: {
                    applyLabel: $translate.instant("entity.action.save"),
                    cancelLabel: $translate.instant("entity.action.clear"),
                    fromLabel: $translate.instant("select.from"),
                    toLabel: $translate.instant("select.to"),
                    customRangeLabel: $translate.instant("select.custom-range"),
                    firstDay: 1
                },
                format: 'YYYY-MM-DD'
            };

            var TODAY = $translate.instant("select.today");
            var YESTERDAY = $translate.instant("select.yesterday");
            var THIS_WEEK = $translate.instant("select.this-week");
            var LAST_WEEK = $translate.instant("select.last-week");
            var LAST_7D = $translate.instant("select.last-7D");
            var LAST_30D = $translate.instant("select.last-30D");
            var THIS_MONTH = $translate.instant("select.this-month");
            var LAST_MONTH = $translate.instant("select.last-month");
            var THIS_QUARTER = $translate.instant("select.this-quarter");
            var LAST_QUARTER = $translate.instant("select.last-quarter");

            def.ranges[TODAY] = [ moment(), moment() ];
            def.ranges[YESTERDAY] = [ moment().subtract(1, 'days'), moment().subtract(1, 'days') ];
            def.ranges[THIS_WEEK] = [ moment().startOf('week'), moment().endOf('week') ];
            def.ranges[LAST_WEEK] = [ moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week') ];
            def.ranges[LAST_7D] = [ moment().subtract(6, 'days'), moment() ];
            def.ranges[LAST_30D] = [ moment().subtract(29, 'days'), moment() ];
            def.ranges[THIS_MONTH] = [ moment().startOf('month'), moment().endOf('month') ];
            def.ranges[LAST_MONTH] = [ moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month') ];
            def.ranges[THIS_QUARTER] = [ moment().startOf('quarter'), moment().endOf('quarter') ];
            def.ranges[LAST_QUARTER] = [ moment().subtract(1, "Q").startOf('quarter'), moment().subtract(1, "Q").endOf('quarter') ];

            return {
                get: get
            };

            function get(override) {
                var result = angular.copy(def);
                angular.extend(result, override);
                return result;
            }

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('currentDatetime', function ($interval) {
            return {
                scope: {
                    timezone: "="
                },
                restrict: 'AE',
                template: '<span ng-if="timezone">{{currentTime | amTimezone:timezone | amDateFormat:format}}</span>',
                link: function(scope) {
                    scope.currentTime = moment();

                    var currentTimeInterval = $interval(function () {
                        scope.currentTime = moment();
                    }, 1000);

                    scope.$on('$destroy', function () {
                        $interval.cancel(currentTimeInterval);
                    });
                }
            };
        });
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('bindHtmlCompile', function ($compile) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    scope.$watch(function () {
                        return scope.$eval(attrs.bindHtmlCompile);
                    }, function (value) {
                        // Incase value is a TrustedValueHolderType, sometimes it
                        // needs to be explicitly called into a string in order to
                        // get the HTML string.
                        element.html(value && value.toString());
                        // If scope is provided use it, otherwise use parent scope
                        var compileScope = scope;
                        if (attrs.bindHtmlScope) {
                            compileScope = scope.$eval(attrs.bindHtmlScope);
                        }
                        $compile(element.contents())(compileScope);
                    });
                }
            };
        })
        .provider('ConfirmDialogService', function () {
            /*jshint validthis: true */
            this.$get = function ($timeout, $sce, $translate, toaster, $uibModal) {
                var defaultParams = {
                    header: $translate.instant("entity.confirm.title"),
                    message: $translate.instant("entity.confirm.message"),
                    confirmPromise: function () {
                        return $q.defer().promise;
                    },
                    confirmedSuccess: function () {

                    },
                    confirmedError: function () {

                    }
                };

                return {
                    open: open
                };

                function open(params) {

                    angular.extend(defaultParams, params);
                    if (defaultParams.messageTranslated) {
                        defaultParams.message = $translate.instant(defaultParams.messageTranslated.key, defaultParams.messageTranslated.params);
                    }

                    return $uibModal.open({
                        templateUrl: 'app/components/confirm-dialog/confirm-dialog.html',
                        controller: function ($uibModalInstance, params) {
                            var vm = this;
                            vm.params = params;

                            vm.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                            vm.confirm = function () {
                                vm.processPromise = defaultParams.confirmPromise();
                                vm.processPromise
                                    .then(function () {
                                        $uibModalInstance.close(true);
                                        defaultParams.confirmedSuccess();
                                    })
                                    .catch(function (reason) {
                                        defaultParams.confirmedError();
                                    });
                            };
                        },
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            params: defaultParams
                        }
                    }).result;
                }

            };

        });


})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('checkList', function () {
            return {
                scope: {
                    list: '=checkList',
                    value: '@'
                },
                link: function(scope, elem, attrs) {
                    var handler = function(setup) {
                        var checked = elem.prop('checked');
                        var index = scope.list.indexOf(scope.value);

                        if (checked && index == -1) {
                            if (setup) elem.prop('checked', false);
                            else scope.list.push(scope.value);
                        } else if (!checked && index != -1) {
                            if (setup) elem.prop('checked', true);
                            else scope.list.splice(index, 1);
                        }
                    };

                    var setupHandler = handler.bind(null, true);
                    var changeHandler = handler.bind(null, false);

                    elem.bind('change', function() {
                        scope.$apply(changeHandler);
                    });
                    scope.$watch('list', setupHandler, true);
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('auditInfo', function () {
            return {
                scope: {
                    audit: "="
                },
                restrict: 'AE',
                templateUrl: 'app/components/audit-info/audit-info.html',
                link: function(scope, $element, $attrs) {

                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('notificationInterceptor', function ($q, AlertService) {
            return {
                response: response
            };

            function response (response) {
                var alertKey = response.headers('x-awizApp-alert');
                if (angular.isString(alertKey)) {
                    AlertService.success(alertKey, { param : response.headers('x-awizApp-params')});
                }
                return response;
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('errorHandlerInterceptor', function ($q, $rootScope) {
            return {
                responseError: responseError
            };

            function responseError (response) {
                if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                    $rootScope.$emit('awizApp.httpError', response);
                }

                return $q.reject(response);
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('authExpiredInterceptor', function ($rootScope, $q, $injector, $document, $state) {
            var service = {
                responseError: responseError
            };

            return service;

            function responseError(response) {
                // If we have an unauthorized request we redirect to the login page
                // Don't do this check on the account API to avoid infinite loop
                if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize().then(function (account) {
                        if(account == null){
                            $state.go('login');
                        }
                    });
                } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                    // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                    var $http = $injector.get('$http');
                    return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
                }
                return $q.reject(response);
            }

            function getCSRF() {
                var doc = $document[0];
                if (doc) {
                    var name = 'CSRF-TOKEN=';
                    var ca = doc.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) === ' ') {c = c.substring(1);}

                        if (c.indexOf(name) !== -1) {
                            return c.substring(name.length, c.length);
                        }
                    }
                }
                return '';
            }

            function afterCSRFRenewed(oldResponse) {
                if (getCSRF() !== '') {
                    // retry the old request after the new CSRF-TOKEN is obtained
                    var $http = $injector.get('$http');
                    return $http(oldResponse.config);
                } else {
                    // unlikely get here but reject with the old response any way and avoid infinite loop
                    return $q.reject(oldResponse);
                }
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate', 'toaster'];

        function getService ($timeout, $sce, $translate, toaster) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 2500; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                toaster.pop({
                    type: alertOptions.type,
                    body: alertOptions.msg,
                    bodyOutputType: 'trustedHtml',
                    timeout: alertOptions.timeout,
                    showCloseButton: true
                });

                // alertOptions.alertId = alertId++;
                // alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                // var that = this;
                // var alert = this.factory(alertOptions);
                // if (alertOptions.timeout && alertOptions.timeout > 0) {
                //     $timeout(function () {
                //         that.closeAlert(alertOptions.alertId, extAlerts);
                //     }, alertOptions.timeout);
                // }
                // return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('jhiAlertError', {
            template: '',
            controller: function ($scope, AlertService, $rootScope, $translate) {
                var vm = this;

                vm.alerts = [];

                function addErrorAlert(message, key, data) {
                    key = key && key !== null ? key : message;
                    vm.alerts.push(
                        AlertService.add(
                            {
                                type: 'danger',
                                msg: key,
                                params: data,
                                timeout: 5000,
                                toast: AlertService.isToast(),
                                scoped: true
                            },
                            vm.alerts
                        )
                    );
                }

                var cleanHttpErrorListener = $rootScope.$on('awizApp.httpError', function (event, httpResponse) {
                    var i;
                    event.stopPropagation();
                    switch (httpResponse.status) {
                        // connection refused, server not reachable
                        case -1:
                            addErrorAlert('No connection', 'error.no-connection');
                            break;
                        case 0:
                            addErrorAlert('Server not reachable', 'error.server.not.reachable');
                            break;

                        case 400:
                            var errorHeader = httpResponse.headers('X-awizApp-error');
                            var entityKey = httpResponse.headers('X-awizApp-params');
                            if (errorHeader) {
                                var entityName = $translate.instant('global.menu.entities.' + entityKey);
                                addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                            } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                                for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                                    var fieldError = httpResponse.data.fieldErrors[i];
                                    // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                                    var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                                    var fieldName = $translate.instant('validation.' + fieldError.objectName + '.' + convertedField);
                                    addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                                }
                            } else if (httpResponse.data && httpResponse.data.message && httpResponse.data.params) {
                                // var messageTranslated = $translate.instant(httpResponse.data.message, httpResponse.data.params);
                                addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                            } else {
                                addErrorAlert(httpResponse.data);
                            }
                            break;

                        default:
                            if (httpResponse.data && httpResponse.data.message) {
                                var messageTranslated = $translate.instant(httpResponse.data.message, httpResponse.data.params);
                                addErrorAlert(messageTranslated);
                            } else {
                                var message = angular.toJson(httpResponse);
                                console.log(message);
                                // addErrorAlert(message);
                            }
                    }
                });

                $scope.$on('$destroy', function () {
                    if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                        cleanHttpErrorListener();
                        vm.alerts = [];
                    }
                });
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('stateHandler', function ($rootScope, $state, translationHandler, Auth, Principal, ENV, VERSION, $transitions) {
            return {
                initialize: initialize
            };

            function initialize() {
                $transitions.onBefore({}, function (transition) {
                    if (transition.from() !== transition.to()) {
                        $rootScope.globalStateIsLoading = true;
                    }

                    var params = transition.to().data;
                    if (params && params.authorities && params.authorities.length > 0) {
                        if (Principal.isIdentityResolved()) {
                            return afterIdentityResolved();
                        } else {
                            return Auth.authorize().then(afterIdentityResolved);
                        }
                    }

                    function afterIdentityResolved() {
                        var hasRequiredAuthority = Principal.hasAnyAuthority(params.authorities);
                        if (hasRequiredAuthority === false) {
                            if (Principal.isAuthenticated()) {
                                return transition.router.stateService.target('accessdenied', undefined);
                            } else {
                                return transition.router.stateService.target('login', undefined, {location: false});
                            }
                        }
                    }
                });

                $transitions.onSuccess({}, function (transition) {
                    var titleKey = 'global.title';
                    var params = transition.to().data;
                    if (params && params.pageTitle) {
                        titleKey = params.pageTitle;
                        translationHandler.updateTitle(titleKey);
                    }

                    if (transition.from() !== transition.to()) {
                        $rootScope.globalStateIsLoading = false;
                    }
                });

                $transitions.onError({}, function (transition) {
                    if (transition.from() !== transition.to()) {
                        $rootScope.globalStateIsLoading = false;
                    }
                });

                $rootScope.ENV = ENV;
                $rootScope.VERSION = VERSION;
            }
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($localStorageProvider) {
            $localStorageProvider.setKeyPrefix('jhi-');
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

            //enable CSRF
            $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
            $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

            //Cache everything except rest api requests
            httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

            $urlRouterProvider.otherwise('/');

            $httpProvider.interceptors.push('errorHandlerInterceptor');
            $httpProvider.interceptors.push('authExpiredInterceptor');
            $httpProvider.interceptors.push('notificationInterceptor');

            $urlMatcherFactoryProvider.type('boolean', {
                name : 'boolean',
                decode: function(val) { return val === true || val === 'true'; },
                encode: function(val) { return val ? 1 : 0; },
                equals: function(a, b) { return this.is(a) && a === b; },
                is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
                pattern: /bool|true|0|1/
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function compileServiceConfig($compileProvider, ENV) {
            // disable debug data on prod profile to improve performance
            if(ENV === 'prod'){
                $compileProvider.debugInfoEnabled(false);
            }
            /*
            If you wish to debug an application with this information
            then you should open up a debug console in the browser
            then call this method directly in this console:

            angular.reloadWithDebugInfo();
            */
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function (AlertServiceProvider) {
            // set below to true to make alerts look like toast
            AlertServiceProvider.showAsToast(true);
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('userManagement', {
            bindings:{
                filters: '=',
                page: '=',
                currentAccount: '<'
            },
            templateUrl: 'app/admin/user-management/user-management.html',
            controller: function ($state, $uibModal, User) {
                this.setActive = function (user, isActivated) {
                    user.activated = isActivated;
                    User.update(user).$promise.then(reload);
                };

                this.logAsUser = function (user) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-loginas-dialog.html',
                        controller: 'UserManagementLoginAsController',
                        controllerAs: 'vm',
                        size: 'sm',
                        resolve: {
                            entity: function () {
                                return user;
                            }
                        }
                    });
                };

                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                function reload() {
                    $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('user-management', {
                    parent: 'admin',
                    url: '/user-management?page&sort&search&{customer:int}&size',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    views: {
                        'content@': 'userManagement'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'customer.name,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        currentAccount: function(Principal){
                            return Principal.identity();
                        },
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (User, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            User.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                })
            ;
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('UserManagementLoginAsController', function ($rootScope, $uibModalInstance, entity, Auth, AlertService, $state) {
            var vm = this;

            vm.user = entity;
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            };

            vm.confirmLoginAs = function () {
                Auth.loginAs(vm.user.email).then(function (result) {
                    AlertService.success("user.events.signed-in-as", { param : result.firstName + " " + result.lastName });
                    $uibModalInstance.close(true);
                    $state.go('home');
                });
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('jhi-metrics', {
                parent: 'admin',
                url: '/metrics',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'metrics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/metrics/metrics.html',
                        controller: 'JhiMetricsMonitoringController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('JhiMetricsService', function ($rootScope, $http) {
            return {
                getMetrics: getMetrics,
                threadDump: threadDump
            };

            function getMetrics () {
                return $http.get('metrics/metrics').then(function (response) {
                    return response.data;
                });
            }

            function threadDump () {
                return $http.get('dump').then(function (response) {
                    return response.data;
                });
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('JhiMetricsMonitoringModalController', function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
            var vm = this;

            vm.cancel = cancel;
            vm.getLabelClass = getLabelClass;
            vm.threadDump = threadDump;
            vm.threadDumpAll = 0;
            vm.threadDumpBlocked = 0;
            vm.threadDumpRunnable = 0;
            vm.threadDumpTimedWaiting = 0;
            vm.threadDumpWaiting = 0;

            angular.forEach(threadDump, function(value) {
                if (value.threadState === 'RUNNABLE') {
                    vm.threadDumpRunnable += 1;
                } else if (value.threadState === 'WAITING') {
                    vm.threadDumpWaiting += 1;
                } else if (value.threadState === 'TIMED_WAITING') {
                    vm.threadDumpTimedWaiting += 1;
                } else if (value.threadState === 'BLOCKED') {
                    vm.threadDumpBlocked += 1;
                }
            });

            vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
                vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

            function cancel () {
                $uibModalInstance.dismiss('cancel');
            }

            function getLabelClass (threadState) {
                if (threadState === 'RUNNABLE') {
                    return 'label-success';
                } else if (threadState === 'WAITING') {
                    return 'label-info';
                } else if (threadState === 'TIMED_WAITING') {
                    return 'label-warning';
                } else if (threadState === 'BLOCKED') {
                    return 'label-danger';
                }
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('JhiMetricsMonitoringController', function ($scope, JhiMetricsService, $uibModal) {
            var vm = this;

            vm.cachesStats = {};
            vm.metrics = {};
            vm.refresh = refresh;
            vm.refreshThreadDumpData = refreshThreadDumpData;
            vm.servicesStats = {};
            vm.updatingMetrics = true;

            vm.refresh();

            $scope.$watch('vm.metrics', function (newValue) {
                vm.servicesStats = {};
                vm.cachesStats = {};
                angular.forEach(newValue.timers, function (value, key) {
                    // if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                    // }
                    if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                        // remove gets or puts
                        var index = key.lastIndexOf('.');
                        var newKey = key.substr(0, index);

                        // Keep the name of the domain
                        index = newKey.lastIndexOf('.');
                        vm.cachesStats[newKey] = {
                            'name': newKey.substr(index + 1),
                            'value': value
                        };
                    }
                });
            });

            function refresh () {
                vm.updatingMetrics = true;
                JhiMetricsService.getMetrics().then(function (promise) {
                    vm.metrics = promise;
                    vm.updatingMetrics = false;
                }, function (promise) {
                    vm.metrics = promise.data;
                    vm.updatingMetrics = false;
                });
            }

            function refreshThreadDumpData () {
                JhiMetricsService.threadDump().then(function(data) {
                    $uibModal.open({
                        templateUrl: 'app/admin/metrics/metrics.modal.html',
                        controller: 'JhiMetricsMonitoringModalController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            threadDump: function() {
                                return data;
                            }
                        }
                    });
                });
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function($stateProvider) {
            $stateProvider.state('logs', {
                parent: 'admin',
                url: '/logs',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'logs.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/logs/logs.html',
                        controller: 'LogsController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('LogsService', function ($resource) {
            return $resource('api/logs', {}, {
                'findAll': {method: 'GET', isArray: true},
                'changeLevel': {method: 'PUT'}
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('LogsController', function (LogsService) {
            var vm = this;

            vm.changeLevel = function (name, level) {
                LogsService.changeLevel({name: name, level: level}, function () {
                    vm.loggers = LogsService.findAll();
                });
            };
            vm.loggers = LogsService.findAll();

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('jhi-health', {
                parent: 'admin',
                url: '/health',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'health.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/health/health.html',
                        controller: 'JhiHealthCheckController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('JhiHealthService', function ($rootScope, $http) {
            return {
                checkHealth: checkHealth
            };

            function checkHealth () {
                return $http.get('health').then(function (response) {
                    return response.data;
                });
            }
        });

})();
;
(function() {
    'use strict';

    angular.module('awizApp')
        .controller('HealthModalController', function ($uibModalInstance, currentHealth, baseName, subSystemName) {
            var vm = this;

            vm.cancel = cancel;
            vm.currentHealth = currentHealth;
            vm.baseName = baseName;
            vm.subSystemName = subSystemName;

            function cancel() {
                $uibModalInstance.dismiss('cancel');
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.addHealthObject = addHealthObject;
        vm.baseName = baseName;
        vm.flattenHealthData = flattenHealthData;
        vm.getLabelClass = getLabelClass;
        vm.getModuleName = getModuleName;
        vm.hasSubSystem = hasSubSystem;
        vm.isHealthObject = isHealthObject;
        vm.refresh = refresh;
        vm.updatingHealth = true;
        vm.separator = '.';
        vm.showHealth = showHealth;
        vm.subSystemName = subSystemName;
        vm.transformHealthData = transformHealthData;

        vm.refresh();


        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!vm.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function baseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (vm.isHealthObject(value)) {
                    if (vm.hasSubSystem(value)) {
                        vm.addHealthObject(result, false, value, vm.getModuleName(path, key));
                        vm.flattenHealthData(result, vm.getModuleName(path, key), value);
                    } else {
                        vm.addHealthObject(result, true, value, vm.getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + vm.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = vm.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  vm.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

        function subSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        function transformHealthData (data) {
            var response = [];
            vm.flattenHealthData(response, null, data);
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('docs', {
                parent: 'admin',
                url: '/docs',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'docs.page-title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/docs/docs.html'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('customerManagement', {
            bindings:{
                filters: '=',
                page: '='
            },
            templateUrl: 'app/admin/customer-management/list.html',
            controller: function ($state, CustomerService) {
                this.add = function(){
                    CustomerService.add().then(reload);
                };
                this.edit = function (id) {
                    CustomerService.edit(id).then(reload);
                };
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                function reload() {
                    $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('customer-management', {
                    parent: 'admin',
                    url: '/customer-management?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    views: {
                        'content@': 'customerManagement'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (Customer, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            Customer.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                });
        });

})();
;
(function () {
    'use strict';
    angular
        .module('awizApp')
        .service('CustomerService', function ($uibModal) {
            this.add = function () {
                return $uibModal.open({
                    templateUrl: 'app/admin/customer-management/new-account.html',
                    controller: 'CustomerNewAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result;
            };

            this.edit = function (id) {
                return $uibModal.open({
                    templateUrl: 'app/admin/customer-management/dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        id: function () {
                            return id;
                        }
                    }
                }).result;
            };
        })
        .factory('Customer', function ($resource) {
            return $resource('api/customer/:id', {}, {
                query: {method: 'GET', isArray: true},
                update: {method: 'PUT'},
                autocomplete: {url: 'api/admin/customer-autocomplete', isArray: true}
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('CustomerNewAccountDialogController', function ($timeout, $scope, $uibModalInstance, Customer) {
            var vm = this;
            vm.newAccount = {};

            vm.save = function () {
                return Customer.save(vm.newAccount, onSaveSuccess).$promise;
                function onSaveSuccess(result) {
                    $uibModalInstance.close(result);
                }
            };

            vm.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        });
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('CustomerDialogController', function ($timeout, $scope, id, $uibModalInstance, Customer) {
            var vm = this;

            Customer.get({id: id}).$promise
                .then(function (data) {
                    vm.customerAccount = data;
                });

            vm.save = function () {
                var params = {
                    id: vm.customerAccount.customer.id,
                    slots: vm.customerAccount.customer.slots
                };
                return Customer.update(params, onSaveSuccess, onSaveError).$promise;

                function onSaveSuccess(result) {
                    $uibModalInstance.close(result);
                }

                function onSaveError() {}
            };

            vm.close = function() {
                $uibModalInstance.dismiss('cancel');
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('jhi-configuration', {
                parent: 'admin',
                url: '/configuration',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'configuration.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/configuration/configuration.html',
                        controller: 'JhiConfigurationController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('JhiConfigurationService', function ($filter, $http) {
            var service = {
                get: get,
                getEnv: getEnv
            };

            return service;

            function get () {
                return $http.get('configprops').then(getConfigPropsComplete);

                function getConfigPropsComplete (response) {
                    var properties = [];
                    angular.forEach(response.data, function (data) {
                        properties.push(data);
                    });
                    var orderBy = $filter('orderBy');
                    return orderBy(properties, 'prefix');
                }
            }

            function getEnv () {
                return $http.get('env').then(getEnvComplete);

                function getEnvComplete (response) {
                    var properties = {};
                    angular.forEach(response.data, function (val,key) {
                        var vals = [];
                        angular.forEach(val, function (v,k) {
                            vals.push({ key:k, val:v });
                        });
                        properties[key] = vals;
                    });
                    return properties;
                }
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('JhiConfigurationController', function (filter,JhiConfigurationService) {
            var vm = this;

            vm.allConfiguration = null;
            vm.configuration = null;

            JhiConfigurationService.get().then(function(configuration) {
                vm.configuration = configuration;
            });
            JhiConfigurationService.getEnv().then(function (configuration) {
                vm.allConfiguration = configuration;
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('audits', {
                parent: 'admin',
                url: '/audits',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'audits.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/audits/audits.html',
                        controller: 'AuditsController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .factory('AuditsService', function ($resource) {
            return $resource('api/audits/:id', {}, {
                'get': { method: 'GET', isArray: true },
                'query': { method: 'GET', isArray: true, params: {fromDate: null, toDate: null} }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('AuditsController', function ($filter, AuditsService, ParseLinks) {
            var vm = this;

            vm.audits = null;
            vm.fromDate = null;
            vm.links = null;
            vm.loadPage = loadPage;
            vm.onChangeDate = onChangeDate;
            vm.page = 1;
            vm.pageSize = 50;
            vm.previousMonth = previousMonth;
            vm.toDate = null;
            vm.today = today;
            vm.totalItems = null;

            vm.today();
            vm.previousMonth();
            vm.onChangeDate();

            function onChangeDate () {
                var dateFormat = 'yyyy-MM-dd';
                var fromDate = $filter('date')(vm.fromDate, dateFormat);
                var toDate = $filter('date')(vm.toDate, dateFormat);

                AuditsService.query({page: vm.page -1, size: vm.pageSize, fromDate: fromDate, toDate: toDate}, function(result, headers){
                    vm.audits = result;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                });
            }

            // Date picker configuration
            function today () {
                // Today + 1 day - needed if the current day must be included
                var today = new Date();
                vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            }

            function previousMonth () {
                var fromDate = new Date();
                if (fromDate.getMonth() === 0) {
                    fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
                } else {
                    fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
                }

                vm.fromDate = fromDate;
            }

            function loadPage (page) {
                vm.page = page;
                vm.onChangeDate();
            }
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('settings', {
            bindings: {
                settingsAccount: '<'
            },
            templateUrl: 'app/account/settings/settings.html',
            controller: function ($translate, Auth, Principal) {
                this.save = function () {
                    Auth.updateAccount(this.settingsAccount).then(function() {
                        Principal.identity(true).then(function(account) {
                            $translate.use(account.language);
                        });
                    });
                };
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('settings', {
                parent: 'account',
                url: '/settings',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': 'settings'
                },
                resolve: {
                    settingsAccount: function (Principal) {
                        return Principal.identity().then(function(account) {
                            return {
                                firstName: account.firstName,
                                lastName: account.lastName,
                                email: account.email,
                                language: account.language
                            };
                        });
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('sessions', {
                parent: 'account',
                url: '/sessions',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'sessions.page-title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/sessions/sessions.html',
                        controller: 'SessionsController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('SessionsController', function (Sessions, Principal) {
            var vm = this;

            vm.account = null;
            vm.error = null;
            vm.invalidate = function (series) {
                Sessions.delete({series: encodeURIComponent(series)},
                    function () {
                        vm.error = null;
                        vm.success = 'OK';
                        vm.sessions = Sessions.getAll();
                    },
                    function () {
                        vm.success = null;
                        vm.error = 'ERROR';
                    });
            };

            vm.sessions = Sessions.getAll();
            vm.success = null;

            Principal.identity().then(function(account) {
                vm.account = account;
            });

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('password', {
                parent: 'account',
                url: '/password',
                data: {
                    authorities: [],
                    pageTitle: 'password.page-title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/password/password.html',
                        controller: 'PasswordController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('PasswordController', function (Auth, Principal) {
            var vm = this;

            vm.changePassword = changePassword;
            vm.doNotMatch = null;
            vm.error = null;
            vm.success = null;

            Principal.identity().then(function(account) {
                vm.account = account;
            });

            function changePassword () {
                if (vm.password !== vm.confirmPassword) {
                    vm.error = null;
                    vm.success = null;
                    vm.doNotMatch = 'ERROR';
                } else {
                    vm.doNotMatch = null;
                    Auth.changePassword(vm.password).then(function () {
                        vm.error = null;
                        vm.success = 'OK';
                    }).catch(function () {
                        vm.success = null;
                        vm.error = 'ERROR';
                    });
                }
            }
        });

})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('awizApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength"></small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('company', {
                parent: 'account',
                url: '/company',
                data: {
                    authorities: ['ROLE_OWNER'],
                    pageTitle: 'user.organization-settings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/company/company.html',
                        controller: 'CompanyController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('fileUpload', function () {
            return {
                scope: true,        //create a new scope
                link: function (scope, el, attrs) {
                    el.bind('change', function (event) {
                        var files = event.target.files;
                        //iterate files since 'multiple' may be specified on the element
                        for (var i = 0; i < files.length; i++) {
                            //emit event upward
                            scope.$emit("fileSelected", {file: files[i]});
                        }
                    });
                }
            };
        })
        .factory('AccountCustomer', function ($resource) {
            return $resource('api/account-customer/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'update': {method: 'PUT'},
                'autocomplete': {url: 'api/customer-autocomplete', isArray: true}
            });
        })
        .controller('CompanyController', function ($scope, Principal, AccountCustomer, OrganizationSettings) {
            var vm = this;

            Principal.identity().then(function (account) {
                vm.item = angular.copy(account.customer);
            });

            vm.hasSlots = Principal.hasSlots;

            vm.loadOrganizationSettings = function () {
                OrganizationSettings.get().$promise.then(function (data) {
                    vm.organizationSettings = data;
                });
            };

            vm.saveOrganization = function () {
                return AccountCustomer.update(vm.item).$promise.then(function () {
                    Principal.identity(true).then(function (account) {
                        vm.item = angular.copy(account.customer);
                    });
                });
            };


            $scope.$on("fileSelected", function (event, args) {
                $scope.$apply(function () {
                    //add the file object to the scope's files collection
                    vm.newPrivacyPolicy = {
                        file : args.file
                    };
                });
            });

            vm.saveOrganizationSettings = function () {
                return OrganizationSettings.updatePrivacyPolicy({}, vm.newPrivacyPolicy).$promise.then(function () {
                    delete vm.newPrivacyPolicy;
                    vm.loadOrganizationSettings();
                });
            };
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('register', {
                parent: 'account',
                url: '/register',
                data: {
                    authorities: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .controller('RegisterController', function ($translate, Auth) {
            var vm = this;

            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.registerAccount = {};
            vm.success = null;

            vm.register = function () {
                if (vm.registerAccount.password !== vm.confirmPassword) {
                    vm.doNotMatch = 'ERROR';
                } else {
                    vm.registerAccount.langKey = $translate.use();
                    vm.doNotMatch = null;
                    vm.error = null;
                    vm.errorUserExists = null;
                    vm.errorEmailExists = null;

                    Auth.createAccount(vm.registerAccount).then(function () {
                        vm.success = 'OK';
                    }).catch(function (response) {
                        vm.success = null;
                        vm.error = 'ERROR';
                    });
                }
            };

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('activate', {
                parent: 'account',
                url: '/activate?key',
                data: {
                    authorities: [],
                    pageTitle: 'activate.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/activate/activate.html',
                        controller: 'ActivationController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('ActivationController', ActivationController);

    function ActivationController($stateParams, Auth) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

    }
})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('users', {
            bindings: {
                filters: '=',
                page: '=',
                currentAccount: '<'
            },
            templateUrl: 'app/user/user.html',
            controller: function ($state, UserService) {
                this.add = function(){
                    UserService.add().then(reload);
                };
                this.edit = function(id){
                    UserService.edit(id).then(reload);
                };
                this.delete = function (item) {
                    UserService.delete(item.id, item).then(reload);
                };
                this.submit = function () {
                    $state.go($state.current, this.filters);
                };
                function reload() {
                    $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider
                .state('user', {
                    parent: 'entity',
                    url: '/user?page&sort&search&size',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'user.title'
                    },
                    views: {
                        'content@': 'users'
                    },
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        size: {
                            value: '50',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        },
                        search: null
                    },
                    resolve: {
                        currentAccount: function(Principal){
                            return Principal.identity();
                        },
                        filters: function ($transition$) {
                            return angular.copy($transition$.params());
                        },
                        page: function (CompanyUser, $q, $stateParams) {
                            var deferred = $q.defer();
                            var queryParams = angular.copy($stateParams);
                            queryParams.page -= 1;
                            CompanyUser.query(queryParams, onSuccess, onError);

                            function onSuccess(response, headers) {
                                deferred.resolve({
                                    items: response,
                                    itemsCount: headers('X-Total-Count')
                                });
                            }

                            function onError() {
                                deferred.reject();
                            }

                            return deferred.promise;
                        }
                    }
                });

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .controller('UserDialogController', function ($rootScope, $uibModalInstance, user, CompanyUser) {
            var vm = this;
            vm.authorities = ['ROLE_OWNER', 'ROLE_USER'];
            vm.setPassword = false;
            vm.user = user;

            vm.save = function() {
                if (user.id) {
                    return CompanyUser.update(vm.user).$promise.then(function (result){
                        $rootScope.$broadcast('user:updated');
                        $uibModalInstance.close(result);
                    });
                } else {
                    return CompanyUser.save(vm.user).$promise.then(function (result) {
                        $rootScope.$broadcast('user:updated');
                        $uibModalInstance.close(result);
                    });
                }
            };

            vm.clear = function() {
                $uibModalInstance.dismiss('cancel');
            };
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .directive('isCompanyWorker', function (Principal) {
            return {
                restrict: 'A',
                scope: {
                    customerId: "="
                },
                link: function (scope, element, attrs) {

                    var setVisible = function () {
                            element.removeClass('hidden');
                        },
                        setHidden = function () {
                            element.addClass('hidden');
                        },
                        defineVisibility = function (reset) {

                            if (reset) {
                                setVisible();
                            }

                            Principal.isCompanyWorker(scope.customerId)
                                .then(function (result) {
                                    if (result) {
                                        setVisible();
                                    } else {
                                        setHidden();
                                    }
                                });
                        };

                    defineVisibility(true);

                    scope.$watch(function () {
                        return Principal.isAuthenticated();
                    }, function () {
                        defineVisibility(true);
                    });
                }
            };

        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .factory('CompanyUser', function ($resource) {
            return $resource('api/users/:login:id', {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                'save': {method: 'POST'},
                'update': {method: 'PUT'},
                'delete': {method: 'DELETE'}
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('loginComponent', {
            bindings: {
                returnTo: '<'
            },
            templateUrl: 'app/home/login.html',
            controller: function ($state, Auth) {
                var vm = this;
                this.formData = {
                    rememberMe: true
                };

                var returnToOriginalState = function () {
                    vm.authenticationError = false;
                    var state = vm.returnTo.state();
                    var params = vm.returnTo.params();
                    var options = Object.assign({}, vm.returnTo.options());
                    $state.go(state, params, options);
                };

                this.login = function (event) {
                    event.preventDefault();
                    Auth.login(this.formData)
                        .then(returnToOriginalState)
                        .catch(function () {
                            vm.authenticationError = true;
                        });
                };
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('login', {
                parent: 'app',
                url: '/login',
                views: {
                    'content@': 'loginComponent'
                },
                resolve: {
                    returnTo: function ($transition$) {
                        if ($transition$.redirectedFrom() != null) {
                            // The user was redirected to the login state (e.g., via the requiresAuth hook when trying to activate contacts)
                            // Return to the original attempted target state (e.g., contacts)
                            return $transition$.redirectedFrom().targetState();
                        }
                        var $state = $transition$.router.stateService;

                        // The user was not redirected to the login state; they directly activated the login state somehow.
                        // Return them to the state they came from.
                        if ($transition$.from().name !== '') {
                            return $state.target($transition$.from(), $transition$.params("from"));
                        }

                        // If the fromState's name is empty, then this was the initial transition. Just return them to the home state
                        return $state.target('home');
                    }
                }
            });

        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .component('home', {
            templateUrl: 'app/home/home.html',
            controller: function (Principal) {
                this.hasSlots = Principal.hasSlots;
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: [ 'ROLE_USER' ]
                },
                views: {
                    'content@': 'home'
                }
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('entity', {
                abstract: true,
                parent: 'app'
            });
        });

})();
;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('admin', {
                abstract: true,
                parent: 'app'
            });
        });

})();
;
(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('account', {
                abstract: true,
                parent: 'app'
            });
        });

})();
;
angular.module("awizApp")

.constant("ENV", "prod")

.constant("VERSION", "1.2.7")

;;
(function () {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('app', {
                abstract: true,
                views: {
                    'navbar@': {
                        templateUrl: 'app/layouts/navbar/navbar.html',
                        controller: 'NavbarController',
                        controllerAs: 'vm'
                    },
                    'sidebar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settings');
                        $translatePartialLoader.addPart('slot-management');
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('day-off');
                        $translate.refresh();
                    }
                }
            });
        })
        // .config(function ($stateProvider) {
        //     $stateProvider.decorator('onEnter', function (state, parent) {
        //         // this is original, by configuration created parent
        //         var result = parent(state);
        //         console.log('onEnter');
        //         // we can define where we do not want to change that default, configured
        //         // var skipState = state.name === "home"
        //         //     || state.name === "modala"
        //         //     // child already has that in parent
        //         //     || state.name.indexOf(".") > 0;
        //         //
        //         // // and return taht default
        //         // if (skipState) {
        //         //     return result;
        //         // }
        //         //
        //         // // FINALLY - HERE
        //         // //   we want to change parent, or even introduce new
        //         // state.parent = 'modala';
        //
        //         // and rebuild it
        //         // result = parent(state);
        //
        //         // new parent in place
        //         return result;
        //
        //     });
        // })
        // .config(function ($stateProvider) {
        //
        //     $stateProvider.decorator('parent', function (state, parent) {
        //         // this is original, by configuration created parent
        //         var result = parent(state);
        //
        //         // we can define where we do not want to change that default, configured
        //         var skipState = state.name === "home"
        //             || state.name === "modala"
        //             // child already has that in parent
        //             || state.name.indexOf(".") > 0;
        //
        //         // and return taht default
        //         if (skipState) {
        //             return result;
        //         }
        //
        //         // FINALLY - HERE
        //         //   we want to change parent, or even introduce new
        //         state.parent = 'modala';
        //
        //         // and rebuild it
        //         result = parent(state);
        //
        //         // new parent in place
        //         return result;
        //
        //     });
        // })
        //
        // .config(function ($stateProvider) {
        //     $stateProvider
        //         .state('modala', {
        //             template: '<div>' +
        //                 '<h1>MODALA in play</h1>' +
        //                 '<div ui-view=""></div>' +
        //                 '</div>'
        //         });
        //     }
        // )
    ;

})();
;(function(){'use strict';angular.module('awizApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-sm-8"><my-slots-widget></my-slots-widget></div><div class="col-sm-4"><fast-entries-widget ng-if="$ctrl.hasSlots()"></fast-entries-widget><comments-widget></comments-widget></div></div></div>');
$templateCache.put('app/home/login.html','<div ng-cloak><div class="row"><div class="col-md-offset-4 col-md-4 text-center hidden-xs"><img src="content/images/logo-awisped.png" class="img-responsive img-rounded logo-dashboard" alt="awisped"></div><div class="col-md-offset-4 col-md-4"><div class="row"><div class="col-md-8 col-md-offset-2 text-center"><h4 translate="login.title"></h4></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="$ctrl.authenticationError" translate="login.messages.error.authentication"></div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="$ctrl.login($event)" name="loginForm"><div class="form-group"><label for="username" translate="user.email"></label> <input type="email" class="form-control" id="username" ng-model="$ctrl.formData.username" required focus-element></div><div class="form-group"><label for="password" translate="login.form.password"></label> <input type="password" class="form-control" id="password" ng-model="$ctrl.formData.password" required></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="$ctrl.formData.rememberMe"> <span translate="login.form.remember-me"></span></label></div><button type="submit" class="btn btn-primary" translate="login.form.button" ng-disabled="loginForm.$invalid"></button></form><p></p><div class="alert alert-warning"><a class="alert-link" href ui-sref="requestReset" translate="login.password.forgot"></a></div></div></div></div></div></div>');
$templateCache.put('app/user/user-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" show-validation autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h5 class="modal-title" translate="user.title.dialog"></h5></div><div class="modal-body"><div class="form-group"><div class="form-group input-group-sm required"><label class="control-label" for="email" translate="user.email"></label> <input type="email" class="form-control" name="email" id="email" ng-model="vm.user.email" ng-maxlength="100" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid"></p></div></div></div><div class="row bordered-resource"><div class="col-xs-6"><div class="form-group input-group-sm required"><label class="control-label" for="firstName" translate="user.firstName"></label> <input type="text" class="form-control" name="firstName" id="firstName" ng-model="vm.user.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div><div class="col-xs-6"><div class="form-group input-group-sm required"><label translate="user.lastName" for="lastName"></label> <input type="text" class="form-control" name="lastName" id="lastName" ng-model="vm.user.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div></div><div class="row bordered-resource"><div class="col-xs-6"><div class="form-group"><label translate="user.privileges"></label></div><div class="form-group"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-check fa-fw"></i></span><ol class="nya-bs-select input-group-btn" ng-model="vm.user.roles" actions-box="true" title="-- wybierz --" multiple="multiple" data-selected-text-format="count>2"><li nya-bs-option="s in vm.authorities track by $index"><a><span translate="user.authorities.{{s}}"></span> <span class="check-mark"><i class="fas fa-thumbtack"></i></span></a></li></ol></div></div><div class="form-group"><label for="activated"><input type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="user.activated.true"></span></label></div></div><div class="col-xs-6"><div class="form-group"><label translate="settings.form.language" for="language"></label></div><div class="form-group input-group-sm required"><select class="form-control" id="language" ng-model="vm.user.language"><option value="pl">Polski</option><option value="en">English</option></select></div></div></div><div class="row bordered-resource"><div class="col-xs-12"><div class="form-group" ng-if="!vm.user.id"><label for="sendEmailConfirmation"><input type="checkbox" id="sendEmailConfirmation" ng-model="vm.user.sendEmailConfirmation"> <span translate="user.sendEmailConfirmation"></span></label></div><div class="form-group"><label for="setPassword"><input type="checkbox" id="setPassword" ng-model="vm.setPassword"> <span translate="user.setPassword"></span></label></div><div class="form-group" ng-if="vm.setPassword" ng-class="{ \'required\': vm.setPassword }"><label for="password" translate="user.password"></label></div><div class="input-group input-group-sm" ng-if="vm.setPassword"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i> </span><input type="password" id="password" name="password" ng-model="vm.user.password" class="form-control" ng-disabled="!vm.setPassword" ng-required="vm.setPassword"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/user/user.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ng-click="$ctrl.add()" type="button"><i class="fas fa-plus-circle"></i> <span translate="user.label.add"></span></button></div></div></form></div><table-title title-key="user.label.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" class="hidden-xs" translate="global.field.id"></th><th scope="col" translate="user.email"></th><th scope="col" class="hidden-xs" translate="user.lastName"></th><th scope="col" class="hidden-xs"></th><th scope="col" class="hidden-xs" translate="user.privileges"></th><th scope="col" class="hidden-xs" translate="audit.updatedTime"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="user in $ctrl.page.items track by user.id"><td class="hidden-xs">{{user.id}}</td><td><a href ng-click="$ctrl.edit(user.id)">{{user.email}}</a></td><td class="hidden-xs">{{user.firstName}} {{user.lastName}}</td><td class="hidden-xs"><span class="label" ng-class="{ \'label-success\': user.activated, \'label-danger\': !user.activated }" translate="user.activated.{{user.activated}}" style="cursor: pointer;"></span></td><td class="hidden-xs"><div ng-repeat="authority in user.authorities | orderBy" style="line-height: 1.42857;"><span class="label label-info label-role-{{authority}}">{{ \'user.authorities.\'.concat(authority) | translate }}</span></div></td><td class="hidden-xs">{{user.lastModifiedDate | date:\'yyyy/MM/dd HH:mm\'}}</td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container" ng-if="user.email !== $ctrl.currentAccount.email"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a href ng-click="$ctrl.edit(user.id)"><i class="fas fa-edit fa-fw"></i> <span translate="entity.action.edit"></span></a></li><li class="divider"></li><li><a href ng-click="$ctrl.delete(user)"><i class="far fa-trash-alt trash-clear fa-fw"></i> <span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h5 translate="activate.title"></h5><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile></div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"></div></div></div></div>');
$templateCache.put('app/account/company/company.html','<div class="row"><div class="col-sm-12"><uib-tabset><uib-tab index="0" heading="{{ \'user.organization-info\' | translate }}"><form name="form" role="form" novalidate ng-submit="vm.saveOrganization()" show-validation autocomplete="off" promise-btn><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default"><div class="panel-heading bold" translate="user.organization-info"></div><div class="panel-body"><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="code" translate="customer.code"></label> <input type="text" class="form-control" name="code" id="code" ng-model="vm.item.code" required></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="name" translate="customer.name"></label> <input type="text" class="form-control" name="name" id="name" ng-model="vm.item.name" required></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="address" translate="customer.address"></label> <input type="text" class="form-control" name="address" id="address" ng-model="vm.item.address" required></div></div><div class="col-sm-2"><div class="form-group input-group-sm required"><label class="control-label" for="postcode" translate="customer.postcode"></label> <input type="text" class="form-control" name="postcode" id="postcode" ng-model="vm.item.postcode" required></div></div><div class="col-sm-4"><div class="form-group input-group-sm required"><label class="control-label" for="city" translate="customer.city"></label> <input type="text" class="form-control" name="city" id="city" ng-model="vm.item.city" required></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="taxNo" translate="customer.tax-no"></label> <input type="text" class="form-control" name="taxNo" id="taxNo" ng-model="vm.item.nip"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="registration-no" translate="customer.registration-no"></label> <input type="text" class="form-control" name="registration-no" id="registration-no" ng-model="vm.item.regon"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone1" translate="customer.phone1"></label> <input type="text" class="form-control" name="phone1" id="phone1" ng-model="vm.item.phone1"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone2" translate="customer.phone2"></label> <input type="text" class="form-control" name="phone2" id="phone2" ng-model="vm.item.phone2"></div></div></div></div></div><div class="pull-right"><div class="btn-group-sm"><button type="submit" ng-disabled="form.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></div></form></uib-tab><uib-tab index="1" ng-if="vm.hasSlots()" heading="{{ \'user.organization-settings\' | translate }}" select="vm.loadOrganizationSettings()"><form name="settingsform" role="form" novalidate ng-submit="vm.saveOrganizationSettings()" show-validation autocomplete="off" promise-btn><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default"><div class="panel-heading bold" translate="user.organization-settings"></div><div class="panel-body"><div class="row"><div class="col-sm-12" ng-if="vm.organizationSettings.privacyPolicy"><div class="form-group input-group-sm"><label class="control-label" translate="customer.privacy-policy"></label></div><div class="form-group input-group-sm"><a target="_blank" ng-href="/api/privacy-policy/{{vm.organizationSettings.privacyPolicy.uuid}}" translate="global.click-here">kliknij tutaj</a>&nbsp; {{ \'customer.to-see-privacy-policy\' | translate }}&nbsp; <button class="btn btn-sm btn-default" ng-click="vm.organizationSettings.privacyPolicy = null"><i class="fa fa-trash"></i></button></div></div><div class="col-sm-12" ng-if="!vm.organizationSettings.privacyPolicy"><div class="form-group input-group-sm"><label class="control-label" for="privacyPolicy" translate="customer.privacy-policy"></label> <input type="file" id="privacyPolicy" file-upload></div></div></div></div></div><div class="pull-right"><div class="btn-group-sm"><button type="submit" ng-disabled="settingsform.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></div></form></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h5 translate="password.title" translate-values="{username: \'{{vm.account.email}}\'}"></h5><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch"></div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword"></label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required"></p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength"></p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength"></p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword"></label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required"></p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength"></p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength"></p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h3 translate="register.title"></h3><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"></div><div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail"></div><div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists"></div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists"></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch"></div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" translate="global.form.username"></label> <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[a-z0-9]*$/" required focus-element><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" translate="register.messages.validate.login.required"></p><p class="help-block" ng-show="form.login.$error.minlength" translate="register.messages.validate.login.minlength"></p><p class="help-block" ng-show="form.login.$error.maxlength" translate="register.messages.validate.login.maxlength"></p><p class="help-block" ng-show="form.login.$error.pattern" translate="register.messages.validate.login.pattern"></p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">-</label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required"></p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid"></p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength"></p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength"></p></div></div><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword"></label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required"></p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength"></p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength"></p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword"></label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required"></p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength"></p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength"></p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" translate="global.messages.info.authenticated" translate-compile></div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h5 translate="sessions.title" translate-values="{username: \'{{vm.account.email}}\'}"></h5><div class="alert alert-success" ng-show="vm.success" translate="sessions.messages.success"></div><div class="alert alert-danger" ng-show="vm.error" translate="sessions.messages.error"></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="sessions.table.ipaddress"></th><th translate="sessions.table.useragent"></th><th translate="sessions.table.date"></th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" translate="sessions.table.button"></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<form name="form" role="form" novalidate ng-submit="$ctrl.save()" show-validation autocomplete="off"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default"><div class="panel-heading bold" translate="settings.title"></div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group input-group-sm required"><label class="control-label" for="email" translate="global.form.email"></label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="$ctrl.settingsAccount.email" required disabled="disabled"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required"></p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid"></p></div></div></div><div class="col-md-4"><div class="form-group input-group-sm required"><label class="control-label" for="firstName" translate="settings.form.firstName.field"></label> <input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstName.placeholder\' | translate}}" ng-model="$ctrl.settingsAccount.firstName" required><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstName.required"></p></div></div></div><div class="col-md-4"><div class="form-group input-group-sm required"><label translate="settings.form.lastName.field" for="lastName"></label> <input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastName.placeholder\' | translate}}" ng-model="$ctrl.settingsAccount.lastName" required><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastName.required"></p></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group input-group-sm required"><label translate="settings.form.language" for="language"></label> <select class="form-control" id="language" ng-model="$ctrl.settingsAccount.language"><option value="pl">Polski</option><option value="en">English</option></select></div></div></div></div></div><div class="pull-right"><div class="btn-group-sm"><button type="submit" ng-disabled="form.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></div></form>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title"></h2><div class="row"><div class="col-md-5"><h5 translate="audits.filter.title"></h5><p class="input-group"><span class="input-group-addon" translate="audits.filter.from"></span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to"></span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date"></span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal"></span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status"></span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data"></span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table></div><pagination items-count="vm.totalItems" size="vm.pageSize" page="vm.page"></pagination>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title"></h2><span translate="configuration.filter"></span> <input type="text" ng-model="filter" class="form-control"> <label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix"></span></th><th translate="configuration.table.properties" class="col-sm-8"></th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/customer-management/dialog.html','<form name="invitationForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="user.customer"></h5></div><div class="modal-body"><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-industry fa-fw"></i></div><div class="item-detail-value bold">{{vm.customerAccount.customer.code}}</div><div class="item-detail-label"></div><div class="item-detail-value">{{vm.customerAccount.customer.name}}</div><div class="item-detail-label"></div><div class="item-detail-value">{{vm.customerAccount.customer.address}}</div><div class="item-detail-label"></div><div class="item-detail-value">{{vm.customerAccount.customer.postcode}}&nbsp;{{vm.customerAccount.customer.city}}</div><div class="item-detail-label" translate="customer.tax-no"></div><div class="item-detail-value">{{vm.customerAccount.customer.nip}}</div><div class="item-detail-label" style="font-size: smaller" translate="customer.registration-no"></div><div class="item-detail-value">{{vm.customerAccount.customer.regon}}</div></div><div class="col-sm-6"><div class="bordered-resource" style="padding-bottom: 10px;"><div class="bold" translate="customer.belongs-to-customer"></div><div ng-repeat="customer in vm.customerAccount.parentCustomers"><a href class="bold">{{customer.name}}</a></div><div ng-if="vm.item.parentCustomers.length === 0" translate="select.none"></div></div><div class="bordered-resource" style="padding-top: 10px;"><div class="bold" translate="customer.assigned-forwarders">:</div><div ng-repeat="customer in vm.customerAccount.shippers"><a href class="bold">{{customer.name}}</a></div><div ng-if="vm.item.shippers.length === 0" translate="select.none"></div></div></div></div><div class="row bordered-resource"><div class="col-sm-6"><h5 translate="customer.license"></h5><div class="form-group required"><label class="control-label" for="slots" translate="slot.count"></label><div class="input-group-sm"><input type="number" class="form-control" id="slots" ng-model="vm.customerAccount.customer.slots" required></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="invitationForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/admin/customer-management/list.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ng-click="$ctrl.add()" type="button"><i class="fas fa-plus-circle"></i> <span translate="customer.newAccount.button"></span></button></div></div></form></div><table-title title-key="customer.title.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr jh-sort="$ctrl.filters.predicate" ascending="$ctrl.filters.ascending" callback="$ctrl.submit()"><th scope="col" jh-sort-by="code"><span translate="customer.code"></span></th><th scope="col" class="hidden-xs" jh-sort-by="name"><span translate="customer.name"></span></th><th scope="col" class="hidden-xs" jh-sort-by="address"><span translate="customer.address"></span></th><th scope="col" class="hidden-xs text-center" jh-sort-by="postcode"><span translate="customer.postcode"></span></th><th scope="col" class="hidden-xs" jh-sort-by="city"><span translate="customer.city"></span></th><th scope="col" class="hidden-xs" jh-sort-by="nip"><span translate="customer.tax-no"></span></th><th scope="col" class="hidden-xs text-center" jh-sort-by="slots"><span translate="customer.slots"></span></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a href ng-click="$ctrl.edit(item.id)" class="bold">{{item.code}}</a></td><td class="hidden-xs">{{item.name}}</td><td class="hidden-xs">{{item.address}}</td><td class="hidden-xs text-center">{{item.postcode}}</td><td class="hidden-xs">{{item.city}}</td><td class="hidden-xs">{{item.nip}}</td><td class="text-center">{{item.slots}}</td><td><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu><li><a href ng-click="$ctrl.edit(item.id)"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/admin/customer-management/new-account.html','<form name="invitationForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="customer.newAccount.header"></h5></div><div class="modal-body"><div class=""><div class="panel panel-default"><div class="panel-heading" translate="customer.newAccount.title"></div><div class="panel-body"><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="code" translate="customer.code"></label> <input type="text" class="form-control" name="code" id="code" ng-model="vm.newAccount.code" required></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="name" translate="customer.name"></label> <input type="text" class="form-control" name="name" id="name" ng-model="vm.newAccount.name" required></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="address" translate="customer.address"></label> <input type="text" class="form-control" name="address" id="address" ng-model="vm.newAccount.address" required></div></div><div class="col-sm-2"><div class="form-group input-group-sm required"><label class="control-label" for="postcode" translate="customer.postcode"></label> <input type="text" class="form-control" name="postcode" id="postcode" ng-model="vm.newAccount.postcode" required></div></div><div class="col-sm-4"><div class="form-group input-group-sm required"><label class="control-label" for="city" translate="customer.city"></label> <input type="text" class="form-control" name="city" id="city" ng-model="vm.newAccount.city" required></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="taxNo" translate="customer.tax-no"></label> <input type="text" class="form-control" name="taxNo" id="taxNo" ng-model="vm.newAccount.nip"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="registration-no" translate="customer.registration-no"></label> <input type="text" class="form-control" name="registration-no" id="registration-no" ng-model="vm.newAccount.regon"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone1" translate="customer.phone1"></label> <input type="text" class="form-control" name="phone1" id="phone1" ng-model="vm.newAccount.phone1"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone2" translate="customer.phone2"></label> <input type="text" class="form-control" name="phone2" id="phone2" ng-model="vm.newAccount.phone2"></div></div></div></div></div></div><div class=""><div class="panel panel-default"><div class="panel-heading" translate="customer.newAccount.owner"></div><div class="panel-body"><div class="row"><div class="col-xs-12"><div class="form-group input-group-sm required"><label class="control-label" for="email" translate="user.email"></label> <input type="email" class="form-control" name="email" id="email" ng-model="vm.newAccount.email" ng-maxlength="100" required><div ng-show="form.email.$invalid"><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid"></p></div></div></div><div class="col-xs-6"><div class="form-group input-group-sm required"><label class="control-label" for="firstName" translate="user.firstName"></label> <input type="text" class="form-control" name="firstName" id="firstName" ng-model="vm.newAccount.firstName" ng-maxlength="50" required><div ng-show="form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div><div class="col-xs-6"><div class="form-group input-group-sm required"><label translate="user.lastName" for="lastName"></label> <input type="text" class="form-control" name="lastName" id="lastName" ng-model="vm.newAccount.lastName" ng-maxlength="50" required><div ng-show="form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div><div class="col-xs-6"><div class="form-group"><label translate="settings.form.language" for="language"></label></div><div class="form-group input-group-sm required"><select class="form-control" id="language" ng-model="vm.newAccount.language"><option value="pl">Polski</option><option value="en">English</option></select></div></div><div class="col-xs-12"><div class="form-group"><label for="activated"><input type="checkbox" id="activated" ng-model="vm.newAccount.activated"> <span translate="user.activated.true"></span></label></div></div><div class="col-xs-12"><div class="form-group" ng-if="!vm.user.id"><label for="sendEmailConfirmation"><input type="checkbox" id="sendEmailConfirmation" ng-model="vm.newAccount.sendEmailConfirmation"> <span translate="user.sendEmailConfirmation"></span></label></div><div class="form-group"><label for="setPassword"><input type="checkbox" id="setPassword" ng-model="vm.setPassword"> <span translate="user.setPassword"></span></label></div><div class="form-group" ng-if="vm.setPassword" ng-class="{ \'required\': vm.setPassword }"><label for="password" translate="login.form.password"></label></div><div class="input-group input-group-sm" ng-if="vm.setPassword"><span class="input-group-addon"><i class="fas fa-key fa-fw"></i> </span><input type="password" id="password" name="password" ng-model="vm.newAccount.password" class="form-control" ng-disabled="!vm.setPassword" ng-required="vm.setPassword"></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="invitationForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.send"></span></button></div></form>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h5 translate="health.title"></h5><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button"></span></button></p><table id="healthCheck" class="jh-table table table-bordered"><thead><tr><th class="col-md-7" translate="health.table.service"></th><th class="col-md-2 text-center" translate="health.table.status"></th><th class="col-md-2 text-center" translate="health.details.details"></th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h5 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h5></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h5 translate="health.details.properties"></h5><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name"></th><th class="col-md-6 text-left" translate="health.details.value"></th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h5 translate="health.details.error"></h5><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()" translate="close"></button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title"></h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}"></p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name"></span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level"></span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h5></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-loginas-dialog.html','<form name="deleteForm" ng-submit="vm.confirmLoginAs()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h5 class="modal-title" translate="entity.confirm.title"></h5></div><div class="modal-body"><p><span translate="user.title.sign-in-confirm" translate-values="{ param: vm.user.email }" translate-compile></span></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger">Tak</button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form class="form-inline panel-heading search-panel" autocomplete="off" ng-submit="$ctrl.search"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="input-group input-group-sm"><span class="input-group-addon" translate-attr="{ title: \'user.customer\' }"><i class="fas fa-industry fa-fw"></i></span><select-customer ng-model="$ctrl.filters.customer" ng-change="$ctrl.submit()"></select-customer></div></div></form></div><table-title title-key="user.label.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr jh-sort="$ctrl.filters.predicate" ascending="$ctrl.filters.ascending" callback="$ctrl.submit()"><th scope="col" jh-sort-by="user.firstName" class="hidden-xs"><span translate="user.fullName"></span></th><th scope="col" jh-sort-by="user.email"><span translate="user.email"></span></th><th scope="col" jh-sort-by="customer.name"><span translate="user.organization"></span></th><th scope="col" jh-sort-by="user.activated" class="hidden-xs"><span></span></th><th scope="col" class="hidden-xs"><span translate="user.privileges"></span></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items"><td class="hidden-xs">{{item.user.firstName}} {{item.user.lastName}}</td><td><a href>{{item.user.email}}</a></td><td>{{item.customer.name}}</td><td class="hidden-xs"><span class="label" ng-class="{ \'label-danger\': !item.user.activated, \'label-success\': item.user.activated }" ng-click="$ctrl.setActive(item.user, !item.user.activated)" translate="user.activated.{{item.user.activated}}" style="cursor: pointer;"></span></td><td class="hidden-xs"><div ng-repeat="authority in item.user.authorities | orderBy" style="line-height: 1.42857;"><span class="label label-info label-role-{{authority}}">{{ \'user.authorities.\'.concat(authority) | translate }}</span></div></td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu><li><a href ng-click="$ctrl.logAsUser(item.user)"><i class="fas fa-sign-in-alt"></i> <span translate="login.as"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/day-off/dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" translate="dayOff.dialog.create" ng-if="!vm.item.id"></h5><h5 class="modal-title" translate="dayOff.dialog.edit" ng-if="vm.item.id"></h5></div><div class="modal-body"><div class="row"><div class="col-sm-5"><div class="form-group form-group-label required"><label for="dayOffDate" class="control-label" translate="dayOff.date"></label></div><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-calendar fa-fw"></i></span> <input type="text" id="dayOffDate" name="date" class="form-control" ng-model="vm.item.date" datetimepicker date-model-formatter required options="{ locale: \'pl\', format: \'YYYY-MM-DD\', focusOnShow: false, showTodayButton: true, showClose: true, showClear: true, allowInputToggle: true }"></div></div><div class="col-sm-7"><div class="form-group form-group-label"><label for="dayOffNotes" class="control-label" translate="dayOff.notes"></label></div><textarea id="dayOffNotes" name="notes" class="form-control input-sm" rows="3" ng-model="vm.item.notes" maxlength="255"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/entities/day-off/list.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form class="form-inline panel-heading search-panel" ng-submit="$ctrl.selectYear()" autocomplete="off"><div class="form-group"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="$ctrl.changeYear(-1)" translate-attr="{title: \'dayOff.previousYear\'}"><i class="fas fa-chevron-left"></i></button> </span><input type="number" class="form-control text-center" min="2020" max="2100" ng-model="$ctrl.selectedYear" aria-label="Rok" style="width: 90px;"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="$ctrl.changeYear(1)" translate-attr="{title: \'dayOff.nextYear\'}"><i class="fas fa-chevron-right"></i></button></span></div></div><button class="btn btn-sm btn-default" type="submit" translate="dayOff.showYear"></button> <button class="btn btn-sm btn-primary" type="button" ng-click="$ctrl.importYear()" promise-btn><i class="fas fa-cloud-download-alt"></i> <span translate="dayOff.import"></span></button> <button class="btn btn-sm btn-success" type="button" ng-click="$ctrl.create()"><i class="fas fa-plus-circle"></i> <span translate="dayOff.create"></span></button></form></div><table-title title-key="dayOff.title" table-count="$ctrl.items.length"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" translate="dayOff.date"></th><th scope="col" translate="dayOff.notes"></th><th scope="col"></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.items track by item.id"><td><a href ng-click="$ctrl.edit(item)" class="bold">{{item.date}}</a></td><td>{{item.notes}}</td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a href ng-click="$ctrl.edit(item)"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="$ctrl.delete(item)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.items"></table-loading-spinner><table-no-data items="$ctrl.items"></table-no-data></div>');
$templateCache.put('app/entities/forwarder/invitations-dialog.html','<form name="invitationForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="forwarder.title.invitations"></h5></div><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col"><span translate="forwarder.email"></span></th><th scope="col"><span translate="forwarder.invitation.invitationDate"></span></th><th scope="col"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in vm.invitations track by item.id"><td><a href class="bold">{{item.email}}</a></td><td class="hidden-xs">{{item.invitationDate | amDateFormat : \'YYYY-MM-DD [godz.] HH:mm\'}}</td><td class="hidden-xs"><a ui-sref="forwarderInviteFinish({key: item.invitationKey})" translate="forwarder.invitation.registration-link"></a></td><td class="hidden-xs"><button class="btn btn-sm btn-default" ng-click="vm.sendAgain(item)" promise-btn>{{ \'global.send-again\' | translate }}</button> <button class="btn btn-sm btn-default" ng-click="vm.delete(item)" promise-btn><i class="fa fa-trash"></i></button></td></tr></tbody></table><table-loading-spinner items="vm.invitations"></table-loading-spinner><table-no-data items="vm.invitations"></table-no-data></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button></div></form>');
$templateCache.put('app/entities/forwarder/invite-dialog.html','<form name="invitationForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="forwarder.title.invite"></h5></div><div class="modal-body"><div class="row"><div class="col-xs-12"><p class="help-block" translate="forwarder.invitation.text"></p></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="email" translate="forwarder.invitation.email"></label> <input type="email" class="form-control" name="email" id="email" ng-model="vm.invitation.email" required focus-element><div ng-show="invitationForm.email.$invalid"><p class="help-block" ng-show="invitationForm.email.$error.required" translate="entity.validation.required"></p><p class="help-block" ng-show="invitationForm.email.$error.email" translate="entity.validation.email"></p></div></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label translate="settings.form.language" for="language"></label> <select class="form-control" id="language" ng-model="vm.invitation.language" required><option value="pl">Polski</option><option value="en">English</option></select></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-12"><div class="form-group input-group-md"><label translate="forwarder.invitation.message" for="invitationNotes"></label> <textarea class="form-control input-sm" name="invitationNotes" id="invitationNotes" ng-model="vm.invitation.invitationNotes" rows="9" translate-attr="{ title: \'global.notes\' }"></textarea><p class="help-block" translate="forwarder.invitation.timeLimit"></p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.invitation || invitationForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.send"></span></button></div></form>');
$templateCache.put('app/entities/forwarder/invite-finish.html','<form name="form" role="form" novalidate ng-submit="vm.finishRegistration()" show-validation autocomplete="off"><div class="row" ng-if="vm.item"><div class="col-md-offset-3 col-md-6"><div class="panel panel-default"><div class="panel-heading" translate="forwarder.invitation.finish.title"></div><div class="panel-body"><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="code" translate="customer.code"></label> <input type="text" class="form-control" name="code" id="code" ng-model="vm.item.code" required focus-element></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="name" translate="customer.name"></label> <input type="text" class="form-control" name="name" id="name" ng-model="vm.item.name" required></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="address" translate="customer.address"></label> <input type="text" class="form-control" name="address" id="address" ng-model="vm.item.address" required></div></div><div class="col-sm-2"><div class="form-group input-group-sm required"><label class="control-label" for="postcode" translate="customer.postcode"></label> <input type="text" class="form-control" name="postcode" id="postcode" ng-model="vm.item.postcode" required></div></div><div class="col-sm-4"><div class="form-group input-group-sm required"><label class="control-label" for="city" translate="customer.city"></label> <input type="text" class="form-control" name="city" id="city" ng-model="vm.item.city" required></div></div></div><div class="row"><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="taxNo" translate="customer.tax-no"></label> <input type="text" class="form-control" name="taxNo" id="taxNo" ng-model="vm.item.nip"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="registration-no" translate="customer.registration-no"></label> <input type="text" class="form-control" name="registration-no" id="registration-no" ng-model="vm.item.regon"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone1" translate="customer.phone1"></label> <input type="text" class="form-control" name="phone1" id="phone1" ng-model="vm.item.phone1"></div></div><div class="col-sm-3"><div class="form-group input-group-sm"><label class="control-label" for="phone2" translate="customer.phone2"></label> <input type="text" class="form-control" name="phone2" id="phone2" ng-model="vm.item.phone2"></div></div></div></div></div></div></div><div class="row" ng-if="vm.item"><div class="col-md-offset-3 col-md-6"><div class="panel panel-default"><div class="panel-heading" translate="forwarder.invitation.finish.owner"></div><div class="panel-body"><div class="row"><div class="col-xs-12"><div class="form-group input-group-sm required"><label class="control-label" for="email" translate="user.email"></label> <input type="email" class="form-control" name="email" id="email" ng-model="vm.item.email" ng-maxlength="100" required disabled="disabled"><div ng-show="form.email.$invalid"><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid"></p></div></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="firstName" translate="user.firstName"></label> <input type="text" class="form-control" name="firstName" id="firstName" ng-model="vm.item.firstName" ng-maxlength="50" required><div ng-show="form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label translate="user.lastName" for="lastName"></label> <input type="text" class="form-control" name="lastName" id="lastName" ng-model="vm.item.lastName" ng-maxlength="50" required><div ng-show="form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50"></p></div></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label class="control-label" for="password" translate="global.form.password"></label> <input type="password" class="form-control" id="password" name="password" ng-model="vm.item.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required"></p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength"></p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength"></p></div><password-strength-bar password-to-check="vm.item.password"></password-strength-bar></div><div class="form-group input-group-sm required"><label class="control-label" for="confirmPassword" translate="global.form.re-type-password"></label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required"></p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength"></p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength"></p></div></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><label translate="settings.form.language" for="language"></label> <select class="form-control" id="language" ng-model="vm.item.language" ng-change="vm.refreshLanguage()" required><option value="pl">Polski</option><option value="en">English</option></select></div></div></div></div></div><div class="row"><div class="col-sm-12"><div class="checkbox form-group required"><label><input type="checkbox" ng-model="vm.item.gdpr" required="required"> <span translate="forwarder.invitation.gdpr-agreement"></span> <a ng-href="api/privacy-policy/{{vm.item.privacyPolicy}}" translate="global.more" target="_blank" ng-if="vm.item.privacyPolicy"></a></label></div></div><div class="col-sm-12"><div class="pull-right"><button type="submit" ng-disabled="form.$invalid" class="btn btn-success" translate="entity.action.save"></button></div></div></div></div></div></form>');
$templateCache.put('app/entities/forwarder/list.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><a href ui-sref="forwarder.invite" class="btn btn-success"><i class="fas fa-fw fa-plus-circle"></i> <span translate="forwarder.label.invite"></span></a></div>&nbsp;<div class="btn-group btn-group-sm"><a href ui-sref="forwarder.invitations" class="btn btn-default"><i class="fas fa-fw fa-list"></i> <span translate="forwarder.title.invitations"></span></a></div></div></form></div><table-title title-key="forwarder.title.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr jh-sort="$ctrl.filters.predicate" ascending="$ctrl.filters.ascending" callback="$ctrl.submit()"><th scope="col" jh-sort-by="code"><span translate="forwarder.code"></span></th><th scope="col" class="hidden-xs" jh-sort-by="name"><span translate="forwarder.name"></span></th><th scope="col" class="hidden-xs" jh-sort-by="address"><span translate="forwarder.address"></span></th><th scope="col" class="hidden-xs text-center" jh-sort-by="postcode"><span translate="forwarder.postcode"></span></th><th scope="col" class="hidden-xs" jh-sort-by="city"><span translate="forwarder.city"></span></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a href class="bold">{{item.code}}</a></td><td class="hidden-xs">{{item.name}}</td><td class="hidden-xs">{{item.address}}</td><td class="hidden-xs text-center">{{item.postcode}}</td><td class="hidden-xs">{{item.city}}</td><td class="center"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a href ng-click="$ctrl.delete(item)"><i class="far fa-trash-alt trash-clear fa-fw"></i> <span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/parcel-type/dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" ng-if="vm.item && !vm.item.id" translate="parcelType.label.new"></h5><h5 class="modal-title" ng-if="vm.item && vm.item.id" translate="parcelType.label.edit"></h5></div><div class="modal-body" ng-show="vm.item"><div class="row"><div class="col-sm-6"><div class="input-group-sm required"><label class="control-label" for="name" translate="parcelType.name"></label></div><div class="form-group input-group-sm required"><input type="text" class="form-control" name="name" id="name" ng-model="vm.item.name" required focus-element></div></div><div class="col-sm-6"><div class="input-group-sm required"><label class="control-label" for="processingTimeInMin" translate="parcelType.processingTimeInMin"></label></div><div class="form-group input-group-sm required"><input type="number" class="form-control" name="processingTimeInMin" id="processingTimeInMin" ng-model="vm.item.processingTimeInMin" required></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/entities/parcel-type/list.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ng-click="$ctrl.create()" type="button"><i class="fas fa-plus-circle"></i> <span translate="parcelType.buttons.create"></span></button></div></div></form></div><table-title title-key="parcelType.label.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" translate="parcelType.name"></th><th scope="col" class="text-right" translate="parcelType.processingTimeInMin"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a href ng-click="$ctrl.edit(item)" class="bold">{{item.name}}</a></td><td class="text-right">{{item.processingTimeInMin}} min</td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a href ng-click="$ctrl.edit(item)"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="$ctrl.delete(item)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/slot/dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" ng-if="vm.item && !vm.item.id" translate="slot.label.new"></h5><h5 class="modal-title" ng-if="vm.item && vm.item.id" translate="slot.label.edit"></h5></div><div class="modal-body" ng-show="vm.item"><div class="row"><div class="col-sm-6"><div class="input-group-sm required"><label class="control-label" for="name" translate="slot.name"></label></div><div class="form-group input-group-sm required"><input type="text" class="form-control" name="name" id="name" ng-model="vm.item.name" required focus-element></div><div class="form-group input-group-sm"><input type="checkbox" id="active" ng-model="vm.item.active"> <label for="active" translate="slot.active"></label></div></div><div class="col-sm-6"><div class="input-group-sm required"><label class="control-label" for="warehouse" translate="slot.warehouse"></label></div><div class="form-group input-group-sm"><select-warehouse id="warehouse" ng-model="vm.item.warehouse" required></select-warehouse><div ng-if="vm.item.warehouse"><p class="help-block"><span translate="slot.warehouse-current-time"></span>:&nbsp;{{vm.item.warehouse.timezone}}</p><current-datetime timezone="vm.item.warehouse.timezone"></current-datetime></div></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-12"><div class="form-group input-group-md"><label translate="slot.notes"></label> <textarea class="form-control input-sm" data-ng-model="vm.item.notes" rows="5" title="Uwagi" maxlength="255"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/entities/slot/schedule-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" ng-if="vm.item && !vm.item.id" translate="slot.schedule.new"></h5><h5 class="modal-title" ng-if="vm.item && vm.item.id" translate="slot.schedule.edit"></h5></div><div class="modal-body" ng-show="vm.item"><div class="row"><div class="col-sm-6"><div class="form-group form-group-label required"><label for="startTime" class="control-label" translate="slot.schedule.effective-as-of"></label></div><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-calendar fa-fw"></i> </span><input type="text" id="startTime" name="startTime" class="form-control" ng-model="vm.item.startTime" datetimepicker options="{ locale: \'pl\', format: \'YYYY-MM-DD\', focusOnShow: false, showTodayButton: true, showClose: true, showClear: true, allowInputToggle: true }" ng-required="true" ng-change="vm.calculateEndTime()" date-model-formatter></div></div><div class="col-sm-6"><div class="form-group input-group-md"><label translate="slot.schedule.notes"></label> <textarea class="form-control input-sm" data-ng-model="vm.item.notes" rows="5" translate-attr="{ title: \'global.notes\' }" maxlength="255" focus-element></textarea></div></div></div><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th><div class="form-group form-group-label required"><label class="control-label" translate="slot.schedule.start-day"></label></div></th><th><div class="form-group form-group-label required"><label class="control-label" translate="slot.schedule.end-day"></label></div></th><th><div class="form-group form-group-label required"><label class="control-label" translate="slot.schedule.start-hour"></label></div></th><th><div class="form-group form-group-label required"><label class="control-label" translate="slot.schedule.end-day"></label></div></th><th></th></tr></thead><tbody><tr ng-repeat="p in vm.item.periods"><td><div class="form-group form-group-label input-group-sm"><select class="form-control" ng-model="p.startDay" ng-change="vm.calculateEndTime()" required translate-attr="{ title: \'slot.schedule.start-day\' }"><option value="" translate="select.choose"></option><option ng-repeat="c in vm.dayNames" value="{{c}}">{{\'days.\'.concat(c) | translate}}</option></select></div></td><td><div class="form-group form-group-label input-group-sm"><select class="form-control" ng-model="p.endDay" ng-change="vm.calculateEndTime()" required translate-attr="{ title: \'slot.schedule.end-day\' }"><option value="" translate="select.choose"></option><option ng-repeat="c in vm.dayNames" value="{{c}}">{{\'days.\'.concat(c) | translate}}</option></select></div></td><td><div class="form-group form-group-label input-group-sm"><input type="time" class="form-control" ng-model="p.startHour" required translate-attr="{ title: \'slot.schedule.start-hour\' }" time-model-formatter></div></td><td><div class="form-group form-group-label input-group-sm"><input type="time" class="form-control" ng-model="p.endHour" required translate-attr="{ title: \'slot.schedule.end-hour\' }" time-model-formatter></div></td><td class="text-center"><button type="button" class="btn btn-options" ng-click="vm.removePeriod($index)"><i class="far fa-trash-alt trash-clear"></i></button></td></tr></tbody></table><table-loading-spinner items="vm.item.periods"></table-loading-spinner><table-no-data items="vm.item.periods"></table-no-data></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.addPeriod()"><i class="fas fa-plus-circle"></i>&nbsp; <span translate="slot.schedule.new-range"></span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/entities/slot/schedules.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ui-sref="slotSchedule.create({slotId: $ctrl.slot.id})" type="button"><i class="fas fa-plus-circle"></i> <span translate="slot.schedule.new"></span></button></div></div></form></div><table-title title-key="slot.schedule.table" table-count="$ctrl.slot.name"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" translate="slot.schedule.effective-as-of"></th><th scope="col" translate="slot.schedule.notes"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a ui-sref="slotSchedule.edit({slotId: item.slotId, scheduleId:item.id})" class="bold">{{item.startTime}}</a></td><td>{{item.notes}}</td><td class="text-center"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a href ui-sref="slotSchedule.edit({slotId:item.slotId, scheduleId: item.id})"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li><a href ui-sref="slotSchedule.duplicate({slotId:item.slotId, duplicatedId: item.id})"><i class="fas fa-copy fa-fw"></i><span translate="entity.action.duplicate"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="$ctrl.delete(item)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/slot/select-slot.html','<select class="form-control input-sm select-table-filters" ng-model="modelValue" ng-options="c.id as c.name for c in items" ng-change="setValue(modelValue)"><option value="" translate="select.all"></option></select>');
$templateCache.put('app/entities/slot/slots.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ui-sref="slot.create" type="button"><i class="fas fa-plus-circle"></i> <span translate="slot.buttons.create"></span></button></div></div></form></div><table-title title-key="slot.label.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" translate="slot.name"></th><th scope="col" translate="slot.warehouse"></th><th scope="col" translate="slot.timezone"></th><th scope="col" class="hidden-xs text-center" translate="slot.active"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a href ui-sref="slotSchedule({slotId:item.id})" class="bold">{{item.name}}</a></td><td>{{item.warehouse.name}}</td><td>{{item.timezone}}</td><td class="hidden-xs text-center"><span class="label" ng-class="{true: \'label-success\', false: \'label-danger\'}[item.active]" translate="{{\'entity.boolean.\' + item.active}}"></span></td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a ui-sref="slotSchedule({slotId:item.id})"><i class="fas fa-calendar fa-fw"></i><span translate="slot.schedule.label"></span></a></li><li role="separator" class="divider"></li><li><a ui-sref="slot.edit({id:item.id})"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="$ctrl.delete(item)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/sms/send-dialog.html','<form name="editForm" role="form" ng-submit="vm.submit()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="sms.title.sending"></h5></div><div class="modal-body"><div class="row bordered-resource"><div class="col-sm-12"><div class="form-group required"><label class="control-label" for="phone" translate="sms.phone"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-phone fa-fw"></i> <span translate="sms.phone-prefix"></span> </span><input type="text" class="form-control ng-dirty" id="phone" ng-model="vm.item.phone" required ng-pattern="vm.phonePattern"></div></div><div class="form-group"><span class="help-block" translate="sms.phone-pattern"></span></div><div class="form-group required"><label class="control-label" for="smsMessage" translate="sms.message"></label></div><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-fw fa-comments"></i> </span><textarea translate-attr="{ placeholder: \'sms.write-message\' }" ng-model="vm.item.message" id="smsMessage" class="form-control" rows="5" required focus-element></textarea></div></div></div></div><div class="modal-footer"><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="modal.close"></span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-success"><i class="fas fa-paper-plane"></i> <span translate="entity.action.send"></span></button></div></div></div></form>');
$templateCache.put('app/entities/warehouse/dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" autocomplete="off" show-validation promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" ng-if="vm.item && !vm.item.id" translate="warehouse.labels.add-modal"></h5><h5 class="modal-title" ng-if="vm.item && vm.item.id" translate="warehouse.labels.edit-modal"></h5></div><div class="modal-body"><div class="row"><div class="col-sm-6"><div class="form-group input-group-sm required"><div class="input-group-sm"><label class="control-label" for="name" translate="warehouse.fields.name"></label></div><input type="text" class="form-control" name="name" id="name" ng-model="vm.item.name" required focus-element></div><div class="form-group input-group-sm"><input type="checkbox" id="active" ng-model="vm.item.active"> <label for="active" translate="warehouse.fields.active"></label></div></div><div class="col-sm-6"><div class="form-group input-group-sm required"><div class="input-group-sm"><label class="control-label" for="timezone" translate="warehouse.fields.timezone"></label></div><select id="timezone" class="form-control" timezone-select country="\'PL\'" ng-model="vm.item.timezone" i18n-common="{{ \'timezone.common\' | translate }}" i18n-other="{{ \'timezone.other\' | translate }}" required></select><p class="help-block"><current-datetime timezone="vm.item.timezone"></current-datetime></p></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-6"><p class="help-block" translate="warehouse.fields.address"></p><div class="form-group input-group-sm required"><div class="input-group-sm"><label class="control-label" for="street" translate="warehouse.fields.street"></label></div><input type="text" class="form-control" name="street" id="street" ng-model="vm.item.address.street" required></div><div class="form-group input-group-sm required"><div class="input-group-sm"><label class="control-label" for="postcode" translate="warehouse.fields.postcode"></label></div><input type="text" class="form-control" name="postcode" id="postcode" ng-model="vm.item.address.postcode" required></div><div class="form-group input-group-sm required"><div class="input-group-sm"><label class="control-label" for="city" translate="warehouse.fields.city"></label></div><input type="text" class="form-control" name="city" id="city" ng-model="vm.item.address.city" required></div></div><div class="col-sm-6"><p class="help-block" translate="warehouse.fields.coordinates"></p><div class="form-group input-group-sm"><div class="input-group-sm"><label class="control-label" for="longitude" translate="warehouse.fields.longitude"></label></div><input type="text" class="form-control" name="longitude" id="longitude" ng-model="vm.item.coordinates.longitude"></div><div class="form-group input-group-sm"><div class="input-group-sm"><label class="control-label" for="latitude" translate="warehouse.fields.latitude"></label></div><input type="text" class="form-control" name="latitude" id="latitude" ng-model="vm.item.coordinates.latitude"></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-12"><div class="form-group input-group-md"><label translate="global.notes"></label> <textarea class="form-control input-sm" data-ng-model="vm.item.notes" rows="5" translate-attr="{ title: \'global.title\' }" maxlength="255"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-floppy-disk"></span>&nbsp;<span translate="entity.action.save"></span></button></div></form>');
$templateCache.put('app/entities/warehouse/select-warehouse.html','<select class="form-control input-sm select-table-filters" ng-model="modelValue" ng-options="c as c.name for c in items track by c.id" ng-change="setValue(modelValue)"><option value="" translate="select.choose"></option></select>');
$templateCache.put('app/entities/warehouse/warehouses.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div><div class="form-group"><div class="btn-group btn-group-sm"><button class="btn btn-success" ui-sref="warehouseCreate" type="button"><i class="fas fa-plus-circle"></i> <span translate="warehouse.labels.create"></span></button></div></div></form></div><table-title title-key="warehouse.labels.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col" translate="warehouse.fields.name"></th><th scope="col" translate="warehouse.fields.address"></th><th scope="col" translate="warehouse.fields.timezone"></th><th scope="col" class="hidden-xs text-center" translate="warehouse.fields.active"></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><a ui-sref="warehouse.edit({id:item.id})" class="bold">{{item.name}}</a></td><td><map-link-to-thick address="item.address" coordinates="item.coordinates"></map-link-to-thick>&nbsp;<map-link-to-directions class="pull-right" address="item.address" coordinates="item.coordinates"></map-link-to-directions></td><td>{{item.timezone}}</td><td class="hidden-xs text-center"><span class="label" ng-class="{true: \'label-success\', false: \'label-danger\'}[item.active]" translate="{{\'entity.boolean.\' + item.active}}"></span></td><td class="text-right"><div class="btn-group btn-group-xs flex-btn-group-container"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><ul class="dropdown-menu-right" uib-dropdown-menu aria-labelledby="single-button"><li><a ui-sref="warehouse.edit({id:item.id})"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="$ctrl.delete(item)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/entry-reservation/add.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title"><span translate="entry.title.make-a-reservation"></span> <span style="color: #880000">{{vm.item.startTime | amDateFormat : \'YYYY-MM-DD [godz.] HH:mm\'}} - {{vm.calculatedEndTime | amDateFormat : \'HH:mm\'}} {{vm.item.startTime | amDateFormat : \'z (Z)\'}}</span> <span style="font-size: small;" ng-if="vm.processingTime > 0">(czas trwania: {{vm.processingTime | amdCreate:\'minutes\' | amdFormat: \'h [godz] m [m]\' }})</span></h5></div><div class="modal-body"><div class="row"><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="parcelType" translate="entry.parcel"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-cube fa-fw"></i></span> <select class="form-control" id="parcelType" name="parcelType" ng-model="vm.item.parcelType" ng-change="vm.calculateEndTime()" required ng-options="(c.name + \' (\' + c.processingTimeInMin + \'min)\') for c in vm.parcelTypes track by c.id"><option value="" translate="select.choose"></option></select></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="parcelQuantity" translate="entry.label.parcel-quantity"></label><div class="input-group-sm"><input type="number" min="1" class="form-control" id="parcelQuantity" ng-model="vm.item.parcelQuantity" ng-change="vm.calculateEndTime()" required></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="actionType" translate="entry.action"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-dolly fa-fw"></i></span> <select class="form-control" id="actionType" name="actionType" ng-model="vm.item.actionType" required><option value="" translate="select.choose"></option><option ng-repeat="c in vm.actionTypes" value="{{c}}" translate="entry.actionTypes.{{c}}"></option></select></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group"><label class="control-label" translate="entry.label.status"></label><div class="input-group-sm"><span class="label label-default label-larger label-entry-status-UNCONFIRMED" translate="entry.status.UNCONFIRMED"></span></div></div></div><div class="col-sm-12 col-xs-12 hr-line"></div></div><div class="row"><div class="col-sm-4 col-xs-6"><div class="form-group required" ng-if="vm.shipperSelectable"><label class="control-label" for="shipper" translate="customer.label.forwarder"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-chalkboard-teacher fa-fw"></i></span> <select class="form-control" id="shipper" name="shipper" ng-model="vm.item.shipperId" ng-options="c.id as c.name for c in vm.shippers track by c.id" ng-required="vm.shipperSelectable"><option value="" translate="select.none"></option></select></div></div><div class="form-group"><a href ng-click="vm.setShipper()" ng-if="vm.isSlotOwner && !vm.shipperSelectable" translate="entry.label.assign-forwarder"></a></div><div class="form-group required"><label class="control-label" for="carrierName" translate="entry.carrierName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-shipping-fast fa-fw"></i></span> <input type="text" class="form-control" id="carrierName" ng-model="vm.item.carrierName" required></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverName" translate="entry.vehicle.driverName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-user fa-fw"></i></span> <input type="text" class="form-control" id="driverName" ng-model="vm.item.driverName" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverPhone" translate="entry.vehicle.driverPhone"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-phone fa-fw"></i></span> <input type="text" class="form-control" id="driverPhone" ng-model="vm.item.driverPhone" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group"><label class="control-label" for="driverIdentityCard" translate="entry.vehicle.driverIdentityCard"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-id-card fa-fw"></i></span> <input type="text" class="form-control" id="driverIdentityCard" ng-model="vm.item.driverIdentityCard"></div></div></div><div class="col-sm-4 col-xs-6"><div class="form-group required"><label class="control-label" for="vehicleRegistrationNumber" translate="entry.vehicle.registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-truck fa-fw"></i></span> <input type="text" class="form-control" id="vehicleRegistrationNumber" ng-model="vm.item.vehicleRegistrationNumber" required></div></div><div><label for="trailer" style="cursor: pointer; font-weight: normal;"><input type="checkbox" id="trailer" ng-model="vm.item.trailer" ng-change="vm.onTrailerChange()" class="hidden"> <i ng-if="!vm.item.trailer" class="fas fa-plus-circle fa-fw fa-2x" style="color: green;"></i> <span ng-if="!vm.item.trailer" translate="entry.vehicle.add-trailer"></span> <i ng-if="vm.item.trailer" class="fas fa-minus-circle fa-fw fa-2x" style="color: red;"></i> <span ng-if="vm.item.trailer" translate="entry.vehicle.remove-trailer"></span></label></div><div class="form-group required" ng-if="vm.item.trailer"><label class="control-label" for="trailerRegistrationNumber" translate="entry.vehicle.trailer-registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-trailer fa-fw"></i></span> <input type="text" class="form-control" id="trailerRegistrationNumber" ng-model="vm.item.trailerRegistrationNumber" required></div></div></div><div class="col-sm-4 col-xs-12"><div class="form-group input-group-sm"><label class="control-label" for="trackingNumber" translate="entry.vehicle.tracking-number"></label> <input type="text" class="form-control" id="trackingNumber" ng-model="vm.item.trackingNumber"></div><div class="form-group input-group-sm"><label class="control-label" for="orderNumber" translate="entry.vehicle.order-number"></label> <input type="text" class="form-control" id="orderNumber" ng-model="vm.item.orderNumber"></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-12"><div class="input-group"><label class="control-label" for="comment" translate="entry.comment"></label></div><div class="input-group-sm"><textarea id="comment" class="form-control" ng-model="vm.item.comment" rows="5" translate-attr="{ title: \'entry.comment\' }" maxlength="255"></textarea></div></div></div></div><div class="modal-footer"><div class="pull-left"><div class="form-group required"><label class="control-label" style="color: red;">&nbsp;</label> <span style="padding-left: 10px; color: red; font-weight: bold;">&nbsp;-&nbsp; <span translate="global.form.fields-required"></span></span></div></div><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/entities/entry-reservation/carrier-change.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="entry.title.carrier-edit"></h5></div><div class="modal-body" ng-if="vm.entry"><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-clock fa-fw"></i></div><div class="item-detail-value"><span style="color: #880000;"><period-timezone-format start-time="vm.entry.startTime" end-time="vm.entry.endTime" timezone="vm.entry.slot.timezone"></period-timezone-format></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-tag fa-fw"></i></div><div class="item-detail-value"><span class="label label-default label-entry-status-{{vm.entry.status}}" translate="entry.status.{{vm.entry.status}}"></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-cube fa-fw"></i></div><div class="item-detail-value bold">{{vm.entry.parcelType.name}} ({{vm.entry.parcelType.processingTimeInMin}}min)</div><div class="item-detail-value"><span translate="entry.label.parcel-quantity"></span>&nbsp; <span class="bold">{{vm.entry.parcelQuantity}}</span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-dolly fa-fw"></i></div><div class="item-detail-value"><span translate="entry.actionTypes.{{vm.entry.actionType}}"></span></div></div></div><div class="row bordered-resource"><div class="col-sm-4 col-xs-6"><div class="form-group required"><label class="control-label" for="carrierName" translate="entry.carrierName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-shipping-fast fa-fw"></i></span> <input type="text" class="form-control" id="carrierName" ng-model="vm.item.carrierName" required></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverName" translate="entry.vehicle.driverName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-user fa-fw"></i></span> <input type="text" class="form-control" id="driverName" ng-model="vm.item.driverName" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverPhone" translate="entry.vehicle.driverPhone"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-phone fa-fw"></i></span> <input type="text" class="form-control" id="driverPhone" ng-model="vm.item.driverPhone" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group"><label class="control-label" for="driverIdentityCard" translate="entry.vehicle.driverIdentityCard"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-id-card fa-fw"></i></span> <input type="text" class="form-control" id="driverIdentityCard" ng-model="vm.item.driverIdentityCard"></div></div></div><div class="col-sm-4 col-xs-6"><div class="form-group required"><label class="control-label" for="vehicleRegistrationNumber" translate="entry.vehicle.registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-truck fa-fw"></i></span> <input type="text" class="form-control" id="vehicleRegistrationNumber" ng-model="vm.item.vehicleRegistrationNumber" required></div></div><div><label for="trailer" style="cursor: pointer; font-weight: normal"><input type="checkbox" id="trailer" ng-model="vm.item.trailer" ng-change="vm.onTrailerChange()" class="hidden"> <i ng-if="!vm.item.trailer" class="fas fa-plus-circle fa-fw fa-2x" style="color: green;"></i> <span ng-if="!vm.item.trailer" style="vertical-align: super;" translate="entry.vehicle.add-trailer"></span> <i ng-if="vm.item.trailer" class="fas fa-minus-circle fa-fw fa-2x" style="color: red;"></i> <span ng-if="vm.item.trailer" style="vertical-align: super;" translate="entry.vehicle.remove-trailer"></span></label></div><div class="form-group required" ng-if="vm.item.trailer"><label class="control-label" for="trailerRegistrationNumber" translate="entry.vehicle.trailer-registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-trailer fa-fw"></i></span> <input type="text" class="form-control" id="trailerRegistrationNumber" ng-model="vm.item.trailerRegistrationNumber" required></div></div></div><div class="col-sm-4 col-xs-12"><div class="form-group input-group-sm"><label class="control-label" for="trackingNumber" translate="entry.vehicle.tracking-number"></label> <input type="text" class="form-control" id="trackingNumber" ng-model="vm.item.trackingNumber"></div><div class="form-group input-group-sm"><label class="control-label" for="orderNumber" translate="entry.vehicle.order-number"></label> <input type="text" class="form-control" id="orderNumber" ng-model="vm.item.orderNumber"></div></div></div></div><div class="modal-footer"><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="modal.close"></span></button> <button type="submit" ng-disabled="editForm.$invalid || !vm.canSave()" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/entities/entry-reservation/edit.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title"><span translate="entry.title.make-a-reservation"></span>&nbsp; <span style="color: #880000;"><period-timezone-format start-time="vm.item.startTime" end-time="vm.calculatedEndTime" timezone="vm.item.slot.timezone"></period-timezone-format></span><span style="font-size: small;" ng-if="vm.processingTime > 0">(czas trwania: {{vm.processingTime | amdCreate:\'minutes\' | amdFormat: \'h [godz] m [m]\' }})</span></h5></div><div class="modal-body"><div class="row"><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="parcelType" translate="entry.parcel"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-cube fa-fw"></i></span> <select class="form-control" id="parcelType" name="parcelType" ng-model="vm.item.parcelType" ng-change="vm.calculateEndTime()" required ng-options="(c.name + \' (\' + c.processingTimeInMin + \'min)\') for c in vm.parcelTypes track by c.id"><option value="" translate="select.choose"></option></select></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="parcelQuantity" translate="entry.label.parcel-quantity"></label><div class="input-group-sm"><input type="number" min="1" class="form-control" id="parcelQuantity" ng-model="vm.item.parcelQuantity" ng-change="vm.calculateEndTime()" required></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group required"><label class="control-label" for="actionType" translate="entry.action"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-dolly fa-fw"></i></span> <select class="form-control" id="actionType" name="actionType" ng-model="vm.item.actionType" required><option value="" translate="select.choose"></option><option ng-repeat="c in vm.actionTypes" value="{{c}}" translate="entry.actionTypes.{{c}}"></option></select></div></div></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="form-group"><label class="control-label" translate="entry.label.status"></label><div class="input-group-sm"><span class="label label-default label-larger label-entry-status-UNCONFIRMED" translate="entry.status.UNCONFIRMED"></span></div></div></div><div class="col-sm-12 col-xs-12 hr-line"></div></div><div class="row"><div class="col-sm-4 col-xs-6"><div class="form-group required"><label class="control-label" for="carrierName" translate="entry.carrierName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-shipping-fast fa-fw"></i></span> <input type="text" class="form-control" id="carrierName" ng-model="vm.item.carrierName" required></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverName" translate="entry.vehicle.driverName"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-user fa-fw"></i></span> <input type="text" class="form-control" id="driverName" ng-model="vm.item.driverName" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group" ng-class="{ \'required\': vm.item.actionType === \'LOADING\' }"><label class="control-label" for="driverPhone" translate="entry.vehicle.driverPhone"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-phone fa-fw"></i></span> <input type="text" class="form-control" id="driverPhone" ng-model="vm.item.driverPhone" ng-required="vm.item.actionType === \'LOADING\'"></div></div><div class="form-group"><label class="control-label" for="driverIdentityCard" translate="entry.vehicle.driverIdentityCard"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-id-card fa-fw"></i></span> <input type="text" class="form-control" id="driverIdentityCard" ng-model="vm.item.driverIdentityCard"></div></div></div><div class="col-sm-4 col-xs-6"><div class="form-group required"><label class="control-label" for="vehicleRegistrationNumber" translate="entry.vehicle.registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-truck fa-fw"></i></span> <input type="text" class="form-control" id="vehicleRegistrationNumber" ng-model="vm.item.vehicleRegistrationNumber" required></div></div><div><label for="trailer" style="cursor: pointer; font-weight: normal"><input type="checkbox" id="trailer" ng-model="vm.item.trailer" ng-change="vm.onTrailerChange()" class="hidden"> <i ng-if="!vm.item.trailer" class="fas fa-plus-circle fa-fw fa-2x" style="color: green;"></i> <span ng-if="!vm.item.trailer" translate="entry.vehicle.add-trailer"></span> <i ng-if="vm.item.trailer" class="fas fa-minus-circle fa-fw fa-2x" style="color: red;"></i> <span ng-if="vm.item.trailer" translate="entry.vehicle.remove-trailer"></span></label></div><div class="form-group required" ng-if="vm.item.trailer"><label class="control-label" for="trailerRegistrationNumber" translate="entry.vehicle.trailer-registrationNo"></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-trailer fa-fw"></i></span> <input type="text" class="form-control" id="trailerRegistrationNumber" ng-model="vm.item.trailerRegistrationNumber" required></div></div></div><div class="col-sm-4 col-xs-12"><div class="form-group input-group-sm"><label class="control-label" for="trackingNumber" translate="entry.vehicle.tracking-number"></label> <input type="text" class="form-control" id="trackingNumber" ng-model="vm.item.trackingNumber"></div><div class="form-group input-group-sm"><label class="control-label" for="orderNumber" translate="entry.vehicle.order-number"></label> <input type="text" class="form-control" id="orderNumber" ng-model="vm.item.orderNumber"></div></div></div><div class="row"><div class="col-sm-12 hr-line"></div><div class="col-sm-12"><div class="input-group"><label class="control-label" for="comment" translate="entry.comment"></label></div><div class="input-group-sm"><textarea id="comment" class="form-control" ng-model="vm.item.comment" rows="5" translate-attr="{ title: \'entry.comment\' }" maxlength="255"></textarea></div></div></div></div><div class="modal-footer"><div class="pull-left"><div class="form-group required"><label class="control-label" style="color: red;">&nbsp;</label> <span style="padding-left: 10px; color: red; font-weight: bold;">&nbsp;-&nbsp;<span translate="global.form.fields-required"></span></span></div></div><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="!vm.item || editForm.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/entities/entry-reservation/reservation.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="entry.title.booking-details"></h5></div><div class="modal-body"><div class="row"><div class="panel-loading-spinner" ng-if="!vm.item"><i class="fas fa-spinner fa-spin fa-2x"></i></div><div class="col-sm-6" ng-if="vm.item"><div class="row"><div class="col-sm-6"><span class="small">Magazyn / Slot</span></div></div><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-warehouse fa-fw"></i></div><div class="item-detail-value">{{vm.item.customer.name}}</div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-door-open"></i></div><div class="item-detail-value bold">{{ [vm.item.slot.warehouse.name, vm.item.slot.name] | join:\' / \' }}</div></div><div class="col-sm-offset-6 col-sm-6" ng-if="vm.item.slot.warehouseDetails"><div class="item-detail-label" title="{{ \'entry.label.address\' | translate }}"><i class="fas fa-map-marked-alt"></i></div><div class="item-detail-value"><map-link-to-thick address="vm.item.slot.warehouseDetails.address" coordinates="vm.item.slot.warehouseDetails.coordinates"></map-link-to-thick>&nbsp;<map-link-to-directions address="vm.item.slot.warehouseDetails.address" coordinates="vm.item.slot.warehouseDetails.coordinates"></map-link-to-directions></div></div></div><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fa fa-industry fa-fw"></i></div><div class="item-detail-value">{{vm.item.shipper.name}}</div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-clock fa-fw"></i></div><div class="item-detail-value bold"><span style="color: #880000"><period-timezone-format start-time="vm.item.startTime" end-time="vm.item.endTime" timezone="vm.item.slot.timezone"></period-timezone-format></span></div></div></div><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-cube fa-fw"></i></div><div class="item-detail-value"><span class="small" translate="entry.label.parcel-quantity"></span></div><div class="item-detail-value bold"><span class="bold">{{vm.item.parcelQuantity}}</span>&nbsp;&times;&nbsp;{{vm.item.parcelType.name}}</div><div class="item-detail-value"><span class="small" style="display: inline-block; font-weight: normal;">{{vm.item.parcelQuantity}}&nbsp;&times;&nbsp;{{vm.item.parcelType.processingTimeInMin}}min&nbsp;=&nbsp;{{vm.item.parcelQuantity*vm.item.parcelType.processingTimeInMin}}min</span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-tag fa-fw"></i></div><div class="item-detail-value"><span class="label label-default label-entry-status-{{vm.item.status}}" translate="entry.status.{{vm.item.status}}"></span></div><div class="item-detail-label"><i class="fas fa-dolly fa-fw"></i></div><div class="item-detail-value"><span translate="entry.actionTypes.{{vm.item.actionType}}"></span></div></div></div><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fa fa-shipping-fast fa-fw"></i></div><div class="item-detail-value bold">{{vm.item.carrierName}}</div><div class="item-detail-label" ng-if="vm.item.driverName"><i class="fas fa-user fa-fw"></i></div><div class="item-detail-value" ng-if="vm.item.driverName">{{vm.item.driverName}}</div><div class="item-detail-label" ng-if="vm.item.driverPhone"><i class="fas fa-phone fa-fw"></i></div><div class="item-detail-value" ng-if="vm.item.driverPhone">{{vm.item.driverPhone}}&nbsp; <i class="fas fa-fw fa-sms" has-authority="ROLE_ADMIN" style="color: #f783ac;" ng-click="vm.sendSMS(vm.item.driverPhone)" uib-tooltip="{{ \'sms.send\' | translate }}"></i></div><div class="item-detail-label" ng-if="vm.item.driverIdentityCard"><i class="fas fa-id-card fa-fw"></i></div><div class="item-detail-value" ng-if="vm.item.driverIdentityCard">{{vm.item.driverIdentityCard}}</div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-truck fa-fw"></i></div><div class="item-detail-value bold">{{vm.item.vehicleRegistrationNumber}}</div><div class="item-detail-label" ng-if="vm.item.trailerRegistrationNumber"><i class="fas fa-trailer fa-fw"></i></div><div class="item-detail-value bold">{{vm.item.trailerRegistrationNumber}}</div></div></div><div class="row bordered-resource" ng-if="vm.item.trackingNumber || vm.item.orderNumber"><div class="col-sm-6"><div class="item-detail-label" ng-if="vm.item.trackingNumber"><i class="fas fa-tags fa-fw"></i></div><div class="item-detail-value" ng-if="vm.item.trackingNumber">{{vm.item.trackingNumber}}</div><div class="item-detail-label" ng-if="vm.item.orderNumber"><i class="fas fa-pallet fa-fw"></i></div><div class="item-detail-value" ng-if="vm.item.orderNumber">{{vm.item.orderNumber}}</div></div></div><div class="row bordered-resource" ng-if="vm.item.workStandBy === true"><div class="col-sm-12"><div class="item-detail-label"></div><div class="item-detail-value"><i class="fas fa-fw fa-truck fa-2x work-stand-by-true" style="margin-right: 10px;"></i> <span class="bold" translate="entry.events.work-stand-by.true"></span></div></div></div><div class="row bordered-resource"><div class="col-sm-12"><div class="item-detail-label"><i class="fas fa-id-card"></i></div><div class="item-detail-value"><div style="font-size: smaller;"><span translate="audit.created"></span>&nbsp; <b>{{vm.item.createdDate | date : \'d MMM y HH:mm:ss\'}}</b>&nbsp;</div><div style="font-size: smaller;"><span translate="audit.lastChanged"></span>&nbsp; <b>{{vm.item.modifiedDate | date : \'d MMM y HH:mm:ss\'}}</b>&nbsp;</div></div></div></div></div><div class="col-sm-6"><entry-comments entry-id="vm.item.id" ng-if="vm.item.id"></entry-comments></div></div></div><div class="modal-footer"><div class="pull-right"><div class="btn-group"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.close()"><span translate="modal.close"></span></button></div><div class="btn-group dropup" uib-dropdown keyboard-nav><button type="button" class="btn btn-primary btn-sm" uib-dropdown-toggle><span class="text" translate="entity.action.options"></span> <i class="fa fa-caret-down"></i></button><entry-option-button entry="vm.item"></entry-option-button></div></div></div>');
$templateCache.put('app/entities/entry-reservation/time-change.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="entry.title.time-change"></h5></div><div class="modal-body" ng-if="vm.entry"><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-clock fa-fw"></i></div><div class="item-detail-value"><span style="color: #880000"><period-timezone-format start-time="vm.entry.startTime" end-time="vm.entry.endTime" timezone="vm.entry.slot.timezone"></period-timezone-format></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-tag fa-fw"></i></div><div class="item-detail-value"><span class="label label-default label-entry-status-{{vm.entry.status}}" translate="entry.status.{{vm.entry.status}}"></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-cube fa-fw"></i></div><div class="item-detail-value bold">{{vm.entry.parcelType.name}} ({{vm.entry.parcelType.processingTimeInMin}}min)</div><div class="item-detail-value"><span translate="entry.label.parcel-quantity"></span>&nbsp; <span class="bold">{{vm.entry.parcelQuantity}}</span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-dolly fa-fw"></i></div><div class="item-detail-value"><span translate="entry.actionTypes.{{vm.entry.actionType}}"></span></div></div></div><div class="row bordered-resource"><div class="col-sm-12"><div class="form-group form-group-label required"><label for="startTime" class="control-label" translate="entry.label.start-time"></label></div><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-calendar fa-fw"></i> </span><input type="text" id="startTime" class="form-control" ng-model="vm.item.startTime" datetimepicker options="{ locale: \'pl\', timeZone: vm.entry.slot.timezone, format: \'YYYY-MM-DD HH:mm\', focusOnShow: false, showTodayButton: true, showClose: true, showClear: true, allowInputToggle: true }" ng-required="true" ng-change="vm.calculateEndTime()"> <span class="input-group-addon" id="basic-addon2"><span translate="entry.label.end-time"></span>&nbsp; <span class="bold">{{vm.calculatedEndTime | amTimezone: vm.entry.slot.timezone | amDateFormat : \'HH:mm\'}}</span></span></div></div></div></div><div class="modal-footer"><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="modal.close"></span></button> <button type="submit" ng-disabled="editForm.$invalid || !vm.canSave()" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/components/audit-info/audit-info.html','<div class="pull-left" style="margin-right: 10px;"><span class="glyphicon glyphicon-modal-window" style="font-size: larger;"></span></div><div style="font-size: smaller;"><span translate="audit.created"></span>&nbsp; <b>{{audit.createdTime | date : \'d MMM y HH:mm:ss\'}}</b>&nbsp; <span translate="audit.by"></span>&nbsp; <a href style="font-weight: bolder;">{{audit.createdBy.firstName}}&nbsp;{{audit.createdBy.lastName}}</a></div><div style="font-size: smaller;"><span translate="audit.lastChanged"></span>&nbsp; <b>{{audit.updatedTime | date : \'d MMM y HH:mm:ss\'}}</b>&nbsp; <span translate="audit.by"></span> <a href style="font-weight: bolder;">{{audit.updatedBy.firstName}}&nbsp;{{audit.updatedBy.lastName}}</a></div>');
$templateCache.put('app/components/confirm-dialog/confirm-dialog.html','<form name="confirmForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h5 class="modal-title" ng-bind-html="vm.params.header"></h5></div><div class="modal-body"><p ng-bind-html="vm.params.message"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel"></span></button> <button type="submit" ng-disabled="confirmForm.$invalid || vm.processPromise.$$state.pending" class="btn btn-danger"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span translate="entity.action.confirm"></span></button></div></form>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-offset-2 col-md-8"><h1 translate="error.title"></h1><div class="alert alert-danger" translate="error.403"></div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-offset-2 col-md-8"><h1 translate="error.title"></h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default navbar-fixed-top" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand" href ui-sref="home" ng-click="vm.collapseNavbar()"><img src="content/images/logo-awisped.png" alt="logo-awisped"> <span class="navbar-version">v{{VERSION}} <span style="color:red;">{{ENV}}</span></span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed"><ul class="nav navbar-nav navbar-right"><li has-authority="ROLE_PREVIOUS_ADMINISTRATOR"><a href ng-click="vm.exitUser()" style="color: red;"><i class="fa-fw fas fa-sign-out-alt"></i> <span translate="user.label.exit-user"></span></a></li><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span><i class="fa-fw fas fa-columns"></i> <span translate="home.dashboard"></span></span></a></li><li ui-sref-active="active" has-authority="ROLE_USER" ng-if="vm.hasSlots()"><a ui-sref="forwarder" ng-click="vm.collapseNavbar()"><i class="fa-fw fa fa-industry"></i> <span translate="customer.label.forwarders"></span></a></li><li ng-class="{active: vm.$state.includes(\'entryreservation\')}" uib-dropdown has-authority="ROLE_USER"><a uib-dropdown-toggle href><span><i class="fa-fw fas fa-shipping-fast"></i> <span translate="entry.title.menu"></span> <b class="caret"></b></span></a><ul uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="entryreservation-list" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-tasks"></i> <span translate="entry.title.list-view"></span></a></li><li ui-sref-active="active"><a ui-sref="entryreservation-calendar" ng-click="vm.collapseNavbar()"><i class="fa-fw far fa-calendar-alt"></i> <span translate="entry.title.calendar-view"></span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown ng-if="vm.isAuthenticated()"><a uib-dropdown-toggle href><span><i class="fa-fw fas fa-user-circle"></i> <span class="hidden-sm"><principal-email></principal-email></span><b class="caret"></b></span></a><ul uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-user-circle"></i> <span translate="user.profile"></span></a></li><li ui-sref-active="active" has-authority="ROLE_OWNER"><a ui-sref="company" ng-click="vm.collapseNavbar()"><i class="fa-fw far fa-credit-card"></i> <span translate="user.organization-settings"></span></a></li><li ui-sref-active="active" has-authority="ROLE_OWNER"><a ui-sref="user" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-users-cog"></i> <span translate="user.menu"></span></a></li><li class="divider" role="separator" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER"></li><li class="dropdown-header" style="font-size: x-small;" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER" translate="entry.title.reservation-settings"></li><li ui-sref-active="active" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER"><a ui-sref="warehouse" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-warehouse"></i> <span translate="warehouse.labels.menu"></span></a></li><li ui-sref-active="active" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER"><a ui-sref="slot" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-pallet"></i> <span translate="slot.label.entities"></span></a></li><li ui-sref-active="active" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER"><a ui-sref="dayOff" ng-click="vm.collapseNavbar()"><i class="fa-fw far fa-calendar-times"></i> <span translate="dayOff.menu"></span></a></li><li ui-sref-active="active" ng-if="vm.hasSlots()" has-authority="ROLE_OWNER"><a ui-sref="parcelType" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-box"></i> <span translate="parcelType.label.menu"></span></a></li><li class="divider" role="separator"></li><li ui-sref-active="active"><a ui-sref="password" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-key"></i> <span translate="password.page-title"></span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-cloud"></i> <span translate="sessions.page-title"></span></a></li><li class="divider" role="separator"></li><li ui-sref-active="active"><a href ng-click="vm.logout()"><i class="fa-fw fas fa-sign-out-alt"></i> <span translate="global.menu.account.logout"></span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" uib-dropdown has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href><span><i class="fa-fw fas fa-cogs"></i> <span class="visible-xs-inline" translate="global.menu.admin.main"></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li class="dropdown-header" style="font-size: x-small;" translate="customer.label.management"></li><li ui-sref-active="active"><a ui-sref="customer-management" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-industry"></i> <span translate="customer.title.menu"></span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-users-cog"></i> <span translate="user.menu"></span></a></li><li class="divider" role="separator"></li><li class="dropdown-header" style="font-size: x-small;" translate="global.menu.admin.main"></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-tachometer-alt"></i> <span translate="metrics.title"></span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-heartbeat"></i> <span translate="health.title"></span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-tools"></i> <span translate="configuration.title"></span></a></li><li class="divider" role="separator"></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-bell"></i> <span translate="audits.title"></span></a></li><li class="divider" role="separator"></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-tasks"></i> <span translate="logs.title"></span></a></li><li ng-if="!vm.inProduction" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><i class="fa-fw fas fa-book"></i> <span translate="docs.page-title"></span></a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/sidebar/sidebar.html','');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h5 translate="reset.finish.title"></h5><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info"></p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error"></p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile></p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch"></div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword"></label> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required focus-element><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required"></p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength"></p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength"></p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword"></label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required"></p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength"></p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength"></p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h5 translate="reset.request.title"></h5><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"></div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info"></p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success"></p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email"></label> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required focus-element><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required"></p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid"></p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength"></p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength"></p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/admin/customer-management/select-customer/select-customer.html','<select class="form-control input-sm select-table-filters" ng-model="modelValue" ng-options="c.id as c.name for c in list" ng-change="setValue(modelValue)"><option value="" translate="select.choose"></option></select>');
$templateCache.put('app/entities/forwarder/select-shipper/select-shipper.html','<select class="form-control input-sm select-table-filters" ng-model="modelValue" ng-options="c.id as c.name for c in shippers" ng-change="setValue(modelValue)"><option value="" translate="select.all"></option></select>');
$templateCache.put('app/entities/entry-reservation/entry-comments/entry-comments.html','<div ng-if="comments"><form ng-submit="postComment(item, newComment)" name="commentPost" class="new-comment-header" promise-btn><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-comments"></i> </span><input type="text" translate-attr="{ placeholder: \'comment.label.write-comment\' }" ng-model="newComment.text" class="form-control" ng-if="!showTextareaComment"> <textarea translate-attr="{ placeholder: \'comment.label.write-comment\' }" ng-model="newComment.text" id="entry-comment-input" class="form-control" ng-if="showTextareaComment"></textarea> <span class="input-group-btn" ng-show="!showTextareaComment"><button class="btn btn-success" type="submit" ng-disabled="newComment.text.length === 0"><i class="fas fa-paper-plane"></i></button> <button class="btn btn-default" type="button" translate-attr="{ title: \'comment.label.expand-field\' }" ng-click="showTextareaComment=!showTextareaComment"><i class="fas fa-expand-arrows-alt"></i></button></span></div><div class="input-group input-group-sm pull-right" ng-show="showTextareaComment"><div class="btn-group btn-group-sm"><button class="btn btn-success" type="submit" ng-disabled="newComment.text.length === 0"><i class="fas fa-paper-plane"></i></button> <button class="btn btn-default" type="button" translate-attr="{ title: \'comment.label.compress-field\' }" ng-click="showTextareaComment=!showTextareaComment"><i class="fas fa-compress-arrows-alt"></i></button></div></div><div class="clearfix"></div></form><div class="panel panel-default panel-gray"><div class="panel-body no-padding"><div class="comment-row bordered-resource" ng-repeat="comment in comments track by comment.id"><div class="user-thumb"><ng-letter-avatar charcount="2" data="{{comment.author.firstName + \' \' + comment.author.lastName}}" fontsize="16" height="34" width="34"></ng-letter-avatar></div><div class="resource"><div class="info-block"><span class="author-info">{{comment.author.firstName + \' \' + comment.author.lastName}}</span> <span class="time-info"><span title="{{comment.createdDate | date : \'medium\'}}" am-time-ago="comment.createdDate"></span></span></div><div><span style="white-space: pre-wrap">{{comment.text}}</span></div></div><div class="clearfix"></div></div><div class="panel-no-comments" ng-if="comments.length===0"><span translate="comment.label.no-comments"></span></div></div></div></div><div class="panel-loading-spinner" ng-if="!comments"><i class="fas fa-spinner fa-spin fa-2x"></i></div>');
$templateCache.put('app/entities/entry-reservation/option-button/option-button.html','<ul uib-dropdown-menu class="dropdown-menu-right" role="menu" aria-labelledby="single-button"><li class="dropdown-header" style="font-size: x-small;" translate="entry.label.status-change"></li><li ng-if="isUnconfirmed()" is-company-worker customer-id="entry.customer.id"><a href ng-click="confirm()"><i class="fas fa-play fa-fw" style="color: green;"></i> <span translate="entry.label.status-confirm"></span></a></li><li ng-if="isConfirmed()" is-company-worker customer-id="entry.customer.id"><a href ng-click="backToUnconfirmed()"><i class="fas fa-undo-alt fa-fw" style="color: yellowgreen;"></i> <span translate="entry.label.status-revoke"></span></a></li><li ng-if="isConfirmed()" is-company-worker customer-id="entry.customer.id"><a href ng-click="finish()"><i class="fas fa-stop fa-fw" style="color: #337ab7;"></i> <span translate="entry.label.status-finish"></span></a></li><li ng-if="isFinished() || isCancelled()" is-company-worker customer-id="entry.customer.id"><a href ng-click="backToConfirmed()"><i class="fas fa-play fa-fw" style="color: yellowgreen;"></i> <span translate="entry.label.status-reopen"></span></a></li><li ng-if="isUnconfirmed() || isConfirmed()"><a href ng-click="cancel()"><i class="fas fa-ban fa-fw" style="color: #cc0000;"></i> <span translate="entry.label.status-cancel"></span></a></li><li role="separator" class="divider" ng-if="isUnconfirmed() || isConfirmed()"></li><li class="dropdown-header" style="font-size: x-small;" ng-if="isUnconfirmed() || isConfirmed()" translate="entry.label.modification"></li><li ng-if="isUnconfirmed()"><a href ng-click="edit()"><i class="fas fa-edit fa-fw"></i> <span translate="entity.action.edit"></span></a></li><li ng-if="isUnconfirmed()"><a href ng-click="timeChange()"><i class="fas fa-clock fa-fw"></i> <span translate="entry.label.change-time"></span></a></li><li ng-if="isConfirmed()"><a href ng-click="carrierChange()"><i class="fas fa-shipping-fast fa-fw"></i> <span translate="entry.label.change-carrier"></span></a></li><li role="separator" class="divider" ng-if="isConfirmed() || isReadyForWork()" is-company-worker customer-id="entry.customer.id"></li><li class="dropdown-header" style="font-size: x-small;" ng-if="isConfirmed() || isReadyForWork()" is-company-worker customer-id="entry.customer.id"><span translate="entry.label.readiness"></span></li><li ng-if="isConfirmed() || isReadyForWork()" is-company-worker customer-id="entry.customer.id" translate-attr="{ title: \'entry.label.readiness\' }"><a href class="text-center"><button type="button" class="btn btn-sm btn-options" ng-click="toggleWorkStandBy(false)" title="{{ \'entry.events.work-stand-by.false\' | translate }}"><i class="fab fa-first-order-alt fa-2x work-stand-by-false"></i></button> <button type="button" class="btn btn-sm btn-options" ng-click="toggleWorkStandBy(true)" title="{{ \'entry.events.work-stand-by.true\' | translate }}"><i class="fas fa-truck fa-2x work-stand-by-true"></i></button></a></li></ul>');
$templateCache.put('app/entities/entry-reservation/reservation-calendar/calendar.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off" ng-submit="vm.search()"><div class="form-group"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-check fa-fw"></i></span><ol class="nya-bs-select input-group-btn" ng-model="vm.tableFilters.status" actions-box="true" id="status" translate-attr="{ title: \'select.status\' }" multiple="multiple" data-selected-text-format="count>2" ng-change="vm.search()"><li nya-bs-option="s in vm.reservationStatuses"><a><span class="label label-default label-entry-status-{{s}}" translate="entry.status.{{s}}"></span> <span class="check-mark"><i class="fas fa-thumbtack"></i></span></a></li></ol></div></div><div class="form-group" ng-if="vm.hasSlots()"><div class="input-group input-group-sm"><span class="input-group-addon" title="Spedytor"><i class="fas fa-industry fa-fw"></i></span><select-shipper id="shipper" ng-model="vm.tableFilters.shipper" ng-change="vm.search()" options="{ activityFiltering : false }"></select-shipper></div></div><div class="form-group" ng-if="vm.hasSlots()"><div class="input-group input-group-sm"><span class="input-group-addon" title="Slot"><i class="fa fa-door-open fa-fw"></i></span><select-slot id="slot" ng-model="vm.tableFilters.slot" ng-change="vm.search()"></select-slot></div></div><div class="form-group"><field-search ng-model="vm.tableFilters.search" ng-change="vm.search()"></field-search></div><div class="form-group"><span translate="timezone.name"></span>: {{vm.timezone}}</div></form></div><div><table-filters-switch></table-filters-switch><div class="clearfix"></div></div><div ui-calendar="vm.calendarOptions.calendar" calendar="{{vm.calendarId}}"></div>');
$templateCache.put('app/entities/entry-reservation/reservation-list/list.html','<div class="panel panel-default no-padding-bottom" mobile-filters><form name="searchForm" class="form-inline panel-heading search-panel" autocomplete="off"><div class="form-group"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-check fa-fw"></i></span><ol class="nya-bs-select input-group-btn" ng-model="$ctrl.filters.status" ng-model-options="{ updateOn: \'blur\' }" actions-box="true" id="status" translate-attr="{ title: \'select.status\' }" multiple="multiple" data-selected-text-format="count>2" ng-change="$ctrl.submit()"><li nya-bs-option="s in $ctrl.reservationStatuses"><a><span class="label label-default label-entry-status-{{s}}" translate="entry.status.{{s}}"></span> <span class="check-mark"><i class="fas fa-thumbtack"></i></span></a></li></ol></div></div><div class="form-group" ng-if="$ctrl.hasSlots()"><div class="input-group input-group-sm"><span class="input-group-addon" translate-attr="{ title: \'customer.label.forwarder\' }"><i class="fas fa-industry fa-fw"></i></span><select-shipper id="shipper" ng-model="$ctrl.filters.shipper" ng-change="$ctrl.submit()" options="{ activityFiltering : false }"></select-shipper></div></div><div class="form-group" ng-if="$ctrl.hasSlots()"><div class="input-group input-group-sm"><span class="input-group-addon" translate-attr="{ title: \'slot.label.entity\' }"><i class="fa fa-door-open fa-fw"></i></span><select-slot id="slot" ng-model="$ctrl.filters.slot" ng-change="$ctrl.submit()"></select-slot></div></div><div class="form-group"><select-date-range start="$ctrl.filters.start" end="$ctrl.filters.end" options="{ placeholderKey: \'entry.label.time\' }" on-change="$ctrl.submit()"></select-date-range></div><div class="form-group"><field-search ng-model="$ctrl.filters.search" ng-change="$ctrl.submit()"></field-search></div></form></div><table-title title-key="entry.title.table" table-count="$ctrl.page.itemsCount"></table-title><div class="table-responsive"><table class="jh-table table table-bordered table-no-margin"><thead><tr><th scope="col"><span translate="entry.label.time"></span></th><th scope="col" class="hidden-xs" ng-if="!$ctrl.hasSlots()"><span translate="customer.label.orderer"></span></th><th scope="col" class="hidden-xs" ng-if="$ctrl.hasSlots()"><span translate="customer.label.forwarder"></span></th><th scope="col"><span translate="slot.label.entity"></span></th><th scope="col" class="hidden-xs"><span translate="customer.label.carrier"></span></th><th scope="col" class="hidden-xs"><span translate="entry.parcel"></span></th><th scope="col" class="hidden-xs text-right"><span translate="entry.quantity"></span></th><th scope="col" class="hidden-xs text-center"><span translate="entry.action"></span></th><th scope="col" class="hidden-xs"><span translate="entry.vehicle.registrationNo"></span></th><th scope="col" class="hidden-xs text-center"><span translate="entry.label.status"></span></th><th scope="col"></th></tr></thead><tbody table-invisible-on-loading><tr ng-repeat="item in $ctrl.page.items track by item.id"><td><div class="visible-xs bold"><span ng-if="!$ctrl.hasSlots()">{{item.customer.name}}</span> <span ng-if="$ctrl.hasSlots()">{{item.shipper.name}}</span></div><div><a href class="bold" ng-click="$ctrl.show(item.id)"><period-timezone-format start-time="item.startTime" end-time="item.endTime" timezone="item.slot.timezone"></period-timezone-format></a></div></td><td ng-if="!$ctrl.hasSlots()" class="bold hidden-xs">{{item.customer.name}}</td><td ng-if="$ctrl.hasSlots()" class="bold hidden-xs">{{item.shipper.name}}</td><td>{{item.slot.name}}</td><td class="hidden-xs">{{item.carrierName}}</td><td class="hidden-xs">{{item.parcelType.name}}</td><td class="hidden-xs text-right">{{item.parcelQuantity}}</td><td class="hidden-xs text-center"><span translate="entry.actionTypes.{{item.actionType}}"></span></td><td class="hidden-xs">{{item.vehicleRegistrationNumber}}<span ng-if="item.trailerRegistrationNumber"> / {{item.trailerRegistrationNumber}}</span></td><td class="hidden-xs text-center"><span class="label label-default label-entry-status-{{item.status}}" translate="entry.status.{{item.status}}"></span></td><td class="text-center"><div class="btn-group btn-group-xs"><div uib-dropdown keyboard-nav><button type="button" class="btn btn-options" uib-dropdown-toggle><i class="fas fa-ellipsis-v"></i></button><entry-option-button entry="item"></entry-option-button></div></div></td></tr></tbody></table><table-loading-spinner items="$ctrl.page.items"></table-loading-spinner><table-no-data items="$ctrl.page.items"></table-no-data></div><pagination items-count="$ctrl.page.itemsCount" size="$ctrl.filters.size" page="$ctrl.filters.page"></pagination>');
$templateCache.put('app/entities/entry-reservation/status-change/status-change.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off" promise-btn><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h5 class="modal-title" translate="entry.title.status-change"></h5></div><div class="modal-body" ng-if="vm.entry"><div class="row bordered-resource"><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-clock fa-fw"></i></div><div class="item-detail-value"><span style="color: #880000"><period-timezone-format start-time="vm.entry.startTime" end-time="vm.entry.endTime" timezone="vm.entry.slot.timezone"></period-timezone-format></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-tag fa-fw"></i></div><div class="item-detail-value"><span class="label label-default label-entry-status-{{vm.entry.status}}" translate="entry.status.{{vm.entry.status}}"></span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-cube fa-fw"></i></div><div class="item-detail-value bold">{{vm.entry.parcelType.name}} ({{vm.entry.parcelType.processingTimeInMin}}min)</div><div class="item-detail-value"><span translate="entry.label.parcel-quantity"></span>&nbsp;<span class="bold">{{vm.entry.parcelQuantity}}</span></div></div><div class="col-sm-6"><div class="item-detail-label"><i class="fas fa-dolly fa-fw"></i></div><div class="item-detail-value"><span translate="entry.actionTypes.{{vm.entry.actionType}}"></span></div></div></div><div class="row bordered-resource"><div class="col-sm-12"><div class="form-group required"><label class="control-label" translate="entry.label.reservation-status"></label></div><div class="panel panel-default"><ul class="list-group"><li class="list-group-item" ng-class="{ \'selected\': s === vm.item.status}" ng-repeat="s in vm.getStatuses()" ng-click="vm.setNewStatus(s)"><span class="label label-default label-larger label-entry-status-{{s}}" translate="entry.status.short.{{s}}"></span></li></ul><input type="hidden" ng-model="vm.item.status" required></div></div><div class="col-sm-12"><div class="form-group" ng-class="{ \'required\': vm.isCommentRequired() }"><label class="control-label" translate="entry.comment"></label></div><div class="input-group input-group-sm" ng-class="{ \'required\': vm.isCommentRequired() }"><div class="input-group-addon"><label class="control-label"><i class="fas fa-comments fa-fw"></i></label></div><textarea class="form-control" ng-model="vm.item.comment" rows="5" translate-attr="{ title: \'entry.label.status-change-placeholder\', placeholder: \'entry.label.status-change-placeholder\' }" ng-required="vm.isCommentRequired()"></textarea></div><div class="error-text bold" ng-if="vm.isCommentRequired() && !vm.item.comment"><span translate="entity.validation.field.required-to-save"></span></div></div><div class="col-sm-12" ng-if="vm.canChangeTime()"><div class="checkbox"><label><input type="checkbox" id="trailer" ng-model="vm.item.timeChange" ng-change="vm.onTimeChangeCheckbox()"> <span translate="entry.label.change-time"></span></label></div></div><div class="col-sm-12" ng-if="vm.item.timeChange"><div class="form-group form-group-label required"><label for="startTime" class="control-label" translate="entry.label.start-time"></label></div><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-calendar fa-fw"></i> </span><input type="text" id="startTime" class="form-control" ng-model="vm.item.startTime" datetimepicker options="{ locale: \'pl\', timeZone: vm.entry.slot.timezone, format: \'YYYY-MM-DD HH:mm\', focusOnShow: false, showTodayButton: true, showClose: true, showClear: true, allowInputToggle: true }" ng-required="true" ng-change="vm.calculateEndTime()"> <span class="input-group-addon" id="basic-addon2"><span translate="entry.label.end-time"></span> <span class="bold">{{vm.calculatedEndTime | amTimezone: vm.entry.slot.timezone | amDateFormat : \'HH:mm\'}}</span></span></div></div></div></div><div class="modal-footer"><div class="pull-right"><div class="btn-group-sm"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span translate="modal.close"></span></button> <button type="submit" ng-disabled="(editForm.$invalid) || (vm.item.status === vm.entry.status && !vm.item.timeChange) || (vm.item.timeChange && vm.item.startTime === vm.entry.startTime)" class="btn btn-success"><i class="fas fa-save"></i> <span translate="entity.action.save"></span></button></div></div></div></form>');
$templateCache.put('app/entities/entry-reservation/tv-mode/tv-mode.html','<div ng-cloak><div class="row" ng-if="vm.isAuthenticated()" has-authority="ROLE_USER"><div class="col-sm-{{vm.colsPerSlot}}" ng-repeat="slot in vm.slots"><my-slot slot="slot" default-view="listDay" stick-to-current-day="true" request-params="{ status: \'CONFIRMED\' }"></my-slot></div></div></div>');
$templateCache.put('app/entities/entry-reservation/widget-comments/comments.html','<div class="dashboard-widget"><div class="panel panel-default panel-gray"><div class="panel-heading widget-heading"><div class="widget-title" translate="entry.label.recent-comments"></div><div class="widget-buttons"><button type="button" class="btn btn-sm btn-default" ng-click="reloadData()"><i class="fas fa-sync-alt"></i></button> <button type="button" class="btn btn-sm btn-default" ng-click="previousPage()" ng-disabled="page === 0"><i class="fas fa-caret-left"></i></button> <button type="button" class="btn btn-sm btn-default" ng-click="nextPage()" ng-disabled="isLastPage()"><i class="fas fa-caret-right"></i></button></div><div class="clearfix"></div></div><div class="panel-body no-padding"><div class="comment-row bordered-resource" ng-repeat="comment in items track by comment.id"><div class="user-thumb"><ng-letter-avatar charcount="2" data="{{comment.author.firstName + \' \' + comment.author.lastName}}" fontsize="16" height="34" width="34"></ng-letter-avatar></div><div class="resource"><div class="info-block"><span class="author-info">{{comment.author.firstName + \' \' + comment.author.lastName}}</span> <span class="time-info"><span title="{{comment.createdDate | date : \'medium\'}}" am-time-ago="comment.createdDate"></span></span></div><div><span style="white-space: pre-wrap">{{comment.text}}</span></div><div><a href class="bold" ng-click="show(comment.entry.id)" style="color: green; margin-right: 8px;">{{comment.entry.shipper.name}} </a><a href class="bold" ng-click="show(comment.entry.id)"><period-timezone-format start-time="comment.entry.startTime" end-time="comment.entry.endTime" timezone="comment.entry.slot.timezone"></period-timezone-format></a></div></div><div class="clearfix"></div></div><div class="comment-row panel-loading-spinner" ng-if="!items"><i class="fas fa-spinner fa-spin fa-2x"></i></div><div class="panel-no-comments" ng-if="items && items.length === 0"><span translate="comment.label.no-comments"></span></div></div></div></div>');
$templateCache.put('app/entities/entry-reservation/widget-fast-entries/entries.html','<div class="dashboard-widget"><div class="panel panel-default panel-gray"><div class="panel-heading widget-heading"><div class="widget-title"><span translate="entry.fast-entry.fast-entries-at"></span>&nbsp; {{selectedDate | amDateFormat : \'YYYY-MM-DD\'}}</div><div class="widget-buttons"><button type="button" class="btn btn-sm btn-default" ng-click="reloadData()"><i class="fas fa-sync-alt"></i></button> <button type="button" class="btn btn-sm btn-default" ng-click="previous()"><i class="fas fa-caret-left"></i></button> <button type="button" class="btn btn-sm btn-default" ng-click="next()"><i class="fas fa-caret-right"></i></button></div><div class="clearfix"></div></div><div class="panel-body no-padding"><div class="bordered-resource"><form ng-submit="addFastEntry()"><input class="new-fast-entry" translate-attr="{ placeholder: \'entry.fast-entry.enter-text\' }" ng-model="newEntryContent" ng-disabled="isSaving"></form></div><div class="bordered-resource" ng-repeat="entry in items | filter:doneFilter track by $index"><div class="fast-entry-view" ng-class="{ \'editing\': entry == editedEntry }"><div class="fast-entry-toggle"><input type="checkbox" class="toggle" ng-model="entry.done" translate-attr="{ title: \'entry.fast-entry.finished\' }" ng-change="toggleDone(entry)"></div><label ng-class="{ \'done\': entry.done }" ng-dblclick="edit(entry)">{{entry.content}}</label><div class="fast-entry-actions"><button type="button" class="btn btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" translate-attr="{ title: \'entity.action.options\' }"><i class="fa fa-ellipsis-v"></i> <span class="sr-only" translate="entity.action.options"></span></button><ul class="dropdown-menu dropdown-menu-right"><li title="Edytuj"><a href ng-click="edit(entry)"><i class="fas fa-edit fa-fw"></i><span translate="entity.action.edit"></span></a></li><li role="separator" class="divider" ng-if="!$first && !$last"></li><li class="dropdown-header" style="font-size: x-small;" ng-if="!$first && !$last"><span translate="entry.fast-entry.order-change"></span></li><li title="Przesu\u0144 w g\xF3r\u0119" ng-if="!$first"><a href ng-click="moveUp(entry)"><i class="fas fa-caret-up fa-fw"></i><span translate="entry.fast-entry.up"></span></a></li><li title="Przesu\u0144 w d\xF3\u0142" ng-if="!$last"><a href ng-click="moveDown(entry)"><i class="fas fa-caret-down fa-fw"></i><span translate="entry.fast-entry.down"></span></a></li><li role="separator" class="divider"></li><li><a href ng-click="delete(entry)"><i class="fas fa-trash-alt fa-fw"></i><span translate="entity.action.delete"></span></a></li></ul></div><form ng-submit="saveEdited(editedEntry, \'submit\')"><input class="new-fast-entry" translate-attr="{ placeholder: \'entry.fast-entry.enter-text\' }" ng-blur="saveEdited(editedEntry, \'blur\')" ng-model="editedEntry.content" ng-disabled="isSaving" todo-escape="revertEntry(entry)" todo-focus="entry == editedEntry"></form></div><div class="clearfix"></div></div><div class="bordered-resource" ng-if="items && items.length > 0"><div class="fast-entry-view"><ul class="fast-entry-filters"><li><a href ng-class="{ selected: selectedFilter === \'all\'}" ng-click="changeFilter(\'all\')" translate="entry.fast-entry.all"></a></li><li><a href ng-class="{ selected: !selectedFilter || selectedFilter === \'undone\' }" ng-click="changeFilter(\'undone\')" translate="entry.fast-entry.undone"></a></li><li><a href ng-class="{ selected: selectedFilter === \'done\' }" ng-click="changeFilter(\'done\')" translate="entry.fast-entry.done"></a></li></ul></div><div class="clearfix"></div></div><div class="comment-row panel-loading-spinner" ng-if="!items"><i class="fas fa-spinner fa-spin fa-2x"></i></div><div class="panel-no-comments" ng-if="items && items.length === 0"><span translate="entry.fast-entry.no-data"></span></div></div></div></div>');
$templateCache.put('app/entities/entry-reservation/widget-slots/slots.html','<div class="row center-block"><div ng-class="{ \'col-sm-4\': slots.length >= 3, \'col-sm-6\': slots.length <= 2 }" ng-repeat="s in slots track by s.id"><my-slot slot="s"></my-slot></div><div class="col-sm-12"><div class="panel panel-default panel-gray" ng-if="slots && slots.length === 0"><div class="panel-heading"><div class="bold"><span translate="slot.label.entities"></span></div></div><div class="panel-no-comments"><span translate="slot.label.no-slots"></span></div></div></div></div>');
$templateCache.put('app/entities/entry-reservation/slot/slot.html','<div style="margin-bottom: 30px;"><div class="panel panel-default"><div class="panel-heading"><div class="bold">{{slot.name}} <a href class="bold" style="color: green; margin-right: 8px; margin-left: 8px; font-size: smaller;">{{slot.customer.code}} </a><span class="map-directions pull-right"><map-link-to-directions address="slot.warehouseDetails.address" coordinates="slot.warehouseDetails.coordinates"></map-link-to-directions></span></div><div class="timezone" ng-if="isDifferentTimezone()">{{slot.timezone}}</div></div></div><div ui-calendar="calendarOptions.calendar" calendar="{{calendarId}}"></div></div>');}]);})();